"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7665],{

/***/ 84447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LogoField; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95576);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56225);
/* harmony import */ var _govlaunch_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98973);
/* harmony import */ var _govlaunch_profile_picture__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77876);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90489);







function LogoField(param) {
    var fieldName = param.fieldName, entityName = param.entityName;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_final_form__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, {
        name: fieldName,
        children: function(param) {
            var input = param.input;
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_govlaunch_core__WEBPACK_IMPORTED_MODULE_2__/* .Filestack */ .QZ, {
                options: {
                    accept: "image/*"
                },
                onSuccess: function(param) {
                    var filesUploaded = param.filesUploaded;
                    return input.onChange(filesUploaded[0].url);
                },
                customRender: function(param) {
                    var onPick = param.onPick;
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                                css: {
                                    display: "flex",
                                    justifyContent: "center"
                                },
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_govlaunch_profile_picture__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    xlarge: true,
                                    image: input.value,
                                    name: entityName || "A B"
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
                                css: {
                                    display: entityName ? "flex" : "none",
                                    justifyContent: "center",
                                    marginTop: 10,
                                    marginBottom: 10,
                                    color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__/* .darkGray */ .O5,
                                    textAlign: "center",
                                    fontWeight: "bold",
                                    fontSize: 20
                                },
                                children: entityName
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("div", {
                                css: {
                                    display: "flex",
                                    justifyContent: "center",
                                    marginTop: 16
                                },
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_govlaunch_core__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                                        size: "xsmall",
                                        color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__/* .primary */ .T$,
                                        onClick: onPick,
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            defaultMessage: "Upload",
                                            id: "p4N05H"
                                        })
                                    }),
                                    input.value && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("span", {
                                        css: {
                                            marginLeft: 5
                                        },
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_govlaunch_core__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                                            size: "xsmall",
                                            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__/* .red */ .Q6,
                                            theme: "secondary",
                                            onClick: function() {
                                                return input.onChange(null);
                                            },
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                defaultMessage: "Remove",
                                                id: "G/yZLu"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    });
                }
            });
        }
    });
};


/***/ }),

/***/ 23946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ClipboardIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);




function ClipboardIcon(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: 15,
        height: 17
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
            d: "M14.53 2.19L12.791.466A1.614 1.614 0 0011.656 0H5.893a1.6 1.6 0 00-1.607 1.594v1.593H1.607A1.6 1.6 0 000 4.782v10.625A1.6 1.6 0 001.607 17h7.5a1.6 1.6 0 001.607-1.594v-1.594h2.679A1.6 1.6 0 0015 12.22V3.316c0-.422-.17-.828-.47-1.127zm-2.744-1.111c.094.023.18.071.249.14l1.737 1.722a.526.526 0 01.14.247h-2.126v-2.11zM9.643 15.406c0 .293-.24.531-.536.531h-7.5a.534.534 0 01-.536-.53V4.78c0-.293.24-.531.536-.531h2.679v7.969a1.6 1.6 0 001.607 1.594h3.75v1.593zm4.286-3.187c0 .293-.24.531-.536.531h-7.5a.534.534 0 01-.536-.531V1.594c0-.293.24-.532.536-.532h4.821v2.391c0 .438.362.797.804.797h2.41v7.969z",
            fill: "#0071BB",
            fillRule: "nonzero"
        })
    }));
};


/***/ }),

/***/ 9128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LeftArrowIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);





function LeftArrowIcon(_param) {
    var width = _param.width, height = _param.height, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "width",
        "height"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 33 23",
        width: width,
        height: height
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("path", {
            d: "M10.273 1.009a1.112 1.112 0 0 1 1.587 0 1.12 1.12 0 0 1 0 1.571l-8.047 8.047h26.554c.619 0 1.127.492 1.127 1.111s-.508 1.127-1.127 1.127H3.813l8.047 8.032c.429.444.429 1.159 0 1.587a1.112 1.112 0 0 1-1.587 0L.321 12.532a1.12 1.12 0 0 1 0-1.571l9.952-9.952z",
            fill: "currentColor",
            fillRule: "nonzero"
        })
    }));
};


/***/ }),

/***/ 11444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);




var YoutubeIcon = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: "1em",
        height: "1em",
        viewBox: "0 0 461 327"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
            d: "M365.257.393H95.744C42.866.393 0 43.259 0 96.137v134.728c0 52.878 42.866 95.744 95.744 95.744h269.513c52.878 0 95.744-42.866 95.744-95.744V96.137c0-52.878-42.866-95.744-95.744-95.744zm-64.751 169.663l-126.06 60.123c-3.359 1.602-7.239-.847-7.239-4.568V101.607c0-3.774 3.982-6.22 7.348-4.514l126.06 63.881c3.748 1.899 3.683 7.274-.109 9.082z",
            fill: "#F61C0D",
            fillRule: "nonzero"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (YoutubeIcon);


/***/ }),

/***/ 25807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PlanOfferings; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);


function PlanOfferings(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("ul", {
        css: {
            display: "grid",
            gridRowGap: 5,
            margin: 0,
            padding: 0,
            fontSize: 14,
            listStyle: "none",
            "& > li > strong": {
                fontWeight: 600
            }
        },
        children: children
    });
};


/***/ }),

/***/ 30300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PlanOfferingsBlock; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);


function PlanOfferingsBlock(param) {
    var title = param.title, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("div", {
        css: {
            display: "grid",
            gridRowGap: 10
        },
        children: [
            title && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("h5", {
                css: {
                    color: "#525252",
                    fontWeight: 600,
                    fontSize: 14,
                    margin: 0
                },
                children: title
            }),
            children
        ]
    });
};


/***/ }),

/***/ 20948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ userHasSearchAccess; }
/* harmony export */ });
function userHasSearchAccess(user) {
    if (!user) {
        return false;
    }
    if (user.__typename === "PendingUser" && user.verified) {
        return true;
    }
    if (user.__typename === "GovernmentUser") {
        return true;
    }
    return user.__typename === "VendorUser" && user.company && user.company.plan && user.company.plan.limits && user.company.plan.limits.searchAccess;
};


/***/ }),

/***/ 68471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Website; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95576);
/* harmony import */ var _lib_utils_getHostname__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6044);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19026);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90489);
/* harmony import */ var _components_icons_CompassIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76745);







function Website(param) {
    var url = param.url;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
        css: {
            display: "flex",
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_components_icons_CompassIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                width: 38,
                height: 38
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
                css: {
                    marginLeft: 10
                },
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("span", {
                        css: {
                            fontWeight: 600,
                            fontSize: 14,
                            display: "flex"
                        },
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            defaultMessage: "Website",
                            id: "JkLHGw"
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_1__/* .Anchor */ .ee, {
                        href: url,
                        external: "outside-govlaunch",
                        css: {
                            color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__/* .sealBlue */ .N9,
                            userSelect: "none",
                            fontSize: 14,
                            "&:focus, &:visited": {
                                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__/* .darkGray */ .O5
                            },
                            "&:hover": {
                                color: _govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__/* .darkGray */ .O5,
                                borderBottom: "solid 1px ".concat(_govlaunch_palette__WEBPACK_IMPORTED_MODULE_5__/* .sealBlue */ .N9)
                            }
                        },
                        children: (0,_lib_utils_getHostname__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(url)
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 45742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18125);
/* harmony import */ var _govlaunch_project__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78062);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query Group($slug: String!) {\n    groupBySlug(slug: $slug) {\n      _id\n      slug\n      name\n      about\n      website\n      location\n      membersCount\n      productsCount\n      feedCount\n      viewerIsMember\n      headedByAdmins\n      viewerCanHeadContent\n      awards {\n        _id\n        name\n      }\n      governments {\n        _id\n        name\n        logo\n        slug\n      }\n      vendors {\n        _id\n        name\n        logo\n        slug\n      }\n      tags {\n        _id\n        name\n      }\n      pendingRequests {\n        ... on GovernmentGroupRequest {\n          _id\n          government {\n            _id\n            logo\n            name\n            slug\n            city {\n              _id\n              name\n              country\n              countryName\n            }\n          }\n          createdAt\n        }\n        ... on VendorGroupRequest {\n          _id\n          vendor {\n            _id\n            logo\n            name\n            slug\n          }\n          createdAt\n        }\n      }\n      socialMedia {\n        instagram\n        youtube\n        facebook\n        linkedin\n        twitter\n      }\n      products {\n        _id\n        name\n        logo\n        slug\n        company {\n          _id\n          name\n          slug\n        }\n      }\n      outsideProducts {\n        _id\n        name\n        url\n        logo\n      }\n      newsworthy {\n        title\n        siteName\n        favicon\n        url\n        description\n        addedAt\n      }\n      projectsCount\n      projects(limit: 100, audience: PRIVATE) {\n        items {\n          _id\n          ...ProjectCardFields\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n      projectsFromGovernments(limit: 6) {\n        items {\n          _id\n          ...ProjectCardFields\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n      resources {\n        ... on LinkResource {\n          url\n          title\n          addedAt\n          type\n        }\n        ... on DownloadResource {\n          url\n          title\n          filename\n          addedAt\n          type\n        }\n        ... on TextResource {\n          title\n          body\n          addedAt\n          type\n        }\n      }\n      logo\n      visibility\n      viewerCanRemoveMembers\n      members {\n        items {\n          ... on PendingUser {\n            _id\n            slug\n            firstName\n            fullName\n            avatar\n            jobTitle\n            createdAt\n          }\n          ... on GovernmentUser {\n            _id\n            slug\n            firstName\n            jobTitle\n            fullName\n            avatar\n            title\n            createdAt\n          }\n          ... on VendorUser {\n            _id\n            slug\n            firstName\n            jobTitle\n            fullName\n            avatar\n            title\n            createdAt\n          }\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject(), _govlaunch_project__WEBPACK_IMPORTED_MODULE_1__/* .ProjectCardFieldsFragment */ .SS));


/***/ }),

/***/ 42462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18125);
/* harmony import */ var _lib_queries_fragments_StripePlanFields__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68674);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query StripePlans {\n    stripePlans {\n      ...StripePlanFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject(), _lib_queries_fragments_StripePlanFields__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z));


/***/ }),

/***/ 68674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18125);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment StripePlanFields on StripePlan {\n    name\n    displayName\n    tier\n    recurrency\n    price\n    planId\n    productId\n    viewerIsSubscribed\n    upgradeToPlan {\n      planId\n      name\n    }\n    limits {\n      teamMembers\n      products\n      enrichedProducts\n      groups\n      groupInvitations\n      sharingPage\n      projectsPerMonth\n      productTags\n      searchAccess\n    }\n    changeDetails {\n      prorateCost\n      proratePaymentDueDate\n      firstInvoiceAfterProrateDate\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject()));


/***/ }),

/***/ 27665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ vendor; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./components/auth/Auth.tsx + 1 modules
var Auth = __webpack_require__(27068);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(49550);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/index.ts + 112 modules
var web = __webpack_require__(19026);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/router.js
var next_router = __webpack_require__(22051);
// EXTERNAL MODULE: ./intl/locales.ts
var locales = __webpack_require__(30629);
// EXTERNAL MODULE: ./lib/queries/VendorQuery.ts
var VendorQuery = __webpack_require__(93849);
// EXTERNAL MODULE: ./lib/route/Redirect.tsx
var Redirect = __webpack_require__(47116);
// EXTERNAL MODULE: ./lib/withIntl.tsx + 9 modules
var withIntl = __webpack_require__(21505);
// EXTERNAL MODULE: ./src/components/translation/TranslateTo.tsx
var TranslateTo = __webpack_require__(77766);
// EXTERNAL MODULE: ./src/utils/stringOrFirst.ts
var stringOrFirst = __webpack_require__(39327);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/head.js
var head = __webpack_require__(84217);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(69057);
// EXTERNAL MODULE: ./components/seo/SeoHead.tsx
var SeoHead = __webpack_require__(35692);
;// CONCATENATED MODULE: ./components/seo/VendorPageSeo.tsx





function VendorPageSeo(param) {
    var vendor = param.vendor, tab = param.tab;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SeoHead/* default */.Z, {
                title: getVendorsFormattedTitle(vendor, tab),
                description: getVendorsFormattedDescription(vendor, tab)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        name: "twitter:site",
                        content: "@Govlaunch"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        name: "twitter:image",
                        content: vendor.logo || ""
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        property: "og:image",
                        content: vendor.logo || ""
                    })
                ]
            })
        ]
    });
};
function getVendorsFormattedTitle(vendor, tab) {
    var intl = (0,useIntl/* default */.Z)();
    if (!vendor) {
        return intl.formatMessage({
            defaultMessage: "Local Government Innovation Vendors",
            id: "wVOwCh"
        });
    }
    switch(tab){
        case "connect":
            return intl.formatMessage({
                defaultMessage: "{vendor} – Govlaunch Vendors Activity",
                id: "Q3O9kI"
            }, {
                vendor: vendor.name
            });
        case "projects":
            return intl.formatMessage({
                defaultMessage: "{vendor} – Govlaunch Vendors Projects",
                id: "3tBCiM"
            }, {
                vendor: vendor.name
            });
        case "products":
            return intl.formatMessage({
                defaultMessage: "{vendor} – Govlaunch Vendors Products",
                id: "Ywzgi7"
            }, {
                vendor: vendor.name
            });
        case "stories":
            return intl.formatMessage({
                defaultMessage: "{vendor} – Govlaunch Vendors Stories",
                id: "kmCoYJ"
            }, {
                vendor: vendor.name
            });
        case "profile":
            return intl.formatMessage({
                defaultMessage: "{vendor} – Govlaunch Vendors Profile",
                id: "5AXz/X"
            }, {
                vendor: vendor.name
            });
        case "highlights":
            return intl.formatMessage({
                defaultMessage: "{vendor} – Govlaunch Vendors Highlights",
                id: "fHhJiZ"
            }, {
                vendor: vendor.name
            });
        case "invite-governments":
            return intl.formatMessage({
                defaultMessage: "{vendor} – Govlaunch Vendors Invite Governments",
                id: "+bGLP+"
            }, {
                vendor: vendor.name
            });
        case "governments":
            return intl.formatMessage({
                defaultMessage: "{vendor} – Govlaunch Vendors Governments",
                id: "BYPA2c"
            }, {
                vendor: vendor.name
            });
        case "groups":
            return intl.formatMessage({
                defaultMessage: "{vendor} – Govlaunch Vendors Groups",
                id: "O/Wpnw"
            }, {
                vendor: vendor.name
            });
        case "new-group":
            return intl.formatMessage({
                defaultMessage: "{vendor} – Govlaunch Vendors New Group",
                id: "yuAZUY"
            }, {
                vendor: vendor.name
            });
        case "actions":
            return intl.formatMessage({
                defaultMessage: "{vendor} – Govlaunch Vendors Actions",
                id: "LyFkLn"
            }, {
                vendor: vendor.name
            });
        case "sharing":
            return intl.formatMessage({
                defaultMessage: "{vendor} – Govlaunch Vendors Sharing",
                id: "ce2a0N"
            }, {
                vendor: vendor.name
            });
        case "account":
            return intl.formatMessage({
                defaultMessage: "{vendor} – Govlaunch Vendors Account",
                id: "CWT6kP"
            }, {
                vendor: vendor.name
            });
        case "edit-vendor":
            return intl.formatMessage({
                defaultMessage: "{vendor} – Govlaunch Vendors Edit Profile",
                id: "AhNEBK"
            }, {
                vendor: vendor.name
            });
        case "team":
            return intl.formatMessage({
                defaultMessage: "{vendor} – Govlaunch Vendors Team",
                id: "SnxRLW"
            }, {
                vendor: vendor.name
            });
        case "preview":
            return intl.formatMessage({
                defaultMessage: "{vendor} – Govlaunch Vendors Preview Profile",
                id: "Vt18JJ"
            }, {
                vendor: vendor.name
            });
        default:
            return intl.formatMessage({
                defaultMessage: "{vendor} – Govlaunch Vendors",
                id: "frSpNA"
            }, {
                vendor: vendor.name
            });
    }
}
function getVendorsFormattedDescription(vendor, tab) {
    var intl = (0,useIntl/* default */.Z)();
    if (!vendor) {
        return intl.formatMessage({
            defaultMessage: "Local Government Innovation Vendors",
            id: "wVOwCh"
        });
    }
    switch(tab){
        case "projects":
            return intl.formatMessage({
                defaultMessage: "Discover {vendor} - Projects on Govlaunch. Search {vendor} government technology solutions and innovation projects.",
                id: "FgmnC5"
            }, {
                vendor: vendor.name
            });
        case "products":
            return intl.formatMessage({
                defaultMessage: "Discover {vendor} - Products on Govlaunch. Search {vendor} government technology solutions and innovation projects.",
                id: "p0+jIr"
            }, {
                vendor: vendor.name
            });
        case "stories":
            return intl.formatMessage({
                defaultMessage: "Discover {vendor} - Stories on Govlaunch. Search {vendor} government technology solutions and innovation projects.",
                id: "Xaekkg"
            }, {
                vendor: vendor.name
            });
        case "profile":
            return intl.formatMessage({
                defaultMessage: "Discover {vendor} - Profile on Govlaunch. Search {vendor} government technology solutions and innovation projects.",
                id: "tn1y53"
            }, {
                vendor: vendor.name
            });
        case "governments":
            return intl.formatMessage({
                defaultMessage: "Discover {vendor} - Governments on Govlaunch. Search {vendor} government technology solutions and innovation projects.",
                id: "6FL800"
            }, {
                vendor: vendor.name
            });
        case "highlights":
            return intl.formatMessage({
                defaultMessage: "Discover {vendor} - Highlights on Govlaunch. Search {vendor} government technology solutions and innovation projects.",
                id: "5lk84w"
            }, {
                vendor: vendor.name
            });
        default:
            return intl.formatMessage({
                defaultMessage: "Discover {vendor} on Govlaunch. Search {vendor} government technology solutions and innovation projects.",
                id: "ghP/h/"
            }, {
                vendor: vendor.name
            });
    }
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+core@0.21.2_iyni55cf3gelv6eahxhjaprhn4/node_modules/@govlaunch/core/index.js + 20 modules
var core = __webpack_require__(98973);
// EXTERNAL MODULE: ./types/types.ts
var types = __webpack_require__(43845);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+palette@0.4.0/node_modules/@govlaunch/palette/index.js
var palette = __webpack_require__(95576);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(90489);
// EXTERNAL MODULE: ./components/mediaQueries.ts
var mediaQueries = __webpack_require__(92418);
;// CONCATENATED MODULE: ./components/makers/AreYouSure.tsx






function AreYouSure(param) {
    var onConfirm = param.onConfirm, onCancel = param.onCancel;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            display: "grid",
            gridRowGap: 20,
            padding: 20,
            backgroundColor: palette/* white */.ix,
            border: "solid 1px ".concat(palette/* lightestGray */.v2),
            borderRadius: 4
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "grid",
                    gridRowGap: 4
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                        css: {
                            margin: 0
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Are you sure?",
                            id: "2oCaym"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                        css: {
                            margin: 0,
                            color: palette/* mediumGray */.rF,
                            fontSize: 14,
                            lineHeight: 1.33
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "WARNING: By downgrading your account, you will no longer have access to the following features:",
                            id: "inGgC8"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                css: {
                    color: palette/* red */.Q6
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Enhanced product profiles",
                            id: "zgVDfq"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Increased visibility for your products across our platform",
                            id: "x+uUzO"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Team access",
                            id: "mBumrs"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Custom branded discussion groups",
                            id: "SvUL59"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Access to community discussions",
                            id: "tTYN1/"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Customizable public share page",
                            id: "+PonEv"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: (0,mediaQueries/* default */.Z)({
                    justifyContent: "center",
                    display: "grid",
                    gridTemplateColumns: [
                        "1fr",
                        "1fr",
                        "1fr",
                        "1fr 1fr"
                    ],
                    gridColumnGap: 20,
                    gridRowGap: 20
                }),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                        color: palette/* innovatorBlue */.LD,
                        onClick: onConfirm,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Yes, proceed",
                            id: "mti4GD"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                        color: palette/* darkGray */.O5,
                        theme: "secondary",
                        onClick: onCancel,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Cancel",
                            id: "47FYwb"
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(17440);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.5.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(18125);
// EXTERNAL MODULE: ./lib/queries/fragments/CompanySubscription.ts
var CompanySubscription = __webpack_require__(77438);
// EXTERNAL MODULE: ./lib/queries/fragments/StripeChargeFields.ts
var StripeChargeFields = __webpack_require__(11115);
;// CONCATENATED MODULE: ./lib/mutations/CancelSubscription.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CancelSubscription {\n    cancelSubscription {\n      ...CompanySubscription\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ var CancelSubscription = ((0,lib/* gql */.Ps)(_templateObject(), CompanySubscription/* default */.Z, StripeChargeFields/* default */.Z));

// EXTERNAL MODULE: ./lib/queries/fragments/StripePlanFields.ts
var StripePlanFields = __webpack_require__(68674);
;// CONCATENATED MODULE: ./lib/mutations/ChangeSubscriptionPlan.ts

function ChangeSubscriptionPlan_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ChangeSubscriptionPlan($stripePlanId: String!) {\n    changeSubscriptionPlan(stripePlanId: $stripePlanId) {\n      stripePlan {\n        ...StripePlanFields\n      }\n      ...CompanySubscription\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    ChangeSubscriptionPlan_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




/* harmony default export */ var ChangeSubscriptionPlan = ((0,lib/* gql */.Ps)(ChangeSubscriptionPlan_templateObject(), CompanySubscription/* default */.Z, StripeChargeFields/* default */.Z, StripePlanFields/* default */.Z));

// EXTERNAL MODULE: ./lib/apollo/RefetchQueriesFixLink.ts
var RefetchQueriesFixLink = __webpack_require__(69086);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/components/Mutation.js
var Mutation = __webpack_require__(82280);
;// CONCATENATED MODULE: ./components/makers/ChangePlansMutations.tsx








function ChangePlansMutations(param) {
    var children = param.children;
    var selfie = (0,Auth/* useSelfie */.yD)();
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
        mutation: ChangeSubscriptionPlan,
        onCompleted: function() {
            if (selfie && selfie.__typename === "VendorUser" && selfie.company) {
                router.push("/vendors/[vendorSlug]/[[...content]]", "/vendors/".concat(selfie.company.slug, "/account"));
            }
        },
        refetchQueries: (0,RefetchQueriesFixLink/* refetchQueries */.h)([
            "Vendor",
            "CompanyAccountBillingInfo",
            "Plans"
        ]),
        children: function(changeSubscriptionPlan, param) {
            var isChangingPlans = param.loading, failedToCommitPlanChange = param.error;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                mutation: CancelSubscription,
                refetchQueries: (0,RefetchQueriesFixLink/* refetchQueries */.h)([
                    "CompanyAccountBillingInfo",
                    "Vendor",
                    "Plans"
                ]),
                children: function(cancelSubscription, param) {
                    var isCancellingSubscription = param.loading, failedToCancelSubscription = param.error, cancelSubscriptionMutationResult = param.data;
                    return children({
                        changeSubscriptionPlan: changeSubscriptionPlan,
                        isChangingPlans: isChangingPlans,
                        failedToCommitPlanChange: failedToCommitPlanChange,
                        cancelSubscription: cancelSubscription,
                        isCancellingSubscription: isCancellingSubscription,
                        cancelSubscriptionMutationResult: cancelSubscriptionMutationResult,
                        failedToCancelSubscription: failedToCancelSubscription
                    });
                }
            });
        }
    });
};

// EXTERNAL MODULE: ./src/shared/components/IntlDateTime.tsx
var IntlDateTime = __webpack_require__(50544);
// EXTERNAL MODULE: ./components/makers/PlanOfferingsBlock.tsx
var PlanOfferingsBlock = __webpack_require__(30300);
// EXTERNAL MODULE: ./components/makers/PlanOfferings.tsx
var PlanOfferings = __webpack_require__(25807);
;// CONCATENATED MODULE: ./components/makers/Emojis.tsx


var CheckEmoji = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
    css: {
        marginRight: 2
    },
    children: "✅"
});
var StarEmoji = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
    css: {
        marginRight: 2
    },
    children: "⭐️"
});

// EXTERNAL MODULE: ./lib/utils/strongify.tsx
var strongify = __webpack_require__(11135);
;// CONCATENATED MODULE: ./components/makers/FromPlanOption.tsx









function FromPlanOption(param) {
    var fromPlan = param.fromPlan;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            padding: 20,
            border: "solid 1px ".concat(palette/* lightestGray */.v2),
            borderRadius: 4
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: {
                display: "grid",
                gridRowGap: 12
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                    css: {
                        color: "#797979",
                        fontWeight: "bold",
                        fontSize: 16,
                        fontStyle: "italic",
                        textTransform: "uppercase"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Current Plan",
                        id: "Z3GpJF"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                    css: {
                        margin: 0,
                        fontSize: 24,
                        color: "#4a4a4a"
                    },
                    children: fromPlan.displayName
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("h3", {
                    css: {
                        margin: 0,
                        color: "#797979",
                        fontWeight: "bold",
                        fontSize: 24
                    },
                    children: [
                        "$",
                        fromPlan.recurrency === types/* IPlanRecurrency.Yearly */.oO.Yearly ? (fromPlan.price / 100 / 12).toFixed(2) : (fromPlan.price / 100).toFixed(2),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                            css: {
                                fontSize: 24,
                                fontWeight: "normal",
                                color: "#9f9f9f"
                            },
                            children: [
                                "/",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "month",
                                    id: "Cu3Cty"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: {
                        padding: "10px 0px"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlanOfferingsBlock/* default */.Z, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PlanOfferings/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                    children: [
                                        CheckEmoji,
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Enhanced profiles for <strong>{count} products</strong>",
                                            id: "oQg1FL",
                                            values: {
                                                count: fromPlan.limits.enrichedProducts,
                                                strong: function(chunk) {
                                                    return (0,strongify/* default */.Z)(chunk);
                                                }
                                            }
                                        })
                                    ]
                                }),
                                fromPlan.limits.productTags > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                    children: [
                                        CheckEmoji,
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Up to <strong>{chunk} category tags</strong> per product",
                                            id: "DQ/iww",
                                            values: {
                                                chunk: "".concat(fromPlan.limits.productTags),
                                                strong: function(chunk) {
                                                    return (0,strongify/* default */.Z)(chunk);
                                                }
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                    children: [
                                        CheckEmoji,
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Enhanced vendor profile",
                                            id: "ervosm"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                    children: [
                                        CheckEmoji,
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Team access for <strong>{count} users</strong>",
                                            id: "Uj5Y7y",
                                            values: {
                                                count: fromPlan.limits.teamMembers,
                                                strong: function(chunk) {
                                                    return (0,strongify/* default */.Z)(chunk);
                                                }
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                    children: [
                                        CheckEmoji,
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Add up to <strong>{projectsPerMonth}</strong> new {projectsPerMonth, plural, one {project} other {projects}} per month",
                                            id: "SkEF2S",
                                            values: {
                                                projectsPerMonth: fromPlan.limits.projectsPerMonth,
                                                strong: function(chunk) {
                                                    return (0,strongify/* default */.Z)(chunk);
                                                }
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                    children: [
                                        CheckEmoji,
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "<strong>{count}</strong>custom branded discussion groups",
                                            id: "hFfG9q",
                                            values: {
                                                count: fromPlan.limits.groups,
                                                strong: function(chunk) {
                                                    return (0,strongify/* default */.Z)(chunk);
                                                }
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                    children: [
                                        CheckEmoji,
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Access up to <strong>{count}</strong> community discussion groups",
                                            id: "gpQvpj",
                                            values: {
                                                count: fromPlan.limits.groupInvitations,
                                                strong: function(chunk) {
                                                    return (0,strongify/* default */.Z)(chunk);
                                                }
                                            }
                                        })
                                    ]
                                }),
                                fromPlan.limits.searchAccess && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                    children: [
                                        CheckEmoji,
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                            children: [
                                                CheckEmoji,
                                                " ",
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "View other <strong>product profiles</strong>",
                                                    id: "S0q+nj",
                                                    values: {
                                                        strong: function(chunk) {
                                                            return (0,strongify/* default */.Z)(chunk);
                                                        }
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                fromPlan.limits.searchAccess && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                    children: [
                                        CheckEmoji,
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Search for other vendor & products",
                                            id: "vEUFjJ"
                                        })
                                    ]
                                }),
                                fromPlan.limits.searchAccess && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                    children: [
                                        CheckEmoji,
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Suggest products to add to Govlaunch",
                                            id: "MV9qNV"
                                        })
                                    ]
                                }),
                                fromPlan.limits.sharingPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                    children: [
                                        StarEmoji,
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Customizable public sharing hub",
                                            id: "eTjaNG"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/makers/ToBasicPlanOption.tsx








function ToBasicPlanOption() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            padding: 20,
            border: "solid 1px ".concat(palette/* lightestGray */.v2),
            borderRadius: 4
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: {
                display: "grid",
                gridRowGap: 12
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                    css: {
                        fontSize: 16,
                        fontWeight: "bold",
                        color: palette/* innovatorBlue */.LD,
                        fontStyle: "italic",
                        textTransform: "uppercase"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "New Plan",
                        id: "U2j/jE"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                    css: {
                        margin: 0,
                        fontSize: 24,
                        color: "#4a4a4a"
                    },
                    children: "Basic"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("h3", {
                    css: {
                        margin: 0,
                        color: "#797979",
                        fontWeight: "bold",
                        fontSize: 24
                    },
                    children: [
                        "$0",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                            css: {
                                fontSize: 24,
                                fontWeight: "normal",
                                color: "#9f9f9f"
                            },
                            children: [
                                "/",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "month",
                                    id: "Cu3Cty"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: {
                        padding: "10px 0px"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlanOfferingsBlock/* default */.Z, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PlanOfferings/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                    children: [
                                        CheckEmoji,
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Basic product profiles",
                                            id: "AcV6wk"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                    children: [
                                        CheckEmoji,
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Up to <strong>{chunk}</strong> per product",
                                            id: "oiRzjp",
                                            values: {
                                                chunk: "1 category tag",
                                                strong: function(chunk) {
                                                    return (0,strongify/* default */.Z)(chunk);
                                                }
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                    children: [
                                        CheckEmoji,
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Basic vendor profile",
                                            id: "Aw7JHD"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                    children: [
                                        CheckEmoji,
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Up to <strong>{teamMembers}</strong> team member",
                                            id: "So4cAG",
                                            values: {
                                                teamMembers: 1,
                                                strong: function(chunk) {
                                                    return (0,strongify/* default */.Z)(chunk);
                                                }
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/makers/ToPlanOption.tsx









function ToPlanOption(param) {
    var toPlan = param.toPlan;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            padding: 20,
            border: "solid 1px ".concat(palette/* lightestGray */.v2),
            borderRadius: 4
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: {
                display: "grid",
                gridRowGap: 12
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                    css: {
                        color: palette/* innovatorBlue */.LD,
                        fontWeight: "bold",
                        fontSize: 16,
                        fontStyle: "italic",
                        textTransform: "uppercase"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "New Plan",
                        id: "U2j/jE"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                    css: {
                        margin: 0,
                        fontSize: 24,
                        color: "#4a4a4a"
                    },
                    children: toPlan.displayName
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("h3", {
                    css: {
                        margin: 0,
                        color: "#797979",
                        fontWeight: "bold",
                        fontSize: 24
                    },
                    children: [
                        "$",
                        toPlan.recurrency === types/* IPlanRecurrency.Yearly */.oO.Yearly ? (toPlan.price / 100 / 12).toFixed(2) : (toPlan.price / 100).toFixed(2),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                            css: {
                                fontSize: 24,
                                fontWeight: "normal",
                                color: "#9f9f9f"
                            },
                            children: [
                                "/",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "month",
                                    id: "Cu3Cty"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: {
                        padding: "10px 0px"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlanOfferingsBlock/* default */.Z, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PlanOfferings/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                    children: [
                                        CheckEmoji,
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Enhanced profiles for <strong>{count} products</strong>",
                                            id: "oQg1FL",
                                            values: {
                                                count: toPlan.limits.enrichedProducts,
                                                strong: function(chunk) {
                                                    return (0,strongify/* default */.Z)(chunk);
                                                }
                                            }
                                        })
                                    ]
                                }),
                                toPlan.limits.productTags > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                    children: [
                                        CheckEmoji,
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Up to <strong>{chunk} category tags</strong> per product",
                                            id: "DQ/iww",
                                            values: {
                                                chunk: "".concat(toPlan.limits.productTags),
                                                strong: function(chunk) {
                                                    return (0,strongify/* default */.Z)(chunk);
                                                }
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                    children: [
                                        CheckEmoji,
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Enhanced vendor profile",
                                            id: "ervosm"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                    children: [
                                        CheckEmoji,
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Team access for <strong>{count} users</strong>",
                                            id: "Uj5Y7y",
                                            values: {
                                                count: toPlan.limits.teamMembers,
                                                strong: function(chunk) {
                                                    return (0,strongify/* default */.Z)(chunk);
                                                }
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                    children: [
                                        CheckEmoji,
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Add up to <strong>{projectsPerMonth}</strong> new {projectsPerMonth, plural, one {project} other {projects}} per month",
                                            id: "SkEF2S",
                                            values: {
                                                projectsPerMonth: toPlan.limits.projectsPerMonth,
                                                strong: function(chunk) {
                                                    return (0,strongify/* default */.Z)(chunk);
                                                }
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                    children: [
                                        CheckEmoji,
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "<strong>{count}</strong>custom branded discussion groups",
                                            id: "hFfG9q",
                                            values: {
                                                count: toPlan.limits.groups,
                                                strong: function(chunk) {
                                                    return (0,strongify/* default */.Z)(chunk);
                                                }
                                            }
                                        })
                                    ]
                                }),
                                toPlan.limits.searchAccess && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                    children: [
                                        CheckEmoji,
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "View other <strong>product profiles</strong>",
                                            id: "S0q+nj",
                                            values: {
                                                strong: function(chunk) {
                                                    return (0,strongify/* default */.Z)(chunk);
                                                }
                                            }
                                        })
                                    ]
                                }),
                                toPlan.limits.searchAccess && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                    children: [
                                        CheckEmoji,
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Search for other vendor & products",
                                            id: "vEUFjJ"
                                        })
                                    ]
                                }),
                                toPlan.limits.searchAccess && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                    children: [
                                        CheckEmoji,
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Suggest products to add to Govlaunch",
                                            id: "MV9qNV"
                                        })
                                    ]
                                }),
                                toPlan.limits.sharingPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                    children: [
                                        StarEmoji,
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Customizable public sharing hub",
                                            id: "eTjaNG"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/makers/ComparePlansBeforeChanging.tsx










function ComparePlansBeforeChanging(param) {
    var fromPlan = param.fromPlan, toPlan = param.toPlan, onConfirm = param.onConfirm, onCancel = param.onCancel;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            display: "grid",
            gridRowGap: 20,
            padding: 20,
            backgroundColor: palette/* white */.ix,
            border: "solid 1px ".concat(palette/* lightestGray */.v2),
            borderRadius: 4
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "grid",
                    gridRowGap: 4
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                        css: {
                            margin: 0
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Proposed Changes",
                            id: "HsxnxF"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                        css: {
                            margin: 0,
                            color: palette/* mediumGray */.rF,
                            fontSize: 14,
                            lineHeight: 1.33
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Before we continue — compare what you're changing to.",
                            id: "w6sv2+"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: (0,mediaQueries/* default */.Z)({
                    display: "grid",
                    gridRowGap: 30,
                    gridColumnGap: 30,
                    gridTemplateColumns: [
                        "1fr",
                        "1fr",
                        "1fr",
                        "1fr 1fr"
                    ]
                }),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FromPlanOption, {
                        fromPlan: fromPlan
                    }),
                    toPlan === "BASIC" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToBasicPlanOption, {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToPlanOption, {
                        toPlan: toPlan
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                    css: {
                        fontSize: 14,
                        lineHeight: 1.33,
                        fontWeight: 500,
                        color: palette/* text */.fL
                    },
                    children: [
                        "*",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Account plan will switch starting",
                            id: "WW27Jn"
                        }),
                        " ",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IntlDateTime/* default */.Z, {
                            value: fromPlan.changeDetails.proratePaymentDueDate || new Date()
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: (0,mediaQueries/* default */.Z)({
                    justifyContent: "center",
                    display: "grid",
                    gridTemplateColumns: [
                        "1fr",
                        "1fr",
                        "1fr",
                        "1fr 1fr"
                    ],
                    gridColumnGap: 20,
                    gridRowGap: 20
                }),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                        color: palette/* innovatorBlue */.LD,
                        onClick: onConfirm,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "I want to change",
                            id: "FFUlbw"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                        color: palette/* darkGray */.O5,
                        theme: "secondary",
                        onClick: onCancel,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Cancel",
                            id: "47FYwb"
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./lib/hooks/useIntlDate.ts
var useIntlDate = __webpack_require__(99909);
;// CONCATENATED MODULE: ./components/makers/ConfirmDowngrade.tsx








function ConfirmDowngrade(param) {
    var loading = param.loading, currentPlan = param.currentPlan, onConfirm = param.onConfirm, onCancel = param.onCancel;
    var ref = (0,react.useState)(false), canConfirm = ref[0], setCanConfirm = ref[1];
    var intlDate = (0,useIntlDate/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            display: "grid",
            gridRowGap: 20,
            padding: 20,
            backgroundColor: palette/* white */.ix,
            border: "solid 1px ".concat(palette/* lightestGray */.v2),
            borderRadius: 4
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "grid",
                    gridRowGap: 20
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                        css: {
                            margin: 0
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Confirm Downgrade",
                            id: "PHQLEr"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                        css: {
                            margin: 0,
                            color: palette/* mediumGray */.rF,
                            fontSize: 14,
                            lineHeight: 1.33
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Change will be effective at the end of your billing period on <strong>{date}</strong>.",
                            id: "H1szLa",
                            values: {
                                date: intlDate.format(currentPlan.changeDetails.proratePaymentDueDate),
                                strong: function(chunk) {
                                    return (0,strongify/* default */.Z)(chunk);
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                        css: {
                            margin: 0,
                            color: palette/* mediumGray */.rF,
                            fontSize: 14,
                            lineHeight: 1.33
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Any newly added content or users that exceed your new plan’s allowances will be erased immediately prior to the above date.",
                            id: "1tP09i"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                        css: {
                            margin: 0,
                            color: palette/* mediumGray */.rF,
                            fontSize: 14,
                            lineHeight: 1.33
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Type DOWNGRADE (in ALL CAPS) to proceed with your account change.",
                            id: "pCp0yB"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Input */.II, {
                        placeholder: "DOWNGRADE",
                        onChange: function(event) {
                            setCanConfirm((event.target.value || "").trim() === "DOWNGRADE");
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: (0,mediaQueries/* default */.Z)({
                    justifyContent: "center",
                    display: "grid",
                    gridTemplateColumns: [
                        "1fr",
                        "1fr",
                        "1fr",
                        "1fr 1fr"
                    ],
                    gridColumnGap: 20,
                    gridRowGap: 20
                }),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                        color: canConfirm ? palette/* innovatorBlue */.LD : palette/* darkGray */.O5,
                        theme: canConfirm ? "primary" : "secondary",
                        onClick: onConfirm,
                        disabled: !canConfirm,
                        children: loading ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* LoadingIndicator */.TF, {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Confirm",
                            id: "N2IrpM"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                        color: palette/* darkGray */.O5,
                        theme: "primary",
                        disabled: loading,
                        onClick: onCancel,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Cancel",
                            id: "47FYwb"
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/makers/DowngradeSuccessful.tsx






function DowngradeSuccessful(param) {
    var willCancelAt = param.willCancelAt;
    var intlDate = (0,useIntlDate/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            display: "grid",
            gridRowGap: 20,
            padding: 20,
            backgroundColor: palette/* white */.ix,
            border: "solid 1px ".concat(palette/* lightestGray */.v2),
            borderRadius: 4
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: {
                display: "grid",
                gridRowGap: 12
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                    css: {
                        margin: 0
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Downgrade Successful",
                        id: "KP+2qb"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                    css: {
                        margin: 0,
                        color: palette/* mediumGray */.rF,
                        fontSize: 14,
                        lineHeight: 1.33
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Change will be effective at the end of your billing period on <strong>{date}</strong>.",
                        id: "H1szLa",
                        values: {
                            date: intlDate.format(willCancelAt),
                            strong: function(chunk) {
                                return (0,strongify/* default */.Z)(chunk);
                            }
                        }
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                    css: {
                        margin: 0,
                        color: palette/* mediumGray */.rF,
                        fontSize: 14,
                        lineHeight: 1.33
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Please note that newly added content or users that exceed your new plan’s allowances will be erased immediately prior to the above date.",
                        id: "e9cgDB"
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/makers/hasSufficedAllDowngradeRequirements.ts
function hasSufficedAllDowngradeRequirements(toPlan, planUsage) {
    if (toPlan === "BASIC") {
        return planUsage.enrichedProducts === 0 && planUsage.groupInvitations === 0 && planUsage.products <= 20 && planUsage.productsWithMultipleTags === 0 && planUsage.sharingPage === false && planUsage.teamMembers === 1;
    }
    if (!toPlan.limits.sharingPage && planUsage.sharingPage) {
        return false;
    }
    return planUsage.enrichedProducts <= toPlan.limits.enrichedProducts && planUsage.groupInvitations <= toPlan.limits.groupInvitations && planUsage.products <= toPlan.limits.products && planUsage.projectsThisMonth <= toPlan.limits.projectsPerMonth && planUsage.teamMembers <= toPlan.limits.teamMembers;
};

;// CONCATENATED MODULE: ./components/makers/ShouldMeetAllRequirements.tsx





function ShouldMeetAllRequirements(param) {
    var toPlan = param.toPlan, planUsage = param.planUsage, onCancel = param.onCancel;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            display: "grid",
            gridRowGap: 20,
            padding: 20,
            backgroundColor: palette/* white */.ix,
            border: "solid 1px ".concat(palette/* lightestGray */.v2),
            borderRadius: 4
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "grid",
                    gridRowGap: 4
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                        css: {
                            margin: 0
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Required Changes",
                            id: "Z2n6mZ"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                        css: {
                            margin: 0,
                            color: palette/* mediumGray */.rF,
                            fontSize: 14,
                            lineHeight: 1.33
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Before you can downgrade your account to {plan}, you must first do the following:",
                            id: "Glb/wv",
                            values: {
                                plan: toPlan === "BASIC" ? "Basic" : toPlan.displayName
                            }
                        })
                    })
                ]
            }),
            toPlan === "BASIC" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                css: {
                    color: palette/* red */.Q6
                },
                children: [
                    planUsage.enrichedProducts > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Convert all enhanced product profiles to basic status",
                            id: "ERg5jF"
                        })
                    }),
                    planUsage.productsWithMultipleTags > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Keep only 1 tag on products",
                            id: "hcZ213"
                        })
                    }),
                    planUsage.teamMembers > 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Remove all of your teammates from the account",
                            id: "RpXXzN"
                        })
                    }),
                    planUsage.groups > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Close all existing sponsored groups",
                            id: "KQFAGP"
                        })
                    }),
                    planUsage.groupInvitations > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Leave all other groups that you have personally joined",
                            id: "Td6PEj"
                        })
                    }),
                    planUsage.sharingPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "You must disable your sharing page",
                            id: "WDivKN"
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("ul", {
                css: {
                    color: palette/* red */.Q6
                },
                children: [
                    planUsage.enrichedProducts - toPlan.limits.enrichedProducts > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Convert {count} enhanced product {count, plural, one {profile} other {profiles}} to Basic status",
                            id: "eiR9Bf",
                            values: {
                                count: planUsage.enrichedProducts - toPlan.limits.enrichedProducts
                            }
                        })
                    }),
                    planUsage.teamMembers - toPlan.limits.teamMembers > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Remove {count} teammates from the account",
                            id: "kxjWmY",
                            values: {
                                count: planUsage.teamMembers - toPlan.limits.teamMembers
                            }
                        })
                    }),
                    planUsage.groups - toPlan.limits.groups > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Close {count} of your sponsored groups",
                            id: "74g4yZ",
                            values: {
                                count: planUsage.groups - toPlan.limits.groups
                            }
                        })
                    }),
                    planUsage.groupInvitations - toPlan.limits.groupInvitations > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "All account users must reduce their number of outside group memberships to {count}",
                            id: "zrr5Yz",
                            values: {
                                count: planUsage.groupInvitations - toPlan.limits.groupInvitations
                            }
                        })
                    }),
                    planUsage.sharingPage && !toPlan.limits.sharingPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "You must disable your sharing page",
                            id: "WDivKN"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                color: palette/* darkGray */.O5,
                theme: "secondary",
                onClick: onCancel,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Cancel",
                    id: "47FYwb"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/makers/Alert.tsx
var Alert = __webpack_require__(6404);
;// CONCATENATED MODULE: ./components/makers/ChangePlansAlerts.tsx





var contactUs = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
    href: "mailto:hello@govlaunch.com",
    css: {
        color: palette/* innovatorBlue */.LD
    },
    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
        defaultMessage: "contact us",
        id: "cZ6IMP"
    })
});
function FailedToCommitPlanChange() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Alert/* default */.Z, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
            css: {
                margin: 0
            },
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "Sorry but we weren't able to perform this change at this time. Please try again later or {contactUs} to resolve the problem.",
                id: "r4ZPsX",
                values: {
                    contactUs: contactUs
                }
            })
        })
    });
}
function FailedToCancelSubscription() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Alert/* default */.Z, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
            css: {
                margin: 0
            },
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "Sorry but we weren't able to perform the cancellation at this time. Please try again later or {contactUs} to resolve the problem.",
                id: "9n1LEu",
                values: {
                    contactUs: contactUs
                }
            })
        })
    });
}
function NotAVendor() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Alert/* default */.Z, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
            css: {
                margin: 0
            },
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "You cannot access this page because your session expired or you aren't a Vendor. Try logging in again and if the issue still persists, {contactUs}.",
                id: "HJo/SY",
                values: {
                    contactUs: contactUs
                }
            })
        })
    });
}
function NoPlans() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Alert/* default */.Z, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
            css: {
                margin: 0
            },
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "We couldn't find any plans. Try again later or {contactUs}.",
                id: "id0JPH",
                values: {
                    contactUs: contactUs
                }
            })
        })
    });
}
function NoCurrentPlan() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Alert/* default */.Z, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
            css: {
                margin: 0
            },
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "You aren't subscribed to any plan.",
                id: "AQ1jSq"
            })
        })
    });
}
function NoSelectedPlanToChange() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Alert/* default */.Z, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
            css: {
                margin: 0
            },
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "Couldn't find the plan you want to change to. You can try again later or {contactUs}.",
                id: "8enPlT",
                values: {
                    contactUs: contactUs
                }
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/link.js
var next_link = __webpack_require__(54892);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/makers/ChangePlanOptionName.tsx




function ChangePlanOptionName(param) {
    var viewerIsSubscribed = param.viewerIsSubscribed, name = param.name;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: (0,mediaQueries/* default */.Z)({
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: [
                "100%",
                "100%",
                "100%",
                "auto"
            ],
            height: [
                "auto",
                "auto",
                "auto",
                "100%"
            ],
            textAlign: "center",
            borderRight: [
                "none",
                "none",
                "none",
                "solid 1px #e3e3e3"
            ],
            borderBottom: [
                "solid 1px #e3e3e3",
                "solid 1px #e3e3e3",
                "solid 1px #e3e3e3",
                "none"
            ]
        }),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: {
                display: "grid",
                gridRowGap: 5,
                padding: 20
            },
            children: [
                viewerIsSubscribed && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    css: {
                        fontSize: 14,
                        lineHeight: 1.33,
                        fontWeight: 500,
                        color: "#797979"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Current Plan",
                        id: "Z3GpJF"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                    css: {
                        margin: 0,
                        fontSize: 19,
                        fontWeight: 600,
                        color: "#212121",
                        lineHeight: 1.33
                    },
                    children: name
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/makers/ChangePlanOptionDescription.tsx



function ChangePlanOptionDescription(param) {
    var description = param.description;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: (0,mediaQueries/* default */.Z)({
            display: "flex",
            alignItems: "center",
            height: "100%",
            padding: 20,
            textAlign: [
                "center",
                "center",
                "center",
                "left"
            ],
            borderRight: [
                "none",
                "none",
                "none",
                "solid 1px #e3e3e3"
            ],
            borderBottom: [
                "solid 1px #e3e3e3",
                "solid 1px #e3e3e3",
                "solid 1px #e3e3e3",
                "none"
            ]
        }),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
            css: {
                margin: 0,
                fontSize: 14,
                lineHeight: 1.33,
                color: "#797979"
            },
            children: description
        })
    });
};

;// CONCATENATED MODULE: ./components/makers/ChangePlanOptionPrice.tsx






function ChangePlanOptionPrice(param) {
    var price = param.price, recurrency = param.recurrency, name = param.name;
    if (name === "Makers Pro") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
            size: "large",
            theme: "primary",
            color: palette/* primary */.T$,
            textColor: palette/* white */.ix,
            css: {
                width: "90%",
                justifySelf: "center"
            },
            "data-intercom-target": "ContactUsForMakersPro",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "Contact Us",
                id: "hZOGLS"
            })
        });
    }
    if (price === 0) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
            css: {
                padding: 20,
                fontWeight: 600,
                fontSize: 20,
                textAlign: "center"
            },
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "Free",
                id: "tf1lIh"
            })
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("strong", {
        css: {
            padding: 20,
            fontWeight: 600,
            fontSize: 20,
            textAlign: "center"
        },
        children: [
            "$",
            recurrency === types/* IPlanRecurrency.Monthly */.oO.Monthly ? priceWithDecimals(price / 100) : priceWithDecimals(price / 100 / 12),
            " /",
            " ",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "month",
                id: "Cu3Cty"
            })
        ]
    });
};
function priceWithDecimals(price) {
    if (price !== Math.floor(price)) {
        return price.toFixed(2);
    } else {
        return price;
    }
}

;// CONCATENATED MODULE: ./components/makers/ChangePlanOption.tsx







function ChangePlanOption(param) {
    var name = param.name, description = param.description, price = param.price, recurrency = param.recurrency, isSelected = param.isSelected, viewerIsSubscribed = param.viewerIsSubscribed, onSelect = param.onSelect;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        role: "button",
        onClick: function() {
            if (!viewerIsSubscribed || viewerIsSubscribed && !isSelected) {
                onSelect();
            }
        },
        css: (0,mediaQueries/* default */.Z)({
            display: "grid",
            gridTemplateColumns: [
                "1fr",
                "1fr",
                "1fr",
                "150px 1fr 150px"
            ],
            alignItems: "center",
            minHeight: 120,
            backgroundColor: palette/* white */.ix,
            border: isSelected ? "solid 2px ".concat(palette/* innovatorBlue */.LD) : "solid 2px #e3e3e3",
            borderRadius: 4,
            "&:hover": {
                border: "solid 2px ".concat(palette/* innovatorBlue */.LD),
                cursor: "pointer"
            }
        }),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChangePlanOptionName, {
                name: name,
                viewerIsSubscribed: viewerIsSubscribed
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChangePlanOptionDescription, {
                description: description
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChangePlanOptionPrice, {
                price: price,
                recurrency: recurrency,
                name: name
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/makers/ConfirmPlanChange.tsx





function ConfirmPlanChange(param) {
    var toPlan = param.toPlan, children = param.children, onConfirm = param.onConfirm;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var onRequestClose = function() {
        return setIsOpen(false);
    };
    if (toPlan === null) {
        return children({
            onRequestConfirmation: function() {}
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Modal */.u_, {
                isOpen: isOpen,
                ariaHideApp: false,
                onRequestClose: onRequestClose,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "grid",
                        gridRowGap: 20,
                        width: 370,
                        padding: 20
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                display: "flex",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                                    css: {
                                        fontWeight: "bold",
                                        margin: 0
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Confirm Change",
                                        id: "tzQB6V"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* ModalClose */.A3, {
                                    onClick: onRequestClose,
                                    style: {
                                        position: "relative",
                                        top: 0,
                                        right: 0,
                                        marginLeft: "auto",
                                        cursor: "pointer"
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                            css: {
                                margin: 0,
                                fontWeight: 400,
                                fontSize: 14,
                                lineHeight: 1.33
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "You're about to change your plan to <strong>{plan}</strong>.",
                                id: "FpaUHD",
                                values: {
                                    plan: toPlan.displayName,
                                    strong: function(chunk) {
                                        return (0,strongify/* default */.Z)(chunk);
                                    }
                                }
                            })
                        }),
                        toPlan.changeDetails && toPlan.changeDetails.prorateCost !== null && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                            css: {
                                margin: 0,
                                fontWeight: 400,
                                fontSize: 14,
                                lineHeight: 1.33
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "If you proceed, we'll charge <strong>{prorateCost}</strong> now.",
                                id: "BJK59q",
                                values: {
                                    prorateCost: toPlan.changeDetails.prorateCost < 100 ? 0 : toPlan.changeDetails.prorateCost / 100,
                                    strong: function(chunk) {
                                        return (0,strongify/* default */.Z)(chunk);
                                    }
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                display: "grid",
                                gridColumnGap: 20,
                                gridTemplateColumns: "1fr 1fr"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                    theme: "link",
                                    color: "danger",
                                    onClick: onRequestClose,
                                    children: "No. Don't change"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                    onClick: function() {
                                        onConfirm();
                                        onRequestClose();
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Proceed",
                                        id: "VNX4fn"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            children({
                onRequestConfirmation: function() {
                    return setIsOpen(true);
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/makers/ChangePlanOptions.tsx










function ChangePlanOptions(param) {
    var vendorSlug = param.vendorSlug, basicPlan = param.basicPlan, selectedPlanToChange = param.selectedPlanToChange, setSelectedPlanToChange = param.setSelectedPlanToChange, stripePlans = param.stripePlans, currentPlan = param.currentPlan, changeSubscriptionPlan = param.changeSubscriptionPlan, isChangingPlans = param.isChangingPlans, moveToChangeStep = param.moveToChangeStep;
    var intl = (0,useIntl/* default */.Z)();
    var linkToDetails = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: "/makers",
        passHref: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            css: {
                fontSize: 14,
                lineHeight: 1.33,
                color: palette/* innovatorBlue */.LD
            },
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "Details",
                id: "Lv0zJu"
            })
        })
    });
    var changeToPlan = stripePlans.find(function(plan) {
        return plan.planId === selectedPlanToChange;
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            display: "grid",
            gridRowGap: 20
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChangePlanOptionsHeader, {
                vendorSlug: vendorSlug
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "grid",
                    gridRowGap: 20
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChangePlanOption, {
                        name: "Basic",
                        description: basicPlan ? getPlanDescription(basicPlan.limits, basicPlan.tier, intl) : "Basic product profiles.",
                        price: 0,
                        viewerIsSubscribed: false,
                        isSelected: selectedPlanToChange === "BASIC",
                        onSelect: function() {
                            return setSelectedPlanToChange("BASIC");
                        }
                    }),
                    stripePlans.sort(function(a, b) {
                        return PLANS_ORDER.indexOf(a.name) - PLANS_ORDER.indexOf(b.name);
                    }).map(function(plan) {
                        var isSelected = selectedPlanToChange !== null ? selectedPlanToChange === plan.planId : plan.viewerIsSubscribed;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChangePlanOption, {
                            name: plan.displayName,
                            description: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    getPlanDescription(plan.limits, plan.tier, intl),
                                    ". ",
                                    linkToDetails
                                ]
                            }),
                            price: plan.price,
                            recurrency: plan.recurrency,
                            viewerIsSubscribed: plan.viewerIsSubscribed,
                            isSelected: isSelected,
                            onSelect: function() {
                                return setSelectedPlanToChange(plan.planId);
                            }
                        }, plan.planId);
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: (0,mediaQueries/* default */.Z)({
                    justifyContent: "center",
                    display: "grid",
                    gridTemplateColumns: [
                        "1fr",
                        "1fr",
                        "1fr",
                        "120px 120px"
                    ],
                    gridColumnGap: 20,
                    gridRowGap: 20
                }),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ConfirmPlanChange, {
                        toPlan: changeToPlan ? changeToPlan : null,
                        onConfirm: function() {
                            if (changeToPlan) {
                                changeSubscriptionPlan({
                                    variables: {
                                        stripePlanId: changeToPlan.planId
                                    }
                                });
                            }
                        },
                        children: function(param) {
                            var onRequestConfirmation = param.onRequestConfirmation;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                color: isChangingPlans || selectedPlanToChange === null || selectedPlanToChange === currentPlan.planId || changeToPlan && changeToPlan.tier === types/* IPlanTier.Makerspro */.fq.Makerspro ? palette/* darkGray */.O5 : palette/* innovatorBlue */.LD,
                                disabled: selectedPlanToChange === null || isChangingPlans || selectedPlanToChange === currentPlan.planId || changeToPlan && changeToPlan.tier === types/* IPlanTier.Makerspro */.fq.Makerspro,
                                onClick: function() {
                                    if (!selectedPlanToChange) {
                                        return;
                                    }
                                    var isDowngrade = selectedPlanToChange === "BASIC" || changeToPlan && changeToPlan.price < currentPlan.price;
                                    // we'll prompt the user with some more confirmations before he could actually confirm the downgrade
                                    if (isDowngrade) {
                                        moveToChangeStep("COMPARE_BOTH_PLANS");
                                        return;
                                    }
                                    // it's an upgrade. We shouldn't ask for any further confirmation.
                                    if (selectedPlanToChange && selectedPlanToChange !== "BASIC" && changeToPlan) {
                                        moveToChangeStep(null);
                                        onRequestConfirmation();
                                    }
                                },
                                children: isChangingPlans ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* LoadingIndicator */.TF, {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Continue",
                                    id: "acrOoz"
                                })
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: "/vendors/[vendorSlug]/[[...content]]",
                        as: "/vendors/".concat(vendorSlug, "/account"),
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                textAlign: "center"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* AnchorButton */.AN, {
                                color: palette/* darkGray */.O5,
                                theme: "secondary",
                                disabled: isChangingPlans,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Go Back",
                                    id: "ekfOaV"
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
function ChangePlanOptionsHeader(param) {
    var vendorSlug = param.vendorSlug;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            display: "grid",
            gridRowGap: 8
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                css: {
                    fontSize: 26,
                    color: palette/* text */.fL,
                    margin: 0,
                    lineHeight: 1.33,
                    fontWeight: "normal"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Change Plans",
                    id: "D+Kmq3"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: "/vendors/[vendorSlug]/[[...content]]",
                as: "/vendors/".concat(vendorSlug, "/account"),
                passHref: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                    css: {
                        color: palette/* innovatorBlue */.LD
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Back to Account",
                        id: "diSXRh"
                    })
                })
            })
        ]
    });
}
function getPlanDescription(limits, name, intl) {
    var features = [];
    if (name === types/* IPlanTier.Makerspro */.fq.Makerspro) {
        features.push(intl.formatMessage({
            defaultMessage: "For companies with greater than 20 employees",
            id: "z7MBFW"
        }));
        return features.join(" ");
    }
    if (limits.enrichedProducts > 0) {
        features.push(intl.formatMessage({
            defaultMessage: "Enhanced profiles for {count} products.",
            id: "9K+IvJ"
        }, {
            count: limits.enrichedProducts
        }));
    } else {
        features.push(intl.formatMessage({
            defaultMessage: "Basic product profiles",
            id: "AcV6wk"
        }).concat("."));
    }
    if (limits.projectsPerMonth > 0) {
        features.push(intl.formatMessage({
            defaultMessage: "Add up to {projectsPerMonth} {projectsPerMonth, plural, one {project} other {projects}} per month",
            id: "mxbL1j"
        }, {
            projectsPerMonth: limits.projectsPerMonth
        }));
    }
    if (limits.teamMembers > 0) {
        features.push(intl.formatMessage({
            defaultMessage: "{count} team seats.",
            id: "lsftOu"
        }, {
            count: limits.teamMembers
        }));
    }
    if (limits.groups > 0) {
        features.push(intl.formatMessage({
            defaultMessage: "{count} sponsored groups.",
            id: "RjfhhG"
        }, {
            count: limits.groups
        }));
    }
    if (limits.sharingPage) {
        features.push(intl.formatMessage({
            defaultMessage: "Custom share page.",
            id: "CLqXQG"
        }));
    }
    return features.join(" ");
}
var PLANS_ORDER = [
    "Basic",
    "Makers",
    "Makers Pro"
];

;// CONCATENATED MODULE: ./lib/queries/AvailablePlans.ts

function AvailablePlans_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query AvailablePlans {\n    availablePlans {\n      _id\n      name\n      displayName\n      tier\n      isSelectable\n      stripePlanId\n      limits {\n        teamMembers\n        products\n        enrichedProducts\n        groups\n        groupInvitations\n        sharingPage\n        projectsPerMonth\n        productTags\n        enrichedProfile\n      }\n      stripePlan {\n        ...StripePlanFields\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    AvailablePlans_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var AvailablePlans = ((0,lib/* gql */.Ps)(AvailablePlans_templateObject(), StripePlanFields/* default */.Z));

;// CONCATENATED MODULE: ./components/makers/ChangePlans.tsx
















function ChangePlans() {
    var ref;
    var selfie = (0,Auth/* useSelfie */.yD)();
    // will be "BASIC" when the user is "cancelling" the subscription. Otherwise, that will be a Stripe plan identifier
    var ref1 = (0,react.useState)(null), selectedPlanToChange = ref1[0], setSelectedPlanToChange = ref1[1];
    // this is used in the downgrade scenario where the user must compare what he's changing before actually confirming it
    var ref2 = (0,react.useState)(null), changeStep = ref2[0], setChangeStep = ref2[1];
    var ref3 = (0,useQuery/* useQuery */.a)(AvailablePlans), data = ref3.data, loading = ref3.loading;
    if (loading) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* LoadingIndicator */.TF, {});
    }
    var basicPlan = data && ((ref = data.availablePlans) === null || ref === void 0 ? void 0 : ref.find(function(plan) {
        return plan.tier === types/* IPlanTier.Basic */.fq.Basic;
    })) || null;
    var noPlans = !data || !data.availablePlans || data.availablePlans.length === 0;
    if (!selfie || selfie.__typename !== "VendorUser" || !selfie.company) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotAVendor, {});
    }
    if (noPlans || !basicPlan) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoPlans, {});
    }
    var currentPlan = data.availablePlans.find(function(plan) {
        return plan.stripePlan && plan.stripePlan.viewerIsSubscribed;
    });
    if (!currentPlan || !currentPlan.stripePlan) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoCurrentPlan, {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChangePlansMutations, {
        children: function(param) {
            var changeSubscriptionPlan = param.changeSubscriptionPlan, isChangingPlans = param.isChangingPlans, failedToCommitPlanChange = param.failedToCommitPlanChange, cancelSubscription = param.cancelSubscription, isCancellingSubscription = param.isCancellingSubscription, cancelSubscriptionMutationResult = param.cancelSubscriptionMutationResult, failedToCancelSubscription = param.failedToCancelSubscription;
            if (!selfie.company) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotAVendor, {});
            }
            if (failedToCommitPlanChange) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FailedToCommitPlanChange, {});
            }
            if (failedToCancelSubscription) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FailedToCancelSubscription, {});
            }
            if (cancelSubscriptionMutationResult && cancelSubscriptionMutationResult.cancelSubscription.subscription && cancelSubscriptionMutationResult.cancelSubscription.subscription.__typename === "ScheduledToCancelSubscription") {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DowngradeSuccessful, {
                    willCancelAt: cancelSubscriptionMutationResult.cancelSubscription.subscription.willCancelAt
                });
            }
            if (selfie.company.subscription && selfie.company.subscription.__typename === "ScheduledToCancelSubscription") {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DowngradeSuccessful, {
                    willCancelAt: selfie.company.subscription.willCancelAt
                });
            }
            if (changeStep === "TYPE_DOWNGRADE") {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ConfirmDowngrade, {
                    loading: isCancellingSubscription || isChangingPlans,
                    currentPlan: currentPlan.stripePlan,
                    onConfirm: function() {
                        if (selectedPlanToChange === "BASIC") {
                            cancelSubscription({});
                            return;
                        }
                        var changingToPlan = data.availablePlans.find(function(plan) {
                            return plan.stripePlan && plan.stripePlan.planId === selectedPlanToChange;
                        });
                        if (changingToPlan) {
                            changeSubscriptionPlan({
                                variables: {
                                    stripePlanId: changingToPlan.stripePlan.planId
                                }
                            });
                        }
                    },
                    onCancel: function() {
                        return setChangeStep(null);
                    }
                });
            }
            if (changeStep === "MEET_REQUIREMENTS") {
                var changingToPlan = data.availablePlans.find(function(plan) {
                    return plan.stripePlan && plan.stripePlan.planId === selectedPlanToChange;
                });
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShouldMeetAllRequirements, {
                    toPlan: changingToPlan && changingToPlan.stripePlan ? changingToPlan.stripePlan : "BASIC",
                    planUsage: selfie.company.planUsage,
                    onCancel: function() {
                        return setChangeStep(null);
                    }
                });
            }
            if (changeStep === "CONFIRM_CHANGES") {
                var changingToPlan1 = data.availablePlans.find(function(plan) {
                    return plan.stripePlan && plan.stripePlan.planId === selectedPlanToChange;
                });
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AreYouSure, {
                    onConfirm: function() {
                        if (!selfie.company) {
                            return;
                        }
                        setChangeStep(hasSufficedAllDowngradeRequirements(selectedPlanToChange === "BASIC" ? "BASIC" : changingToPlan1 && changingToPlan1.stripePlan ? changingToPlan1.stripePlan : "BASIC", selfie.company.planUsage) ? "TYPE_DOWNGRADE" : "MEET_REQUIREMENTS");
                    },
                    onCancel: function() {
                        return setChangeStep(null);
                    }
                });
            }
            if (changeStep === "COMPARE_BOTH_PLANS") {
                if (selectedPlanToChange === "BASIC") {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ComparePlansBeforeChanging, {
                        fromPlan: currentPlan.stripePlan,
                        toPlan: "BASIC",
                        onConfirm: function() {
                            return setChangeStep("CONFIRM_CHANGES");
                        },
                        onCancel: function() {
                            return setChangeStep(null);
                        }
                    });
                }
                var changingToPlan2 = data.availablePlans.find(function(plan) {
                    return plan.stripePlan && plan.stripePlan.planId === selectedPlanToChange;
                });
                if (!changingToPlan2 || !changingToPlan2.stripePlan) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoSelectedPlanToChange, {});
                }
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ComparePlansBeforeChanging, {
                    fromPlan: currentPlan.stripePlan,
                    toPlan: changingToPlan2.stripePlan,
                    onConfirm: function() {
                        return setChangeStep("CONFIRM_CHANGES");
                    },
                    onCancel: function() {
                        return setChangeStep(null);
                    }
                });
            }
            if (loading) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* LoadingIndicator */.TF, {});
            }
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChangePlanOptions, {
                vendorSlug: selfie.company.slug,
                basicPlan: basicPlan,
                selectedPlanToChange: selectedPlanToChange,
                setSelectedPlanToChange: setSelectedPlanToChange,
                stripePlans: data.availablePlans.map(function(plan) {
                    return plan.stripePlan;
                }).filter(Boolean),
                currentPlan: currentPlan.stripePlan,
                changeSubscriptionPlan: changeSubscriptionPlan,
                isChangingPlans: isChangingPlans,
                moveToChangeStep: setChangeStep
            });
        }
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/components/Query.js
var Query = __webpack_require__(38085);
;// CONCATENATED MODULE: ./lib/queries/fragments/StripeInvoiceFields.ts

function StripeInvoiceFields_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment StripeInvoiceFields on Invoice {\n    id\n    friendlyId\n    status\n    paidAt\n    amount\n    currency\n    amountRefunded\n    receiptUrl\n    card {\n      brand\n      lastFourDigits\n      expirationMonth\n      expirationYear\n    }\n    items {\n      id\n      description\n      amount\n    }\n  }\n"
    ]);
    StripeInvoiceFields_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var StripeInvoiceFields = ((0,lib/* gql */.Ps)(StripeInvoiceFields_templateObject()));

// EXTERNAL MODULE: ./lib/queries/fragments/CompanyPlanUsageFields.ts
var CompanyPlanUsageFields = __webpack_require__(71505);
// EXTERNAL MODULE: ./lib/queries/fragments/CompanyPlanFields.ts
var CompanyPlanFields = __webpack_require__(28896);
;// CONCATENATED MODULE: ./lib/queries/CompanyAccountBillingInfoQuery.ts

function CompanyAccountBillingInfoQuery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query CompanyAccountBillingInfo($slug: String!) {\n    company(slug: $slug) {\n      _id\n      slug\n      name\n      canEarnCreditsUntil\n      isDisruptor\n      usersCanAccessAccountPage\n      usersCanRequestContentTranslation\n      stripePlan {\n        ...StripePlanFields\n      }\n      planUsage {\n        ...CompanyPlanUsageFields\n      }\n      plan {\n        ...CompanyPlanFields\n      }\n      charges {\n        ...StripeChargeFields\n      }\n      invoices {\n        ...StripeInvoiceFields\n      }\n      billing {\n        card {\n          brand\n          lastFourDigits\n          expirationMonth\n          expirationYear\n        }\n      }\n      balanceTransactions {\n        type\n        amount\n        government {\n          _id\n          name\n        }\n        inviter {\n          _id\n          fullName\n        }\n        endingBalance\n        description\n        createdAt\n      }\n      sponsoringSales {\n        _id\n        description\n        type\n        sponsorshipLevel\n        includedCollections {\n          _id\n          name\n          slug\n        }\n        price\n        isActive\n        paymentSchedule\n        createdAt\n        updatedAt\n        ... on RecurringCollectionSponsoringSale {\n          _id\n          renewsAt\n          cancelsAt\n        }\n        ... on LumpSumCollectionSponsoringSale {\n          _id\n          expirationDate\n        }\n      }\n      ...CompanySubscription\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    CompanyAccountBillingInfoQuery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







/* harmony default export */ var CompanyAccountBillingInfoQuery = ((0,lib/* gql */.Ps)(CompanyAccountBillingInfoQuery_templateObject(), CompanySubscription/* default */.Z, StripeChargeFields/* default */.Z, StripeInvoiceFields, StripePlanFields/* default */.Z, CompanyPlanUsageFields/* default */.Z, CompanyPlanFields/* default */.Z));

// EXTERNAL MODULE: ./node_modules/.pnpm/react-powerplug@1.0.0_react@17.0.2/node_modules/react-powerplug/dist/react-powerplug.esm.js
var react_powerplug_esm = __webpack_require__(41491);
;// CONCATENATED MODULE: ./lib/mutations/ReactivateSubscription.ts

function ReactivateSubscription_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ReactivateSubscription {\n    reactivateSubscription {\n      ...CompanySubscription\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    ReactivateSubscription_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ var ReactivateSubscription = ((0,lib/* gql */.Ps)(ReactivateSubscription_templateObject(), CompanySubscription/* default */.Z, StripeChargeFields/* default */.Z));

// EXTERNAL MODULE: ./lib/utils/mediaQueries.ts
var utils_mediaQueries = __webpack_require__(29713);
// EXTERNAL MODULE: ./components/invite/InviteModal.tsx + 4 modules
var InviteModal = __webpack_require__(96805);
;// CONCATENATED MODULE: ./components/vendor/profile/getIntercomTarget.ts
function getIntercomTarget(user, target) {
    if (user.__typename === "VendorUser") {
        if (user.company && user.company.isDisruptor && target.asDisruptor) {
            return target.asDisruptor;
        } else if ((user.role === "COMPANY_OWNER" || user.company && user.company.usersCanAccessAccountPage) && target.asOwner) {
            return target.asOwner;
        } else if (user.role === "COMPANY_MEMBER" && target.asMember) {
            return target.asMember;
        }
    }
    return undefined;
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(29452);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(56262);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(45597);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-switch@6.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-switch/index.js
var react_switch = __webpack_require__(86029);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-use@17.4.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-use/esm/useToggle.js
var useToggle = __webpack_require__(35150);
;// CONCATENATED MODULE: ./lib/mutations/ToggleUsersCanAccessAccountPage.ts

function ToggleUsersCanAccessAccountPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ToggleUsersCanAccessAccountPage($vendorId: ObjectId!, $isAccessAllowed: Boolean!) {\n    toggleUsersCanAccessAccountPage(vendorId: $vendorId, isAccessAllowed: $isAccessAllowed)\n  }\n"
    ]);
    ToggleUsersCanAccessAccountPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var ToggleUsersCanAccessAccountPage = ((0,lib/* gql */.Ps)(ToggleUsersCanAccessAccountPage_templateObject()));

;// CONCATENATED MODULE: ./components/makers/UsersCanAccessAccountPage.tsx











function UsersCanAccessAccountPageToggleRow(param) {
    var usersCanAccessAccountPage = param.usersCanAccessAccountPage, vendorId = param.vendorId;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    fontSize: 16,
                    fontWeight: 600,
                    color: "#949195",
                    maxWidth: 200
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Enable Users to Access Account Page",
                    id: "HpfEcc"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    display: "grid",
                    gridColumnGap: 12,
                    gridTemplateColumns: "repeat(2, max-content)",
                    alignItems: "center",
                    color: palette/* text */.fL,
                    fontSize: 16,
                    "& > strong": {
                        fontWeight: 600
                    }
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleUsersCanAccessAccountPageMutation, {
                    usersCanAccessAccountPage: usersCanAccessAccountPage,
                    vendorId: vendorId
                })
            })
        ]
    });
}
var ToggleUsersCanAccessAccountPageMutation = function(param) {
    var usersCanAccessAccountPage = param.usersCanAccessAccountPage, vendorId = param.vendorId;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(usersCanAccessAccountPage), 2), usersAllowedToViewPage = ref[0], toggleUsersAllowedToViewPage = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
        onCompleted: function() {},
        variables: {
            vendorId: vendorId,
            isAccessAllowed: usersAllowedToViewPage
        },
        mutation: ToggleUsersCanAccessAccountPage,
        children: function(toggleAccess) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_switch["default"], {
                uncheckedIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        fontSize: 15,
                        color: palette/* darkGray */.O5,
                        paddingRight: 10
                    },
                    children: "off"
                }),
                checkedIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        fontSize: 15,
                        color: "#fff",
                        paddingLeft: 10
                    },
                    children: "on"
                }),
                handleDiameter: 22,
                height: 26,
                width: 65,
                onChange: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(checked) {
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    toggleUsersAllowedToViewPage(checked);
                                    _ctx.next = 3;
                                    return toggleAccess({
                                        variables: {
                                            vendorId: vendorId,
                                            isAccessAllowed: checked
                                        }
                                    });
                                case 3:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee);
                    }));
                    return function(checked) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                checked: usersAllowedToViewPage,
                onColor: palette/* greenSuccess */.CU,
                offColor: palette/* lightGray */.l2
            });
        }
    });
};

;// CONCATENATED MODULE: ./lib/mutations/ToggleUsersCanRequestContentTranslation.ts

function ToggleUsersCanRequestContentTranslation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ToggleUsersCanRequestContentTranslation($vendorId: ObjectId!, $requestContentTranslationAllowed: Boolean!) {\n    toggleUsersCanRequestContentTranslation(\n      vendorId: $vendorId\n      requestContentTranslationAllowed: $requestContentTranslationAllowed\n    )\n  }\n"
    ]);
    ToggleUsersCanRequestContentTranslation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var ToggleUsersCanRequestContentTranslation = ((0,lib/* gql */.Ps)(ToggleUsersCanRequestContentTranslation_templateObject()));

;// CONCATENATED MODULE: ./components/makers/UsersRequestContentTranslation.tsx











function UsersCanRequestContentTranslationRow(param) {
    var suggestMyContentTranslation = param.suggestMyContentTranslation, vendorId = param.vendorId;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    fontSize: 16,
                    fontWeight: 600,
                    color: "#949195",
                    maxWidth: 200
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Enable Translation of Vendor’s Profile Page",
                    id: "ysk4G7"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    display: "grid",
                    gridColumnGap: 12,
                    gridTemplateColumns: "repeat(2, max-content)",
                    alignItems: "center",
                    color: palette/* text */.fL,
                    fontSize: 16,
                    "& > strong": {
                        fontWeight: 600
                    }
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleUsersCanRequestContentTranslationMutation, {
                    suggestMyContentTranslation: suggestMyContentTranslation,
                    vendorId: vendorId
                })
            })
        ]
    });
}
var ToggleUsersCanRequestContentTranslationMutation = function(param) {
    var suggestMyContentTranslation = param.suggestMyContentTranslation, vendorId = param.vendorId;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(suggestMyContentTranslation), 2), usersCanRequestTranslation = ref[0], toggleUsersCanRequestTranslation = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
        onCompleted: function() {},
        variables: {
            vendorId: vendorId,
            requestContentTranslationAllowed: usersCanRequestTranslation
        },
        mutation: ToggleUsersCanRequestContentTranslation,
        children: function(toggleAccessToTranslation) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_switch["default"], {
                uncheckedIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        fontSize: 15,
                        color: palette/* darkGray */.O5,
                        paddingRight: 10
                    },
                    children: "off"
                }),
                checkedIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        fontSize: 15,
                        color: "#fff",
                        paddingLeft: 10
                    },
                    children: "on"
                }),
                handleDiameter: 22,
                height: 26,
                width: 65,
                onChange: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(checked) {
                        return runtime_default().wrap(function _callee$(_ctx) {
                            while(1)switch(_ctx.prev = _ctx.next){
                                case 0:
                                    toggleUsersCanRequestTranslation(checked);
                                    _ctx.next = 3;
                                    return toggleAccessToTranslation({
                                        variables: {
                                            vendorId: vendorId,
                                            requestContentTranslationAllowed: checked
                                        }
                                    });
                                case 3:
                                case "end":
                                    return _ctx.stop();
                            }
                        }, _callee);
                    }));
                    return function(checked) {
                        return _ref.apply(this, arguments);
                    };
                }(),
                checked: usersCanRequestTranslation,
                onColor: palette/* greenSuccess */.CU,
                offColor: palette/* lightGray */.l2
            });
        }
    });
};

;// CONCATENATED MODULE: ./components/makers/CurrentPlanAndUsage.tsx















function CurrentPlanAndUsage(param) {
    var company = param.company;
    var loggedInUser = (0,Auth/* useSelfie */.yD)();
    var intl = (0,useIntl/* default */.Z)();
    if (!loggedInUser) {
        return null;
    }
    var userHasOwnershipRights = loggedInUser.role === "COMPANY_OWNER" || company.usersCanAccessAccountPage;
    var Reactivate = function() {
        if (company.stripePlan) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "Reactivate {name}",
                id: "eMM95H",
                values: {
                    name: company.stripePlan.displayName
                }
            });
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
            defaultMessage: "Subscription",
            id: "R/6nsx"
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        "data-intercom-target": getIntercomTarget(loggedInUser, {
            asMember: "Settings Account Box",
            asOwner: "Settings Account Box",
            asDisruptor: "Settings Account Box for Disruptors"
        }),
        css: {
            boxSizing: "border-box",
            padding: 24,
            backgroundColor: palette/* white */.ix,
            border: "solid 0.5px #e6e8ea",
            borderRadius: 4
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                css: {
                    margin: 0,
                    color: "#212121",
                    fontWeight: 600,
                    fontSize: 20
                },
                children: "Account"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("hr", {
                css: {
                    width: "100%",
                    marginTop: 20,
                    border: "none",
                    borderBottom: "solid 1px #e6e8ea"
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    paddingTop: 20
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: (0,utils_mediaQueries/* default */.Z)({
                        display: "grid",
                        gridTemplateColumns: [
                            "1fr",
                            "1fr",
                            "1fr",
                            "max-content 1fr"
                        ],
                        gridColumnGap: 40,
                        gridRowGap: 30
                    }),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                fontSize: 16,
                                fontWeight: 600,
                                color: "#949195"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Current Plan",
                                id: "Z3GpJF"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                display: "grid",
                                gridRowGap: 10
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                                    css: {
                                        fontSize: 16,
                                        fontWeight: 600,
                                        color: palette/* text */.fL
                                    },
                                    children: company.plan.displayName
                                }),
                                !company.isDisruptor && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    css: {
                                        display: "grid",
                                        gridAutoFlow: "column",
                                        gridAutoColumns: "max-content",
                                        gridColumnGap: 10
                                    },
                                    children: [
                                        company.subscription && company.subscription.__typename === "ActiveSubscription" && company.stripePlan && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                            href: "/vendors/[vendorSlug]/[[...content]]",
                                            as: "/vendors/".concat(company.slug, "/change-plans"),
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                href: "/makers",
                                                css: {
                                                    color: "#005aee",
                                                    fontSize: 13
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Change Plans",
                                                    id: "D+Kmq3"
                                                })
                                            })
                                        }),
                                        !company.subscription && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                            href: "/makers",
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                href: "/makers",
                                                css: {
                                                    color: "#005aee",
                                                    fontSize: 13
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "View plans",
                                                    id: "EaucLA"
                                                })
                                            })
                                        }),
                                        company.subscription && company.subscription.__typename === "ScheduledToCancelSubscription" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                                            mutation: ReactivateSubscription,
                                            children: function(reactivateSubscription, param) {
                                                var loading = param.loading;
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                                                    type: "button",
                                                    disabled: loading,
                                                    onClick: function() {
                                                        return reactivateSubscription();
                                                    },
                                                    css: {
                                                        display: "inline-flex",
                                                        boxSizing: "border-box",
                                                        margin: 0,
                                                        padding: 0,
                                                        color: "#005aee",
                                                        fontSize: 13,
                                                        backgroundColor: "transparent",
                                                        border: "none",
                                                        outline: "none",
                                                        cursor: loading ? "default" : "pointer",
                                                        "&:hover": {
                                                            textDecoration: "underline"
                                                        }
                                                    },
                                                    children: loading ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "Reactivating...",
                                                        id: "9QDqZs"
                                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Reactivate, {})
                                                });
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                fontSize: 16,
                                fontWeight: 600,
                                color: "#949195"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Team Members",
                                id: "HCYBYT"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UsageCapLine, {
                                    usage: company.planUsage.teamMembers,
                                    cap: company.plan.limits.teamMembers
                                }),
                                userHasOwnershipRights && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Toggle */.ZD, {
                                    children: function(param) {
                                        var isOpen = param.on, toggle = param.toggle;
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                    role: "button",
                                                    onClick: toggle,
                                                    css: {
                                                        cursor: "pointer",
                                                        color: "#005aee",
                                                        fontSize: 13
                                                    },
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "Add more teammates",
                                                        id: "vCvY6V"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InviteModal/* default */.Z, {
                                                    title: intl.formatMessage({
                                                        defaultMessage: "Invite Team Members",
                                                        id: "LeF5J5"
                                                    }),
                                                    subtitle: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                            defaultMessage: "They’ll be granted access to your <strong>Vendor profile</strong>",
                                                            id: "u9sOgv",
                                                            values: {
                                                                strong: function(chunk) {
                                                                    return (0,strongify/* default */.Z)(chunk);
                                                                }
                                                            }
                                                        })
                                                    }),
                                                    targetType: "VENDOR",
                                                    targetId: company._id,
                                                    isOpen: isOpen,
                                                    onRequestClose: toggle
                                                })
                                            ]
                                        });
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                fontSize: 16,
                                fontWeight: 600,
                                color: "#949195"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Products",
                                id: "7NFfmz"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UsageCapLine, {
                            usage: company.planUsage.products,
                            cap: company.plan.limits.products
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                fontSize: 16,
                                fontWeight: 600,
                                color: "#949195"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Projects (month)",
                                id: "ZTV6Lo"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UsageCapLine, {
                            usage: company.planUsage.projectsThisMonth,
                            cap: company.plan.limits.projectsPerMonth
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                fontSize: 16,
                                fontWeight: 600,
                                color: "#949195"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Maker Products",
                                id: "LGAD29"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UsageCapLine, {
                            usage: company.planUsage.enrichedProducts,
                            cap: company.plan.limits.enrichedProducts
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                fontSize: 16,
                                fontWeight: 600,
                                color: "#949195"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Groups",
                                id: "hzmswI"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UsageCapLine, {
                            usage: company.planUsage.groups,
                            cap: company.plan.limits.groups
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                fontSize: 16,
                                fontWeight: 600,
                                color: "#949195"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Sharing Hub",
                                id: "88oiPf"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                display: "grid",
                                gridColumnGap: 12,
                                gridTemplateColumns: "repeat(2, max-content)",
                                alignItems: "center",
                                color: palette/* text */.fL,
                                fontSize: 16,
                                "& > strong": {
                                    fontWeight: 600
                                }
                            },
                            children: [
                                company.plan.limits.sharingPage ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Included",
                                        id: "ULRaOP"
                                    })
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Not available",
                                        id: "cPhKTw"
                                    })
                                }),
                                company.planUsage.sharingPage ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    css: {
                                        padding: "4px 12px",
                                        color: palette/* disruptiveGreen */.fx,
                                        fontWeight: 600,
                                        fontSize: 14,
                                        backgroundColor: palette/* lightestGreen */.Vt,
                                        borderRadius: 12
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Enabled",
                                        id: "V52jNn"
                                    })
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    css: {
                                        padding: "4px 12px",
                                        color: palette/* red */.Q6,
                                        fontWeight: 600,
                                        fontSize: 14,
                                        backgroundColor: palette/* lightRed */.r6,
                                        borderRadius: 12
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Disabled",
                                        id: "tthToS"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                fontSize: 16,
                                fontWeight: 600,
                                color: "#949195"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Invite Govts.",
                                id: "2UI1Ed"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                display: "grid",
                                gridColumnGap: 12,
                                gridTemplateColumns: "repeat(2, max-content)",
                                alignItems: "center",
                                color: palette/* text */.fL,
                                fontSize: 16,
                                "& > strong": {
                                    fontWeight: 600
                                }
                            },
                            children: company.plan.limits.inviteGovernments ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Included",
                                    id: "ULRaOP"
                                })
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Not available",
                                    id: "cPhKTw"
                                })
                            })
                        }),
                        loggedInUser.role === "COMPANY_OWNER" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UsersCanAccessAccountPageToggleRow, {
                            usersCanAccessAccountPage: company.usersCanAccessAccountPage,
                            vendorId: company._id
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UsersCanRequestContentTranslationRow, {
                            suggestMyContentTranslation: company.usersCanRequestContentTranslation,
                            vendorId: company._id
                        })
                    ]
                })
            })
        ]
    });
};
function UsageCapLine(param) {
    var usage = param.usage, cap = param.cap;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            fontSize: 16,
            color: palette/* text */.fL,
            "& > strong": {
                fontWeight: 600
            }
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
            defaultMessage: "<span>{usage}</span> of <strong>{cap}</strong>",
            id: "KtgCK9",
            values: {
                usage: usage,
                cap: cap,
                span: function(text) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        children: text
                    });
                },
                strong: function(text) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                        children: text
                    });
                }
            }
        })
    });
}

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/upperFirst.js
var upperFirst = __webpack_require__(64336);
var upperFirst_default = /*#__PURE__*/__webpack_require__.n(upperFirst);
// EXTERNAL MODULE: ./node_modules/.pnpm/numeral@2.0.6/node_modules/numeral/numeral.js
var numeral = __webpack_require__(4587);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./lib/hooks/useIsMobile.ts
var useIsMobile = __webpack_require__(67459);
;// CONCATENATED MODULE: ./components/makers/PaymentHistory.tsx











function PaymentHistory(param) {
    var company = param.company;
    var isMobile = (0,useIsMobile/* default */.Z)();
    var selfie = (0,Auth/* useSelfie */.yD)();
    if (!selfie) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        "data-intercom-target": getIntercomTarget(selfie, {
            asMember: "Settings Payment History Box",
            asOwner: "Settings Payment History Box",
            asDisruptor: "Settings Payment History Box for Disruptors"
        }),
        css: {
            padding: 24,
            backgroundColor: palette/* white */.ix,
            border: "solid 0.5px #e6e8ea",
            borderRadius: 4
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                css: {
                    margin: 0,
                    color: "#212121",
                    fontWeight: 600,
                    fontSize: 20
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Invoices",
                    id: "6dqYnF"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("hr", {
                css: {
                    width: "100%",
                    marginTop: 20,
                    border: "none",
                    borderBottom: "solid 1px #e6e8ea"
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("table", {
                css: {
                    boxSizing: "border-box",
                    width: "100%",
                    borderCollapse: "collapse",
                    "> thead > tr > th": {
                        boxSizing: "border-box",
                        padding: 12,
                        color: "#949195",
                        fontWeight: 600,
                        fontSize: 16,
                        lineHeight: 1.33,
                        letterSpacing: 0.6,
                        textAlign: "left"
                    },
                    "& > tbody > tr > td": {
                        boxSizing: "border-box",
                        padding: 12,
                        color: "#949195",
                        fontSize: 14,
                        lineHeight: 1.33,
                        letterSpacing: 0.6,
                        textAlign: "left"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                            children: [
                                isMobile ? null : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                                    children: "ID"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Date",
                                        id: "P7PLVj"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Card",
                                        id: "hmnIY5"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Amount",
                                        id: "/0TOL5"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Status",
                                        id: "tzMNF3"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Receipt",
                                        id: "D0tozv"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tbody", {
                        children: [
                            company.invoices.length === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tr", {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                                    colSpan: isMobile ? 5 : 6,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: {
                                            textAlign: "center"
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "You don't have any invoices/charges.",
                                            id: "Yji5D+"
                                        })
                                    })
                                })
                            }),
                            company.invoices.map(function(invoice) {
                                var isPartiallyRefunded = invoice.amountRefunded > 0 && invoice.amountRefunded !== invoice.amount && invoice.amount !== 0;
                                var isCompletelyRefunded = invoice.amountRefunded === invoice.amount && invoice.amount !== 0;
                                var isRefunded = isPartiallyRefunded || isCompletelyRefunded;
                                var invoiceItems = invoice.items.map(function(invoiceItem) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                                                colSpan: 1,
                                                children: "\xa0"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                                                colSpan: 3,
                                                children: invoiceItem.description || "Invoice Item"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                                                colSpan: 2,
                                                children: "\xa0"
                                            })
                                        ]
                                    }, invoiceItem.id);
                                });
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                                            children: [
                                                isMobile ? null : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                                                    children: invoice.friendlyId
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                                                    children: invoice.paidAt ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IntlDateTime/* default */.Z, {
                                                        value: invoice.paidAt
                                                    }) : "N/A"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                                                    children: invoice.card ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "{cardBrand} **** {lastFourDigits}",
                                                        id: "sPwgku",
                                                        values: {
                                                            cardBrand: upperFirst_default()(invoice.card.brand),
                                                            lastFourDigits: invoice.card.lastFourDigits
                                                        }
                                                    }) : "N/A"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                                                    css: {
                                                        fontWeight: 500,
                                                        color: palette/* darkGray */.O5
                                                    },
                                                    children: isPartiallyRefunded ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                                        children: [
                                                            invoice.currency === "USD" ? "$" : null,
                                                            numeral_default()(invoice.amountRefunded / 100).format("0,00.00"),
                                                            "of",
                                                            invoice.currency === "USD" ? "$" : null,
                                                            " ",
                                                            numeral_default()(invoice.amount / 100).format("0,00.00")
                                                        ]
                                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                                        css: {
                                                            textDecoration: isCompletelyRefunded ? "line-through" : undefined
                                                        },
                                                        children: [
                                                            invoice.currency === "USD" ? "$" : null,
                                                            numeral_default()(invoice.amount / 100).format("0,00.00")
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("td", {
                                                    children: [
                                                        invoice.status === types/* IInvoiceStatus.Paid */.zB.Paid && isRefunded && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                            css: {
                                                                color: palette/* text */.fL,
                                                                fontWeight: "bold"
                                                            },
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                defaultMessage: "Refunded",
                                                                id: "Gs86nL"
                                                            })
                                                        }),
                                                        invoice.status === types/* IInvoiceStatus.Paid */.zB.Paid && !isRefunded && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                defaultMessage: "Paid",
                                                                id: "u/vOPu"
                                                            })
                                                        }),
                                                        invoice.status === types/* IInvoiceStatus.Void */.zB.Void && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                            css: {
                                                                color: palette/* red */.Q6,
                                                                fontWeight: "bold"
                                                            },
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                defaultMessage: "Voided",
                                                                id: "DqBuv6"
                                                            })
                                                        }),
                                                        invoice.status === types/* IInvoiceStatus.Uncollectible */.zB.Uncollectible && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                            css: {
                                                                color: palette/* red */.Q6,
                                                                fontWeight: "bold"
                                                            },
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                defaultMessage: "Uncollectible",
                                                                id: "45hFQt"
                                                            })
                                                        }),
                                                        invoice.status === types/* IInvoiceStatus.Open */.zB.Open && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                defaultMessage: "Open",
                                                                id: "JfG49w"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                        href: invoice.receiptUrl || "",
                                                        rel: "noopener noreferrer",
                                                        target: "_blank",
                                                        title: "Receipt for Charge ".concat(invoice.id),
                                                        css: {
                                                            color: palette/* darkSkyBlue */.Gf,
                                                            fontWeight: 600,
                                                            textDecoration: "none"
                                                        },
                                                        children: invoice.status === types/* IInvoiceStatus.Open */.zB.Open ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                            defaultMessage: "Pay",
                                                            id: "lD3+8a"
                                                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                            defaultMessage: "View",
                                                            id: "FgydNe"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        invoiceItems
                                    ]
                                }, invoice.friendlyId);
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./lib/queries/StripePlansQuery.ts
var StripePlansQuery = __webpack_require__(42462);
;// CONCATENATED MODULE: ./components/makers/ChangeBillingRecurrency.tsx







function ChangeBillingRecurrency(param) {
    var currentStripePlan = param.currentStripePlan, children = param.children;
    if (!currentStripePlan) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Query/* Query */.A, {
        query: StripePlansQuery/* default */.Z,
        children: function(param) {
            var data = param.data, loading = param.loading;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                mutation: ChangeSubscriptionPlan,
                awaitRefetchQueries: true,
                refetchQueries: (0,RefetchQueriesFixLink/* refetchQueries */.h)([
                    "Plans"
                ]),
                children: function(changeSubscriptionPlan, param) {
                    var isChangingPlans = param.loading;
                    if (!data || loading) {
                        return children({
                            isChangingPlans: false,
                            canChangeToYearly: false,
                            canChangeToMonthly: false,
                            toPlan: null,
                            changeToYearly: function() {},
                            changeToMonthly: function() {}
                        });
                    }
                    var monthlyPlan = data.stripePlans.find(function(candidate) {
                        return candidate.productId === currentStripePlan.productId && candidate.recurrency === types/* IPlanRecurrency.Monthly */.oO.Monthly;
                    });
                    var yearlyPlan = data.stripePlans.find(function(candidate) {
                        return candidate.productId === currentStripePlan.productId && candidate.recurrency === types/* IPlanRecurrency.Yearly */.oO.Yearly;
                    });
                    var canChangeToYearly = Boolean(yearlyPlan && currentStripePlan.recurrency === types/* IPlanRecurrency.Monthly */.oO.Monthly);
                    var canChangeToMonthly = Boolean(monthlyPlan && currentStripePlan.recurrency === types/* IPlanRecurrency.Yearly */.oO.Yearly);
                    return children({
                        isChangingPlans: isChangingPlans,
                        canChangeToYearly: canChangeToYearly,
                        canChangeToMonthly: canChangeToMonthly,
                        toPlan: canChangeToYearly ? yearlyPlan || null : monthlyPlan || null,
                        changeToYearly: function() {
                            if (canChangeToYearly && yearlyPlan) {
                                changeSubscriptionPlan({
                                    variables: {
                                        stripePlanId: yearlyPlan.planId
                                    }
                                });
                            }
                        },
                        changeToMonthly: function() {
                            if (canChangeToMonthly && monthlyPlan) {
                                changeSubscriptionPlan({
                                    variables: {
                                        stripePlanId: monthlyPlan.planId
                                    }
                                });
                            }
                        }
                    });
                }
            });
        }
    });
};

;// CONCATENATED MODULE: ./components/makers/ConfirmBillingRecurrencySwitch.tsx







function ConfirmBillingRecurrencySwitch(param) {
    var fromPlan = param.fromPlan, toPlan = param.toPlan, children = param.children, onConfirm = param.onConfirm;
    var intlDate = (0,useIntlDate/* default */.Z)();
    var fromRecurrency = fromPlan.recurrency === types/* IPlanRecurrency.Monthly */.oO.Monthly ? "monthly" : "yearly";
    var toRecurrency = toPlan.recurrency === types/* IPlanRecurrency.Monthly */.oO.Monthly ? "monthly" : "yearly";
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var onRequestClose = function() {
        return setIsOpen(false);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Modal */.u_, {
                isOpen: isOpen,
                ariaHideApp: false,
                onRequestClose: onRequestClose,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "grid",
                        gridRowGap: 20,
                        width: 370,
                        padding: 20
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                display: "flex",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                                    css: {
                                        fontWeight: "bold",
                                        margin: 0
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Confirm Switch",
                                        id: "jwXDYh"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* ModalClose */.A3, {
                                    onClick: onRequestClose,
                                    style: {
                                        position: "relative",
                                        top: 0,
                                        right: 0,
                                        marginLeft: "auto",
                                        cursor: "pointer"
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                            css: {
                                margin: 0,
                                fontWeight: 400,
                                fontSize: 14,
                                lineHeight: 1.33
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "You're about to switch your payment frequency from <strong>{fromRecurrency}</strong> to <strong>{toRecurrency}</strong>.",
                                id: "D3K8rN",
                                values: {
                                    fromRecurrency: fromRecurrency,
                                    toRecurrency: toRecurrency,
                                    strong: function(chunk) {
                                        return (0,strongify/* default */.Z)(chunk);
                                    }
                                }
                            })
                        }),
                        toPlan.changeDetails.prorateCost && toPlan.changeDetails.prorateCost > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                            css: {
                                margin: 0,
                                fontWeight: 400,
                                fontSize: 14,
                                lineHeight: 1.33
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "If you proceed, we'll prorate charge of <strong>{prorateCharge}</strong> now and your next payment due will be <strong>{nextPaymentDue}</strong>.",
                                id: "OGcCCo",
                                values: {
                                    prorateCharge: toPlan.changeDetails.prorateCost < 100 ? 0 : toPlan.changeDetails.prorateCost / 100,
                                    nextPaymentDue: intlDate.format(toPlan.changeDetails.firstInvoiceAfterProrateDate),
                                    strong: function(chunk) {
                                        return (0,strongify/* default */.Z)(chunk);
                                    }
                                }
                            })
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                            css: {
                                margin: 0,
                                fontWeight: 400,
                                fontSize: 14,
                                lineHeight: 1.33
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "By clicking proceed, we'll change the frequency without any charges. Your next payment will be <strong>{nextPaymentDue}</strong>.",
                                id: "fiTVxH",
                                values: {
                                    nextPaymentDue: intlDate.format(toPlan.changeDetails.proratePaymentDueDate),
                                    strong: function(chunk) {
                                        return (0,strongify/* default */.Z)(chunk);
                                    }
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                display: "grid",
                                gridColumnGap: 20,
                                gridTemplateColumns: "1fr 1fr"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                    theme: "link",
                                    color: "danger",
                                    onClick: onRequestClose,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "No. Don't Switch",
                                        id: "qqc0df"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                    onClick: function() {
                                        onConfirm();
                                        onRequestClose();
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Proceed",
                                        id: "VNX4fn"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            children({
                onConfirmBeforeSwitching: function() {
                    return setIsOpen(true);
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/makers/CurrentBill.tsx







function CurrentBill(param) {
    var stripePlan = param.stripePlan, _freeSubscription = param.freeSubscription, freeSubscription = _freeSubscription === void 0 ? false : _freeSubscription;
    var currentPeriodBill = function(recurrency) {
        if (recurrency === types/* IPlanRecurrency.Monthly */.oO.Monthly) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "Current Monthly Bill",
                id: "exEZSV"
            });
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
            defaultMessage: "Current Yearly Bill",
            id: "cnh8A0"
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    fontSize: 16,
                    fontWeight: 600,
                    color: "#949195"
                },
                children: stripePlan ? currentPeriodBill(stripePlan.recurrency) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Current Bill",
                        id: "xWHegU"
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "grid",
                    gridRowGap: 8
                },
                children: [
                    freeSubscription ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                        css: {
                            fontSize: 16,
                            fontWeight: 600,
                            color: palette/* greenSuccess */.CU
                        },
                        children: "Free"
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                        css: {
                            fontSize: 16,
                            fontWeight: 600,
                            color: palette/* text */.fL
                        },
                        children: stripePlan ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                            children: [
                                "$",
                                (stripePlan.price / 100).toFixed(2)
                            ]
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            children: "N/A"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChangeBillingRecurrency, {
                        currentStripePlan: stripePlan,
                        children: function(param) {
                            var toPlan = param.toPlan, canChangeToYearly = param.canChangeToYearly, isChangingPlans = param.isChangingPlans, changeToYearly = param.changeToYearly;
                            if (!stripePlan || !toPlan) {
                                return null;
                            }
                            if (canChangeToYearly) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ConfirmBillingRecurrencySwitch, {
                                    fromPlan: stripePlan,
                                    toPlan: toPlan,
                                    onConfirm: changeToYearly,
                                    children: function(param) {
                                        var onConfirmBeforeSwitching = param.onConfirmBeforeSwitching;
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                                            type: "button",
                                            disabled: isChangingPlans,
                                            onClick: onConfirmBeforeSwitching,
                                            css: {
                                                display: "inline-flex",
                                                boxSizing: "border-box",
                                                margin: 0,
                                                padding: 0,
                                                color: palette/* innovatorBlue */.LD,
                                                fontSize: 13,
                                                lineHeight: 1.33,
                                                backgroundColor: "transparent",
                                                border: "none",
                                                outline: "none",
                                                cursor: isChangingPlans ? "default" : "pointer",
                                                WebkitAppearance: "none"
                                            },
                                            children: isChangingPlans ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Please wait...",
                                                id: "172N3w"
                                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Switch to yearly billing",
                                                id: "l1l9w8"
                                            })
                                        });
                                    }
                                });
                            }
                            return null;
                        }
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/makers/BalanceTransactions.tsx






function BalanceTransactions(param) {
    var transactions = param.transactions, children = param.children;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Modal */.u_, {
                isOpen: isOpen,
                ariaHideApp: false,
                onRequestClose: function() {
                    return setIsOpen(false);
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "grid",
                        gridRowGap: 20,
                        width: 480,
                        padding: 20
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                display: "flex",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                                    css: {
                                        fontWeight: "bold",
                                        margin: 0
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Balance",
                                        id: "H5+NAX"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* ModalClose */.A3, {
                                    onClick: function() {
                                        return setIsOpen(false);
                                    },
                                    style: {
                                        position: "relative",
                                        top: 0,
                                        right: 0,
                                        marginLeft: "auto",
                                        cursor: "pointer"
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("table", {
                                css: {
                                    width: "100%",
                                    "& th, td": {
                                        textAlign: "left"
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                                            css: {
                                                "& th": {
                                                    color: palette/* darkGray */.O5
                                                }
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "Description",
                                                        id: "Q8Qw5B"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "Date",
                                                        id: "P7PLVj"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "Amount",
                                                        id: "/0TOL5"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tbody", {
                                        children: [
                                            transactions.length === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tr", {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                                                    css: {
                                                        color: palette/* darkGray */.O5
                                                    },
                                                    colSpan: 3,
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "No entries available.",
                                                        id: "PjWgbw"
                                                    })
                                                })
                                            }),
                                            transactions.map(function(transaction, index) {
                                                if (transaction.type === "applied_to_invoice") {
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                                                                css: {
                                                                    color: palette/* darkGray */.O5
                                                                },
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                    defaultMessage: "Applied to Invoice",
                                                                    id: "4OCsqZ"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                                                                css: {
                                                                    color: palette/* darkGray */.O5
                                                                },
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IntlDateTime/* default */.Z, {
                                                                    value: transaction.createdAt
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                                                                css: {
                                                                    color: transaction.amount < 0 ? palette/* greenSuccess */.CU : palette/* red */.Q6
                                                                },
                                                                children: formatDollarAmount(transaction.amount)
                                                            })
                                                        ]
                                                    }, "".concat(index, "/").concat(transaction.type));
                                                }
                                                if (transaction.type === "adjustment" && transaction.government) {
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                                                                css: {
                                                                    color: palette/* darkGray */.O5
                                                                },
                                                                children: transaction.description
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                                                                css: {
                                                                    color: palette/* darkGray */.O5
                                                                },
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IntlDateTime/* default */.Z, {
                                                                    value: transaction.createdAt
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                                                                css: {
                                                                    color: transaction.amount < 0 ? palette/* greenSuccess */.CU : palette/* red */.Q6
                                                                },
                                                                children: formatDollarAmount(transaction.amount)
                                                            })
                                                        ]
                                                    }, "".concat(index, "/").concat(transaction.type));
                                                }
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                                                            css: {
                                                                color: palette/* darkGray */.O5
                                                            },
                                                            children: transaction.description || "N/A"
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                                                            css: {
                                                                color: palette/* darkGray */.O5
                                                            },
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IntlDateTime/* default */.Z, {
                                                                value: transaction.createdAt
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                                                            css: {
                                                                color: transaction.amount < 0 ? palette/* greenSuccess */.CU : palette/* red */.Q6
                                                            },
                                                            children: formatDollarAmount(transaction.amount)
                                                        })
                                                    ]
                                                }, "".concat(index, "/").concat(transaction.type));
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            children(function() {
                return setIsOpen(true);
            })
        ]
    });
};
function formatDollarAmount(amount) {
    if (amount > 0) {
        return "-$".concat(Math.abs(amount / 100).toFixed(2));
    }
    return "$".concat(Math.abs(amount / 100).toFixed(2));
}

;// CONCATENATED MODULE: ./components/makers/CurrentBillingCurrentCredits.tsx






function CurrentBillingCurrentCredits(param) {
    var balanceTransactions = param.balanceTransactions, canEarnCreditsUntil = param.canEarnCreditsUntil;
    var intlDate = (0,useIntlDate/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    fontSize: 16,
                    fontWeight: 600,
                    color: "#949195"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Current Credits",
                    id: "dgdiG9"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "grid",
                    gridRowGap: 10
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            display: "grid",
                            gridTemplateColumns: "repeat(2, max-content)",
                            gridColumnGap: 6
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BalanceTransactions, {
                            transactions: balanceTransactions,
                            children: function(toggleOpen) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                                    type: "button",
                                    onClick: toggleOpen,
                                    css: {
                                        margin: 0,
                                        padding: 0,
                                        textDecoration: "underline",
                                        backgroundColor: "transparent",
                                        border: "none",
                                        outline: "none",
                                        cursor: "pointer",
                                        fontSize: 16,
                                        fontWeight: 600,
                                        color: palette/* innovatorBlue */.LD
                                    },
                                    children: CurrentBillingCurrentCredits_formatDollarAmount(balanceTransactions.length > 0 ? balanceTransactions[0].endingBalance : 0)
                                });
                            }
                        })
                    }),
                    canEarnCreditsUntil && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            css: {
                                fontSize: 13,
                                color: "#797979"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Credits can be earned until {date}",
                                id: "BL91Tr",
                                values: {
                                    date: intlDate.format(canEarnCreditsUntil)
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            css: {
                                fontSize: 13,
                                color: "#797979"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Credit will automatically be applied to next bill",
                                id: "MQolnx"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
function CurrentBillingCurrentCredits_formatDollarAmount(amount) {
    if (amount > 0) {
        return "-$".concat(Math.abs(amount / 100).toFixed(2));
    }
    return "$".concat(Math.abs(amount / 100).toFixed(2));
}

;// CONCATENATED MODULE: ./components/makers/CurrentBillingNextPaymentDue.tsx






function CurrentBillingNextPaymentDue(param) {
    var subscription = param.subscription;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    fontSize: 16,
                    fontWeight: 600,
                    color: "#949195"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Next Payment Due",
                    id: "RANMXE"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "grid",
                    gridRowGap: 8
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                        css: {
                            fontSize: 16,
                            fontWeight: 600,
                            color: palette/* text */.fL
                        },
                        children: subscription.nextPaymentDate && !subscription.freeSubscription ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IntlDateTime/* default */.Z, {
                            value: subscription.nextPaymentDate
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Not available",
                            id: "cPhKTw"
                        })
                    }),
                    subscription.nextPaymentAmount !== null && !subscription.freeSubscription && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            css: {
                                fontSize: 13,
                                color: "#797979"
                            },
                            children: subscription.collectionMethod && subscription.collectionMethod === types/* ICollectionMethod.ChargeAutomatically */.gS.ChargeAutomatically ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "We'll charge {amount} by this date",
                                id: "KtMzDM",
                                values: {
                                    amount: (subscription.nextPaymentAmount / 100).toFixed(2)
                                }
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "We'll email you an invoice by this date",
                                id: "yZROtT"
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/makers/CurrentBillingOverdueSubscription.tsx





function CurrentBullingOverdueSubscription(param) {
    var subscription = param.subscription;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    fontSize: 16,
                    fontWeight: 600,
                    color: "#949195"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Next Payment Due",
                    id: "RANMXE"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "grid",
                    gridRowGap: 8
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                        css: {
                            fontSize: 16,
                            fontWeight: 600,
                            color: palette/* text */.fL
                        },
                        children: subscription.nextPaymentAttempt ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IntlDateTime/* default */.Z, {
                            value: subscription.nextPaymentAttempt
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Not available",
                            id: "cPhKTw"
                        })
                    }),
                    subscription.nextPaymentAmount !== null && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            css: {
                                fontSize: 13,
                                color: "#ff7171"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Your payment of {payment} is overdue. Please update your payment information below to avoid an account downgrade.",
                                id: "/i/x90",
                                values: {
                                    payment: (subscription.nextPaymentAmount / 100).toFixed(2)
                                }
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/makers/CurrentBillingPaymentMethod.tsx






function CurrentBillingPaymentMethod(param) {
    var billing = param.billing;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    fontSize: 16,
                    fontWeight: 600,
                    color: "#949195"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Payment Method",
                    id: "nFQbxh"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "grid",
                    gridRowGap: 10
                },
                children: [
                    billing && billing.card ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                            css: {
                                fontSize: 16,
                                fontWeight: 600,
                                color: palette/* text */.fL
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "{cardBrand} **** {lastFourDigits}",
                                id: "sPwgku",
                                values: {
                                    cardBrand: upperFirst_default()(billing.card.brand),
                                    lastFourDigits: billing.card.lastFourDigits
                                }
                            })
                        })
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        css: {
                            fontSize: 16,
                            fontWeight: 600,
                            color: palette/* text */.fL
                        },
                        children: "N/A"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                            href: "/billing/payment",
                            passHref: true,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                href: "/billing/payment",
                                css: {
                                    color: "#005aee",
                                    fontSize: 13
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Add a new card",
                                    id: "lrfCD6"
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/makers/CurrentBillingScheduledToCancel.tsx






function CurrentBillingScheduledToCancel(param) {
    var planName = param.planName, cancellationDate = param.cancellationDate;
    var intlDate = (0,useIntlDate/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            padding: 24,
            backgroundColor: palette/* white */.ix,
            border: "solid 0.5px #e6e8ea",
            borderRadius: 4
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                css: {
                    margin: 0,
                    color: "#212121",
                    fontWeight: 600,
                    fontSize: 20
                },
                children: "Billing"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("hr", {
                css: {
                    width: "100%",
                    marginTop: 20,
                    border: "none",
                    borderBottom: "solid 1px #e6e8ea"
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    paddingTop: 10
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                    css: {
                        margin: 0,
                        fontSize: 16,
                        lineHeight: 1.33,
                        color: "#949195",
                        "& > strong": {
                            color: palette/* text */.fL,
                            fontWeight: 600
                        }
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Your <strong>{plan}</strong> plan is in the cancellation period and will be cancelled on <strong>{cancellationDate}</strong>. If you would like to reactivate it, you can click on the Reactivate {plan} button above.",
                        id: "EE4kbk",
                        values: {
                            plan: planName,
                            cancellationDate: intlDate.format(cancellationDate),
                            strong: function(chunk) {
                                return (0,strongify/* default */.Z)(chunk);
                            }
                        }
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/makers/CurrentBillingTrialPeriod.tsx





function CurrentBillingTrialPeriod(param) {
    var trialPeriod = param.trialPeriod, subscribedAt = param.subscribedAt;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    fontSize: 16,
                    fontWeight: 600,
                    color: "#949195"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Trial Period",
                    id: "CEvh7B"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    display: "grid",
                    gridRowGap: 8
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("strong", {
                    css: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: palette/* text */.fL
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "{count} {count, plural, one {day} other {days}}, started on",
                            id: "/nd5BH",
                            values: {
                                count: trialPeriod
                            }
                        }),
                        " ",
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IntlDateTime/* default */.Z, {
                            value: subscribedAt
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/makers/CurrentBilling.tsx














function CurrentBilling(param) {
    var company = param.company;
    var selfie = (0,Auth/* useSelfie */.yD)();
    if (!selfie) {
        return null;
    }
    if (!company.plan.limits.inviteGovernments) {
        return null;
    }
    if (company.subscription && company.stripePlan && company.subscription.__typename === "ScheduledToCancelSubscription") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CurrentBillingScheduledToCancel, {
            planName: company.stripePlan.displayName,
            cancellationDate: company.subscription.willCancelAt
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        "data-intercom-target": getIntercomTarget(selfie, {
            asMember: "Settings Billing Box",
            asOwner: "Settings Billing Box",
            asDisruptor: "Settings Billing Box for Disruptors"
        }),
        css: {
            padding: 24,
            backgroundColor: palette/* white */.ix,
            border: "solid 0.5px #e6e8ea",
            borderRadius: 4
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                css: {
                    margin: 0,
                    color: "#212121",
                    fontWeight: 600,
                    fontSize: 20
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Billing",
                    id: "Tbo377"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("hr", {
                css: {
                    width: "100%",
                    marginTop: 20,
                    border: "none",
                    borderBottom: "solid 1px #e6e8ea"
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    paddingTop: 20
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: (0,utils_mediaQueries/* default */.Z)({
                        display: "grid",
                        gridTemplateColumns: [
                            "1fr",
                            "1fr",
                            "1fr",
                            "max-content 1fr"
                        ],
                        gridColumnGap: 40,
                        gridRowGap: 30
                    }),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CurrentBill, {
                            stripePlan: company.stripePlan,
                            freeSubscription: company.subscription && company.subscription.__typename === "ActiveSubscription" && company.subscription.freeSubscription
                        }),
                        company.subscription && company.subscription.__typename === "ActiveSubscription" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CurrentBillingNextPaymentDue, {
                            subscription: company.subscription
                        }),
                        company.subscription && company.subscription.__typename === "OverdueSubscription" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CurrentBullingOverdueSubscription, {
                            subscription: company.subscription
                        }),
                        company.subscription && company.subscription.__typename === "ActiveSubscription" && company.subscription.trialPeriod !== null && company.subscription.trialPeriod > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CurrentBillingTrialPeriod, {
                            trialPeriod: company.subscription.trialPeriod,
                            subscribedAt: company.subscription.subscribedAt
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CurrentBillingPaymentMethod, {
                            billing: company.billing
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CurrentBillingCurrentCredits, {
                            balanceTransactions: company.balanceTransactions,
                            canEarnCreditsUntil: company.canEarnCreditsUntil
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/makers/VendorSponsorings.tsx








function VendorSponsorings(param) {
    var company = param.company;
    var selfie = (0,Auth/* useSelfie */.yD)();
    var intlDate = (0,useIntlDate/* default */.Z)();
    if (!selfie) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            padding: 24,
            backgroundColor: palette/* white */.ix,
            border: "solid 0.5px #e6e8ea",
            borderRadius: 4
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                css: {
                    margin: 0,
                    color: "#212121",
                    fontWeight: 600,
                    fontSize: 20
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Collection Sponsorships",
                    id: "swKtQM"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("hr", {
                css: {
                    width: "100%",
                    marginTop: 20,
                    border: "none",
                    borderBottom: "solid 1px #e6e8ea"
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("table", {
                css: {
                    boxSizing: "border-box",
                    width: "100%",
                    borderCollapse: "collapse",
                    "> thead > tr > th": {
                        boxSizing: "border-box",
                        padding: 12,
                        color: "#949195",
                        fontWeight: 600,
                        fontSize: 16,
                        lineHeight: 1.33,
                        letterSpacing: 0.6,
                        textAlign: "left"
                    },
                    "& > tbody > tr > td": {
                        boxSizing: "border-box",
                        padding: 12,
                        color: "#949195",
                        fontSize: 14,
                        lineHeight: 1.33,
                        letterSpacing: 0.6,
                        textAlign: "left"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Type",
                                        id: "+U6ozc"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Level",
                                        id: "y1Qr81"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Collections",
                                        id: "ulh3kf"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Expiration/Renew date",
                                        id: "EkQmPU"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Active",
                                        id: "3a5wL8"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tbody", {
                        children: [
                            company.sponsoringSales.length === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tr", {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                                    colSpan: 5,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: {
                                            textAlign: "center"
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "You don't have any sponsorships.",
                                            id: "ChGDFW"
                                        })
                                    })
                                })
                            }),
                            company.sponsoringSales.map(function(sale) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                                            children: sale.type === types/* ICollectionSponsoringType.Curated */.Ns.Curated ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Curated",
                                                id: "0xVT+0"
                                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Custom Collection",
                                                id: "l2nMr1"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                                            children: sale.sponsorshipLevel === types/* ICollectionSponsoringSponsorshipLevel.Product */.G6.Product ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Product",
                                                id: "x/ZVlU"
                                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Vendor",
                                                id: "dU1t5Z"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                                            children: sale.includedCollections.map(function(collection) {
                                                return collection.name;
                                            }).join(", ")
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                                            css: {
                                                fontWeight: 500,
                                                color: palette/* darkGray */.O5
                                            },
                                            children: sale.__typename === "LumpSumCollectionSponsoringSale" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IntlDateTime/* default */.Z, {
                                                value: sale.expirationDate
                                            }) : sale.renewsAt ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IntlDateTime/* default */.Z, {
                                                value: sale.renewsAt
                                            }) : sale.cancelsAt ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Cancels on {date}",
                                                id: "+DFyAR",
                                                values: {
                                                    date: intlDate.format(sale.cancelsAt)
                                                }
                                            }) : "N/A"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Yes",
                                                id: "a5msuh"
                                            })
                                        })
                                    ]
                                }, sale._id);
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/spacings.tsx
var spacings = __webpack_require__(52126);
;// CONCATENATED MODULE: ./components/makers/CompanyAccountBillingInfo.tsx












function CompanyAccountBillingInfo(param) {
    var vendor = param.vendor;
    var user = (0,Auth/* useSelfie */.yD)();
    var isMobile = (0,useIsMobile/* default */.Z)();
    if (!canAccessBillingInfo(user, vendor.usersCanAccessAccountPage, vendor.viewerIsMember)) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Redirect/* default */.Z, {
            to: "/"
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Query/* Query */.A, {
        query: CompanyAccountBillingInfoQuery,
        variables: {
            slug: user.company.slug
        },
        children: function(param) {
            var data = param.data, loading = param.loading;
            if (loading) {
                return null;
            }
            if (!data || !data.company) {
                return null;
            }
            var company = data.company;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CurrentPlanAndUsage, {
                        company: company
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                        mt: 20,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CurrentBilling, {
                            company: company
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                        mt: 20,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorSponsorings, {
                            company: company
                        })
                    }),
                    isMobile ? null : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                        mt: 20,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PaymentHistory, {
                            company: company
                        })
                    })
                ]
            });
        }
    });
};
function canAccessBillingInfo(user, usersCanAccessAccountPage, viewerIsMember) {
    if (!user) {
        return false;
    }
    if (user.__typename !== "VendorUser") {
        return false;
    }
    if (!user.company) {
        return false;
    }
    if (user.role !== "COMPANY_OWNER" && (!usersCanAccessAccountPage || !viewerIsMember)) {
        return false;
    }
    return true;
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(49980);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+project@2.37.38_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/project/index.ts + 59 modules
var project = __webpack_require__(78062);
;// CONCATENATED MODULE: ./lib/queries/VendorPendingVerificationProjects.ts

function VendorPendingVerificationProjects_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query VendorPendingVerificationProjects($slug: String!, $cursor: Cursor, $limit: Int = 6) {\n    company(slug: $slug) {\n      _id\n      projectsPendingVerification(cursor: $cursor, limit: $limit) {\n        items {\n          ...ProjectCardFields\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    VendorPendingVerificationProjects_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var VendorPendingVerificationProjects = ((0,lib/* gql */.Ps)(VendorPendingVerificationProjects_templateObject(), project/* ProjectCardFieldsFragment */.SS));

;// CONCATENATED MODULE: ./lib/queries/VendorProjectsQuery.ts

function VendorProjectsQuery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query VendorProjects($slug: String!, $cursor: Cursor, $limit: Int = 6) {\n    company(slug: $slug) {\n      _id\n      slug\n      projects(cursor: $cursor, limit: $limit) {\n        items {\n          ...ProjectCardFields\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    VendorProjectsQuery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var VendorProjectsQuery = ((0,lib/* gql */.Ps)(VendorProjectsQuery_templateObject(), project/* ProjectCardFieldsFragment */.SS));

// EXTERNAL MODULE: ./src/components/project/CreateProjectModal.tsx
var CreateProjectModal = __webpack_require__(23115);
// EXTERNAL MODULE: ./src/components/project/listing/ProjectCards.tsx
var ProjectCards = __webpack_require__(70455);
// EXTERNAL MODULE: ./src/components/project/listing/ProjectsListing.tsx
var ProjectsListing = __webpack_require__(93921);
// EXTERNAL MODULE: ./components/form/resources/ShowMoreButtonWithIcon.tsx + 1 modules
var ShowMoreButtonWithIcon = __webpack_require__(38248);
;// CONCATENATED MODULE: ./components/icons/PenIcon.tsx




function PenIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 18,
        height: 18,
        viewBox: "0 0 18 18"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: "#797979",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M15.749.12a.412.412 0 00-.296-.12.43.43 0 00-.296.12L9.189 6.09l-.017.017-.008.008c-.008.013-.02.025-.03.038 0 .004-.003.004-.003.008-.009.012-.013.02-.021.033-.004.004-.004.009-.008.013-.005.012-.009.02-.013.033 0 .004-.004.004-.004.008L8.022 9.454a.41.41 0 00.1.425.42.42 0 00.43.1l3.196-1.067c.004 0 .004 0 .008-.004a.148.148 0 00.038-.017.015.015 0 00.008-.004l.042-.025c.012-.008.025-.02.037-.03.004-.003.008-.003.008-.008.005-.004.013-.008.017-.016l5.972-5.973a.415.415 0 000-.588L15.748.12zM9.664 7.158l1.18 1.18-1.768.587.588-1.767zm1.95.771l-1.541-1.542 5.38-5.381 1.542 1.542-5.38 5.381z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M14.59 7.887a.41.41 0 00-.41.41v7.655a1.232 1.232 0 01-1.228 1.229H2.048A1.233 1.233 0 01.82 15.952V5.048A1.233 1.233 0 012.05 3.82h7.655a.41.41 0 100-.819H2.048A2.049 2.049 0 000 5.048v10.904C0 17.082.917 18 2.048 18h10.904A2.049 2.049 0 0015 15.952V8.296a.41.41 0 00-.41-.41z"
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ./components/profile/NoProjectsBox.tsx
var NoProjectsBox = __webpack_require__(88925);
// EXTERNAL MODULE: ./components/vendor/profile/UpgradeAccountBanner.tsx + 1 modules
var UpgradeAccountBanner = __webpack_require__(4758);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(94614);
;// CONCATENATED MODULE: ./components/profile/ProfileBox.tsx






function ProfileBox(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        css: {
            backgroundColor: palette/* white */.ix,
            borderRadius: 5,
            border: "solid 1px ".concat(palette/* lightestGray */.v2)
        }
    }, props), {
        children: children
    }));
};

;// CONCATENATED MODULE: ./components/icons/VendorProfile/ProjectsIcon.tsx





function ProjectsIcon(_param) {
    var color = _param.color, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 27 26",
        width: 27,
        height: 26
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fill: "none",
            stroke: color,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.58,
            d: "M14.578 1.573l2.793 5.882c.163.35.486.597.865.664l6.179.933a1.26 1.26 0 01.632 2.117l-4.429 4.492a1.292 1.292 0 00-.347 1.11l1.05 6.38a1.185 1.185 0 01-1.655 1.312l-5.59-3.058a1.067 1.067 0 00-1.043 0L7.44 24.463a1.185 1.185 0 01-1.655-1.312l1.055-6.38a1.292 1.292 0 00-.344-1.11l-4.433-4.492a1.26 1.26 0 01.632-2.117l6.18-.933c.378-.067.7-.315.864-.664l2.793-5.882a1.114 1.114 0 012.047 0z"
        })
    }));
};

;// CONCATENATED MODULE: ./components/project/NoProjectConnectionsBox.tsx







function NoProjectConnectionsBox() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProfileBox, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 26
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectsIcon, {
                    width: 33,
                    height: 33,
                    color: palette/* mediumGray */.rF
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                    ml: 14,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        css: {
                            fontSize: 18,
                            fontWeight: 500,
                            color: palette/* mediumGray */.rF
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "No Project Connections",
                            id: "PVVUQM"
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/project/FullVendorProjects.tsx






















function FullVendorProjects(param) {
    var vendor = param.vendor, _showUpgradeBanner = param.showUpgradeBanner, showUpgradeBanner = _showUpgradeBanner === void 0 ? true : _showUpgradeBanner, _showPlaceholder = param.showPlaceholder, showPlaceholder = _showPlaceholder === void 0 ? true : _showPlaceholder;
    if (vendor.plan.limits.projectsPerMonth === 0 && vendor.viewerIsMember) {
        return showUpgradeBanner ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpgradeAccountBanner/* default */.Z, {}) : null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorProjects, {
                vendor: vendor,
                showPlaceholder: showPlaceholder
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PendingVerificationProjects, {
                vendor: vendor
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RelatedProjects, {
                vendor: vendor
            })
        ]
    });
};
function VendorProjects(param) {
    var vendor = param.vendor, showPlaceholder = param.showPlaceholder;
    var ref = (0,react.useState)(false), createProjectModalOpen = ref[0], setCreateProjectModalOpen = ref[1];
    var intl = (0,useIntl/* default */.Z)();
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CreateProjectModal/* default */.Z, {
                isOpen: createProjectModalOpen,
                onClose: function() {
                    return setCreateProjectModalOpen(false);
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    display: "grid",
                    gridRowGap: 28
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Query/* Query */.A, {
                    notifyOnNetworkStatusChange: true,
                    query: VendorProjectsQuery,
                    variables: {
                        slug: vendor.slug,
                        cursor: null,
                        limit: 6
                    },
                    children: function(param) {
                        var data = param.data, loading = param.loading, fetchMore = param.fetchMore;
                        var ref;
                        if (!data || !data.company || !data.company.projects) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoProjectConnectionsBox, {});
                        }
                        var projects = data.company.projects;
                        if (!projects.items) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoProjectConnectionsBox, {});
                        }
                        if (projects.items.length === 0 && vendor.viewerIsMember && showPlaceholder) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        display: "grid",
                                        gridRowGap: 28,
                                        "&:not(:first-of-type)": {
                                            marginTop: 16
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoProjectsBox/* default */.Z, {
                                        onAddProject: function() {
                                            return setCreateProjectModalOpen(true);
                                        },
                                        text: intl.formatMessage({
                                            defaultMessage: "Start showcasing your impact by adding projects to your products.",
                                            id: "aHjadX"
                                        }),
                                        dataIntercomTarget: "Vendor Projects",
                                        addButtonIntercomTarget: "Vendor Add Project",
                                        title: intl.formatMessage({
                                            defaultMessage: "Share your projects",
                                            id: "k0Ak8L"
                                        }),
                                        buttonText: intl.formatMessage({
                                            defaultMessage: "Add Project",
                                            id: "BAZtPp"
                                        })
                                    })
                                })
                            });
                        }
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                display: "grid",
                                gridRowGap: 28
                            },
                            children: projects.items.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                children: [
                                    vendor.viewerIsMember && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                        mb: 28,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Button */.zx, {
                                                theme: "secondary",
                                                size: "large",
                                                onClick: function() {
                                                    return setCreateProjectModalOpen(true);
                                                },
                                                color: palette/* lightestGray */.v2,
                                                textColor: palette/* darkGray */.O5,
                                                css: {
                                                    background: "#fff",
                                                    fontSize: 16,
                                                    display: "inline-flex",
                                                    alignItems: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PenIcon, {}),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                        css: {
                                                            marginLeft: 4,
                                                            height: 15
                                                        },
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                            defaultMessage: "New Projects",
                                                            id: "TFZz3g"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectCards/* default */.Z, {
                                        onModalClose: function() {
                                            var ref;
                                            router.push("/vendors/[vendorSlug]/[[...content]]", "/vendors/".concat(data === null || data === void 0 ? void 0 : (ref = data.company) === null || ref === void 0 ? void 0 : ref.slug, "/projects"));
                                        },
                                        projects: projects.items,
                                        gridProps: {
                                            columns: [
                                                1,
                                                1,
                                                2
                                            ],
                                            spacingY: 6
                                        }
                                    }),
                                    ((ref = data.company.projects.pageInfo) === null || ref === void 0 ? void 0 : ref.hasNextPage) && !loading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Flex */.kC, {
                                        justifyContent: "center",
                                        mt: 6,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShowMoreButtonWithIcon/* default */.Z, {
                                            loading: loading,
                                            onClick: function() {
                                                if (!projects.pageInfo || !projects.pageInfo.endCursor) {
                                                    return null;
                                                }
                                                fetchMore({
                                                    variables: {
                                                        slug: vendor.slug,
                                                        cursor: projects.pageInfo.endCursor,
                                                        limit: 6
                                                    },
                                                    updateQuery: function(previousQueryResult, param) {
                                                        var fetchMoreResult = param.fetchMoreResult;
                                                        if (!fetchMoreResult || !fetchMoreResult.company || !fetchMoreResult.company.projects.items || !previousQueryResult || !previousQueryResult.company || !previousQueryResult.company.projects || !previousQueryResult.company.projects.items) {
                                                            return previousQueryResult;
                                                        }
                                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, previousQueryResult), {
                                                            company: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, previousQueryResult.company), {
                                                                projects: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, previousQueryResult.company.projects, fetchMoreResult.company.projects), {
                                                                    items: previousQueryResult.company.projects.items.concat(fetchMoreResult.company.projects.items)
                                                                })
                                                            })
                                                        });
                                                    }
                                                });
                                            }
                                        })
                                    })
                                ]
                            })
                        });
                    }
                })
            })
        ]
    });
}
function RelatedProjects(param) {
    var vendor = param.vendor;
    var router = (0,next_router.useRouter)();
    if (vendor.relatedProjects.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                    css: {
                        margin: "32px 0 16px 0",
                        color: palette/* sealBlue */.N9,
                        fontWeight: 400,
                        fontSize: 16
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Related Projects",
                        id: "jvAQ49"
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectCards/* default */.Z, {
                onModalClose: function() {
                    router.push("/vendors/[vendorSlug]/[[...content]]", "/vendors/".concat(vendor.slug, "/projects"));
                },
                projects: vendor.relatedProjects,
                gridProps: {
                    columns: [
                        1,
                        1,
                        2
                    ],
                    spacingY: 6
                }
            })
        ]
    });
}
function PendingVerificationProjects(param) {
    var vendor = param.vendor;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Query/* Query */.A, {
        query: VendorPendingVerificationProjects,
        variables: {
            slug: vendor.slug,
            cursor: null
        },
        children: function(param) {
            var data = param.data, loading = param.loading, fetchMore = param.fetchMore;
            var ref;
            if (!data || !data.company || !data.company.projectsPendingVerification.items) {
                return null;
            }
            var projectsPendingVerification = data.company.projectsPendingVerification;
            if (!projectsPendingVerification.items || projectsPendingVerification.items.length === 0) {
                return null;
            }
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    display: "grid",
                    gridRowGap: 24
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                margin: "32px 0 16px 0"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                                    css: {
                                        margin: 0,
                                        color: palette/* sealBlue */.N9,
                                        fontWeight: 600,
                                        fontSize: 18
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Pending Verification",
                                        id: "V5sK5b"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                                    css: {
                                        color: palette/* sealBlue */.N9,
                                        fontWeight: 400,
                                        fontSize: 16
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Projects will be published after a Govlaunch team member reviews them.",
                                        id: "42OjvQ"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectsListing/* default */.Z, {
                            projects: projectsPendingVerification.items,
                            onModalClose: function() {
                                router.push("/vendor?vendorSlug=".concat(vendor.slug, "&content=projects"), "/vendors/".concat(vendor.slug, "/projects"));
                            },
                            gridProps: {
                                columns: [
                                    1,
                                    2
                                ],
                                spacingY: 6
                            },
                            hasNextPage: ((ref = projectsPendingVerification.pageInfo) === null || ref === void 0 ? void 0 : ref.hasNextPage) || false,
                            onLoadMore: function() {
                                if (projectsPendingVerification.pageInfo && projectsPendingVerification.pageInfo.endCursor) {
                                    fetchMore({
                                        variables: {
                                            cursor: projectsPendingVerification.pageInfo.endCursor
                                        },
                                        updateQuery: function(previousQueryResult, param) {
                                            var fetchMoreResult = param.fetchMoreResult;
                                            if (!previousQueryResult.company || !previousQueryResult.company.projectsPendingVerification.items || !fetchMoreResult || !fetchMoreResult.company || !fetchMoreResult.company.projectsPendingVerification || !fetchMoreResult.company.projectsPendingVerification.items) {
                                                return previousQueryResult;
                                            }
                                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, previousQueryResult), {
                                                company: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, previousQueryResult.company), {
                                                    projectsPendingVerification: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fetchMoreResult.company.projectsPendingVerification), {
                                                        items: (0,_to_consumable_array/* default */.Z)(previousQueryResult.company.projectsPendingVerification.items).concat((0,_to_consumable_array/* default */.Z)(fetchMoreResult.company.projectsPendingVerification.items))
                                                    })
                                                })
                                            });
                                        }
                                    });
                                }
                            },
                            loading: loading
                        })
                    ]
                })
            });
        }
    });
}

// EXTERNAL MODULE: ./components/vendor/form/EditVendorForm.tsx + 10 modules
var EditVendorForm = __webpack_require__(94254);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/index.js + 44 modules
var _govlaunch_select = __webpack_require__(3104);
;// CONCATENATED MODULE: ./lib/queries/VendorGovernmentConnectionsQuery.ts

function VendorGovernmentConnectionsQuery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query VendorGovernmentConnections($slug: String!, $cursor: Cursor, $product: ObjectId) {\n    company(slug: $slug) {\n      _id\n      governmentConnectionsCount\n      governmentConnections(limit: 21, cursor: $cursor, product: $product) {\n        items {\n          _id\n          slug\n          logo\n          name\n          currency\n          budget\n          isInnovator\n          city {\n            _id\n            name\n            population\n            country\n            countryName\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n"
    ]);
    VendorGovernmentConnectionsQuery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var VendorGovernmentConnectionsQuery = ((0,lib/* gql */.Ps)(VendorGovernmentConnectionsQuery_templateObject()));

// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+profile-picture@1.4.1/node_modules/@govlaunch/profile-picture/index.js + 1 modules
var profile_picture = __webpack_require__(77876);
;// CONCATENATED MODULE: ./components/icons/BudgetIcon.tsx




var BudgetIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "aria-hidden": "true",
        viewBox: "0 0 496 512"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fill: "currentColor",
            d: "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm24 376v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16.2c-16.5-.6-32.6-5.8-46.4-15.1-8.7-5.9-10-18.1-2.3-25.2l12-11.3c5.4-5.1 13.3-5.4 19.7-1.6 6.1 3.6 12.9 5.4 19.9 5.4h45c11.3 0 20.5-10.5 20.5-23.4 0-10.6-6.3-19.9-15.2-22.7L205 268c-29-8.8-49.2-37-49.2-68.6 0-39.3 30.6-71.3 68.2-71.4v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16.2c16.5.6 32.6 5.8 46.4 15.1 8.7 5.9 10 18.1 2.3 25.2l-12 11.3c-5.4 5.1-13.3 5.4-19.7 1.6-6.1-3.6-12.9-5.4-19.9-5.4h-45c-11.3 0-20.5 10.5-20.5 23.4 0 10.6 6.3 19.9 15.2 22.7l72 21.9c29 8.8 49.2 37 49.2 68.6.2 39.3-30.4 71.2-68 71.4z"
        })
    }));
};
/* harmony default export */ var icons_BudgetIcon = (BudgetIcon);

;// CONCATENATED MODULE: ./components/icons/PeopleIcon.tsx




var PeopleIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "aria-hidden": "true",
        viewBox: "0 0 640 512"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fill: "currentColor",
            d: "M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
        })
    }));
};
/* harmony default export */ var icons_PeopleIcon = (PeopleIcon);

// EXTERNAL MODULE: ./components/government/GovernmentBudget.tsx
var GovernmentBudget = __webpack_require__(47128);
// EXTERNAL MODULE: ./components/government/GovernmentPopulation.tsx
var GovernmentPopulation = __webpack_require__(20838);
;// CONCATENATED MODULE: ./components/government/GovernmentRichLink.tsx












function GovernmentRichLink(param) {
    var government = param.government, popoverBind = param.popoverBind, popoverInnerRef = param.popoverInnerRef;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: "/governments/[governmentSlug]/[[...content]]",
        as: "/governments/".concat(government.slug),
        passHref: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, popoverBind), {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "flex",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                        position: "relative",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                                xsmall: true,
                                name: government.name,
                                image: government.logo,
                                innovator: government.isInnovator
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Tooltip */.u, {
                                maxWidth: "230px",
                                textAlign: "center",
                                "aria-label": government.name,
                                label: government.city.countryName,
                                bg: "blue.600",
                                py: 2,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                    as: "span",
                                    position: "absolute",
                                    bottom: 1,
                                    right: -2,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CountryFlag */.AW, {
                                        countryCode: government.city.country,
                                        width: 24,
                                        height: 14
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            marginLeft: 10
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                ref: popoverInnerRef,
                                css: {
                                    margin: 0,
                                    fontSize: 14,
                                    color: palette/* text */.fL,
                                    fontWeight: 400,
                                    display: "flex",
                                    alignItems: "center"
                                },
                                children: government.name
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    display: "grid",
                                    gridAutoColumns: "max-content",
                                    gridAutoFlow: "column",
                                    gridColumnGap: 4,
                                    alignItems: "center"
                                },
                                children: [
                                    government.city.population && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                        css: {
                                            display: "inline-grid",
                                            gridColumnGap: 4,
                                            gridTemplateColumns: "max-content max-content",
                                            alignItems: "center",
                                            color: palette/* sealBlue */.N9,
                                            fontSize: 12
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentPopulation/* default */.Z, {
                                                population: government.city.population
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_PeopleIcon, {
                                                width: 14,
                                                height: 10
                                            })
                                        ]
                                    }),
                                    !!government.city.population && !!government.budget && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                        css: {
                                            color: palette/* sealBlue */.N9,
                                            fontSize: 12
                                        },
                                        children: "/"
                                    }),
                                    !!government.budget && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                        css: {
                                            display: "inline-grid",
                                            gridColumnGap: 4,
                                            gridTemplateColumns: "max-content max-content",
                                            alignItems: "center",
                                            color: palette/* sealBlue */.N9,
                                            fontSize: 12
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentBudget/* default */.Z, {
                                                budget: government.budget,
                                                currency: government.currency
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_BudgetIcon, {
                                                width: 10,
                                                height: 10
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        }))
    });
};

;// CONCATENATED MODULE: ./components/icons/GovernmentIcon.tsx




var GovernmentIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 -1 512 511",
        width: 24,
        height: 24
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M73.766 211.945h49.703v201.97H73.766zm0 0",
                fill: "#e6f1fa"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M101.469 211.945h22v201.97h-22zm0 0",
                fill: "#cee4f7"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M471.367 157.102L259.414 10.363a5.998 5.998 0 00-6.828 0L40.636 157.102v16.566h430.731zm0 0",
                fill: "#e6f1fa"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M259.414 10.363a5.998 5.998 0 00-6.828 0L245 15.617l204.367 141.485v16.566h22v-16.566zm0 0",
                fill: "#cee4f7"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M272.566 107.402c0 9.149-7.414 16.567-16.566 16.567-9.148 0-16.566-7.418-16.566-16.567 0-9.152 7.418-16.57 16.566-16.57 9.152 0 16.566 7.418 16.566 16.57zm0 0",
                fill: "#feda43"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M134.035 223.367H63.2c-3.312 0-6-2.687-6-6v-37.922h82.836v37.922c0 3.313-2.687 6-6 6zm0 0",
                fill: "#537d91"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M118.035 179.445v37.922c0 3.313-2.687 6-6 6h22c3.313 0 6-2.687 6-6v-37.922zm0 0",
                fill: "#45738a"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M134.035 402.496H63.2c-3.312 0-6 2.684-6 6v37.918h82.836v-37.918c0-3.316-2.687-6-6-6zm0 0",
                fill: "#537d91"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M118.035 446.414v-37.922c0-3.312-2.687-6-6-6h22c3.313 0 6 2.688 6 6v37.922zm0 0",
                fill: "#45738a"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M231.148 211.945h49.704v201.97h-49.704zm0 0",
                fill: "#e6f1fa"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M258.852 211.945h22v201.97h-22zm0 0",
                fill: "#cee4f7"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M291.418 223.367h-70.832c-3.316 0-6-2.687-6-6v-37.922h82.832v37.922c0 3.313-2.688 6-6 6zm0 0",
                fill: "#537d91"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M275.418 179.445v37.922c0 3.313-2.688 6-6 6h22c3.312 0 6-2.687 6-6v-37.922zm0 0",
                fill: "#45738a"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M291.418 402.496h-70.832c-3.316 0-6 2.684-6 6v37.918h82.832v-37.918c0-3.316-2.688-6-6-6zm0 0",
                fill: "#537d91"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M275.418 446.414v-37.922c0-3.312-2.688-6-6-6h22c3.312 0 6 2.688 6 6v37.922zm0 0",
                fill: "#45738a"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M388.531 211.945h49.703v201.97h-49.703zm0 0",
                fill: "#e6f1fa"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M416.234 211.945h22v201.97h-22zm0 0",
                fill: "#cee4f7"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M448.8 223.367h-70.835c-3.313 0-6-2.687-6-6v-37.922H454.8v37.922c0 3.313-2.688 6-6 6zm0 0",
                fill: "#537d91"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M432.8 179.445v37.922c0 3.313-2.687 6-6 6h22c3.313 0 6-2.687 6-6v-37.922zm0 0",
                fill: "#45738a"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M448.8 402.496h-70.835c-3.313 0-6 2.684-6 6v37.918H454.8v-37.918c0-3.316-2.688-6-6-6zm0 0",
                fill: "#537d91"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M432.8 446.414v-37.922c0-3.312-2.687-6-6-6h22c3.313 0 6 2.688 6 6v37.922zm0 0",
                fill: "#45738a"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M481.934 190.234H30.066c-3.312 0-6-2.687-6-6v-21.132c0-3.317 2.688-6 6-6h451.868c3.312 0 6 2.683 6 6v21.132c0 3.313-2.688 6-6 6zm0 0",
                fill: "#feda43"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M481.934 157.102h-22c3.312 0 6 2.683 6 6v21.132c0 3.313-2.688 6-6 6h22c3.312 0 6-2.687 6-6v-21.132c0-3.317-2.688-6-6-6zm0 0",
                fill: "#fdb53e"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M487.934 485.328H24.066v-43.7c0-3.312 2.688-6 6-6h451.868c3.312 0 6 2.688 6 6zm0 0",
                fill: "#feda43"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M481.934 435.629h-22c3.312 0 6 2.687 6 6v43.7h22v-43.7c0-3.313-2.688-6-6-6zm0 0",
                fill: "#fdb53e"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M498.5 501.895h-485c-3.313 0-6-2.688-6-6v-21.133c0-3.313 2.688-6 6-6h485c3.313 0 6 2.687 6 6v21.133c0 3.312-2.688 6-6 6zm0 0",
                fill: "#e6f1fa"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M498.5 468.762h-22c3.313 0 6 2.687 6 6v21.133c0 3.312-2.688 6-6 6h22c3.313 0 6-2.688 6-6v-21.133c0-3.313-2.688-6-6-6zm0 0",
                fill: "#cee4f7"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M256 131.469c13.273 0 24.066-10.797 24.066-24.067 0-13.273-10.796-24.07-24.066-24.07s-24.066 10.797-24.066 24.07c0 13.27 10.796 24.067 24.066 24.067zm0-33.137c5 0 9.066 4.07 9.066 9.07 0 4.996-4.066 9.067-9.066 9.067s-9.066-4.067-9.066-9.067 4.066-9.07 9.066-9.07zm0 0"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M504.5 461.262h-9.066v-25.633c0-4.14-3.36-7.5-7.5-7.5H462.3v-25.633a7.5 7.5 0 00-7.5-7.5h-9.063V230.867h9.063a7.5 7.5 0 007.5-7.5v-25.633h25.633a7.5 7.5 0 007.5-7.5v-33.132a7.5 7.5 0 00-7.5-7.5H473.71L260.27 1.832a7.504 7.504 0 00-8.54 0L38.293 149.602H24.066a7.5 7.5 0 00-7.5 7.5v33.132c0 4.141 3.36 7.5 7.5 7.5H49.7v25.633c0 4.14 3.36 7.5 7.5 7.5h9.067v164.13h-9.067a7.5 7.5 0 00-7.5 7.5v25.632H24.066c-4.14 0-7.5 3.36-7.5 7.5v25.633H7.5a7.497 7.497 0 00-7.5 7.5v33.129c0 4.144 3.355 7.5 7.5 7.5h497c4.145 0 7.5-3.356 7.5-7.5v-33.13a7.5 7.5 0 00-7.5-7.5zm-57.2-33.133H379.47v-18.133H447.3zm-51.269-33.133V230.867h34.703v164.13zm51.27-179.129h-67.832v-18.133H447.3zm-75.332 15h9.062v164.13h-9.062a7.497 7.497 0 00-7.5 7.5v25.632h-59.551v-25.633a7.5 7.5 0 00-7.5-7.5h-9.066V230.867h9.066c4.14 0 7.5-3.36 7.5-7.5v-25.633h59.55v25.633a7.5 7.5 0 007.5 7.5zm-149.883-33.133h67.832v18.133h-67.832zm16.562 33.133h34.704v164.13h-34.704zm51.27 179.13v18.132h-67.832v-18.133zM31.566 164.601H162.45a7.5 7.5 0 007.5-7.5c0-4.145-3.355-7.5-7.5-7.5H64.645L256 17.122l191.36 132.48H192.45a7.5 7.5 0 100 15h287.984v18.132H31.566zM64.7 197.734h67.836v18.133H64.7zm51.27 33.133v164.13H81.266v-164.13zm-51.27 179.13h67.836v18.132H64.7zm75.336-15h-9.066v-164.13h9.066c4.14 0 7.5-3.36 7.5-7.5v-25.633h59.55v25.633a7.5 7.5 0 007.5 7.5h9.063v164.13h-9.062a7.497 7.497 0 00-7.5 7.5v25.632h-59.55v-25.633a7.5 7.5 0 00-7.5-7.5zM31.566 443.128h448.868v18.133H31.566zM497 494.395H15v-18.133h482zm0 0"
            })
        ]
    }));
};
/* harmony default export */ var icons_GovernmentIcon = (GovernmentIcon);

// EXTERNAL MODULE: ./components/profile/ShowMore.tsx
var ShowMore = __webpack_require__(53849);
// EXTERNAL MODULE: ./components/icons/ProjectIcon.tsx
var ProjectIcon = __webpack_require__(20302);
;// CONCATENATED MODULE: ./components/vendor/InviteGovernmentsPlaceholder.tsx







function InviteGovernmentsPlaceholder(param) {
    var slug = param.slug, onClickToggle = param.onClickToggle;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            background: "#fff",
            border: "1px solid ".concat(palette/* lightestGray */.v2),
            padding: 24
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: {
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                maxWidth: 400,
                margin: "0 auto"
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectIcon/* default */.Z, {
                    width: 60,
                    height: 60
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                    css: {
                        margin: "12px 0 0 0",
                        color: palette/* text */.fL,
                        fontWeight: 500,
                        fontSize: 16
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Invite your connections",
                        id: "svU0CY"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                    css: {
                        margin: "12px 0 0 0",
                        color: palette/* darkGray */.O5,
                        fontSize: 14
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Connect with your government customers so your products are added to their stacks.",
                        id: "355747"
                    })
                }),
                onClickToggle ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* AnchorButton */.AN, {
                    size: "small",
                    color: palette/* innovatorBlue */.LD,
                    onClick: onClickToggle,
                    theme: "secondary",
                    css: {
                        margin: "12px 0 0 0",
                        minWidth: 150
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Add Governments",
                        id: "1hAbkF"
                    })
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                    href: "/vendors/[vendorSlug]/[[...content]]",
                    as: "/vendors/".concat(slug, "/invite-governments"),
                    passHref: true,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* AnchorButton */.AN, {
                        size: "small",
                        color: palette/* innovatorBlue */.LD,
                        theme: "secondary",
                        css: {
                            margin: "12px 0 0 0",
                            minWidth: 150
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Add Governments",
                            id: "1hAbkF"
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/vendor/tabs/VendorGovernmentConnections.tsx


















function VendorGovernmentConnections(param) {
    var vendor = param.vendor, _showUpgradeBanner = param.showUpgradeBanner, showUpgradeBanner = _showUpgradeBanner === void 0 ? true : _showUpgradeBanner, _showPlaceholder = param.showPlaceholder, showPlaceholder = _showPlaceholder === void 0 ? true : _showPlaceholder;
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useState)(null), selectedProduct = ref[0], setSelectedProduct = ref[1];
    var ref1 = (0,react.useState)(""), inputValue = ref1[0], setInputValue = ref1[1];
    var products = vendor.products, slug = vendor.slug, viewerIsMember = vendor.viewerIsMember;
    if (!vendor.plan.limits.inviteGovernments && vendor.viewerIsMember) {
        return showUpgradeBanner ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpgradeAccountBanner/* default */.Z, {}) : null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Query/* Query */.A, {
            query: VendorGovernmentConnectionsQuery,
            variables: {
                slug: vendor.slug,
                cursor: null,
                product: selectedProduct ? selectedProduct._id : null
            },
            notifyOnNetworkStatusChange: true,
            children: function(param) {
                var loading = param.loading, data = param.data, fetchMore = param.fetchMore;
                if (!data) {
                    return null;
                }
                var vendor = data.company;
                if (!vendor) {
                    return null;
                }
                var governmentConnections = vendor.governmentConnections;
                if (!governmentConnections || !governmentConnections.items || !governmentConnections.pageInfo) {
                    return null;
                }
                if (governmentConnections.items.length === 0 && showPlaceholder && !selectedProduct) {
                    return viewerIsMember ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InviteGovernmentsPlaceholder, {
                        slug: slug
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyGovernmentConnectionsBox, {});
                }
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    children: [
                        (products || []).length > 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                            mb: 16,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_select/* ProductSelect */.iF, {
                                value: selectedProduct,
                                css: {
                                    minWidth: 300
                                },
                                products: products,
                                inputValue: inputValue,
                                onInputValueChange: setInputValue,
                                onChange: setSelectedProduct,
                                placeholder: intl.formatMessage({
                                    defaultMessage: "Filter by product",
                                    id: "60+BpH"
                                })
                            })
                        }),
                        governmentConnections.items.length === 0 && selectedProduct && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InviteGovernmentsPlaceholder, {
                            slug: slug
                        }),
                        governmentConnections.items.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProfileBox, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        fontWeight: 500,
                                        color: palette/* darkGray */.O5,
                                        fontSize: 16,
                                        padding: 16,
                                        borderBottom: "1px solid ".concat(palette/* lightestGray */.v2),
                                        display: "flex"
                                    },
                                    children: selectedProduct ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        css: {
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                                css: {
                                                    marginRight: 8
                                                },
                                                children: [
                                                    selectedProduct.name,
                                                    " connections"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                                                width: 16,
                                                height: 16,
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM7 11.4L3.6 8 5 6.6l2 2 4-4L12.4 6 7 11.4z",
                                                    fill: palette/* greenSuccess */.CU,
                                                    fillRule: "nonzero"
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        css: {
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                                css: {
                                                    marginRight: 8
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "Verified Governments",
                                                        id: "1cTtuP"
                                                    }),
                                                    " (",
                                                    vendor.governmentConnectionsCount,
                                                    ")"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                                                width: 16,
                                                height: 16,
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                    d: "M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM7 11.4L3.6 8 5 6.6l2 2 4-4L12.4 6 7 11.4z",
                                                    fill: palette/* greenSuccess */.CU,
                                                    fillRule: "nonzero"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: (0,mediaQueries/* default */.Z)({
                                        display: "grid",
                                        gridTemplateColumns: [
                                            "1fr",
                                            "repeat(3, 1fr)"
                                        ],
                                        gridGap: 15,
                                        padding: 15
                                    }),
                                    children: governmentConnections.items.map(function(government) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentRichLink, {
                                            government: government
                                        }, government._id);
                                    })
                                }),
                                loading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        margin: 24
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Loader */.aN, {
                                        centered: true
                                    })
                                }),
                                !loading && governmentConnections.pageInfo.hasNextPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShowMore/* ShowMore */.g, {
                                    onClick: function() {
                                        if (!governmentConnections.pageInfo) {
                                            return;
                                        }
                                        fetchMore({
                                            variables: {
                                                cursor: governmentConnections.pageInfo.endCursor
                                            },
                                            updateQuery: function(previousResult, param) {
                                                var fetchMoreResult = param.fetchMoreResult;
                                                if (!fetchMoreResult) {
                                                    return previousResult;
                                                }
                                                return {
                                                    __typename: "Query",
                                                    company: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fetchMoreResult.company), {
                                                        governmentConnections: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                            __typename: "Governments"
                                                        }, fetchMoreResult.company.governmentConnections), {
                                                            items: previousResult.company.governmentConnections.items.concat(fetchMoreResult.company.governmentConnections.items),
                                                            pageInfo: (0,_object_spread/* default */.Z)({}, fetchMoreResult.company.governmentConnections.pageInfo)
                                                        })
                                                    })
                                                };
                                            }
                                        });
                                    }
                                })
                            ]
                        })
                    ]
                });
            }
        })
    });
};
function EmptyGovernmentConnectionsBox() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProfileBox, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 26
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_GovernmentIcon, {
                    width: 33,
                    height: 33
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                    ml: 14,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        css: {
                            fontSize: 18,
                            fontWeight: 500,
                            color: palette/* mediumGray */.rF
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "No Government Connections",
                            id: "6DydfW"
                        })
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./components/story/StoryListItemDividers.tsx
var StoryListItemDividers = __webpack_require__(77966);
// EXTERNAL MODULE: ./components/story/StoryListItemHoverContainer.tsx
var StoryListItemHoverContainer = __webpack_require__(59933);
// EXTERNAL MODULE: ./components/story/StoryListItem.tsx + 3 modules
var StoryListItem = __webpack_require__(92136);
;// CONCATENATED MODULE: ./lib/queries/GetStoriesByVendor.ts

function GetStoriesByVendor_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GetStoriesByVendor($vendorId: ObjectId!, $sort: SortType, $cursor: Cursor, $limit: Int = 15) {\n    storiesByVendor(vendorId: $vendorId, sort: $sort, cursor: $cursor, limit: $limit) {\n      items {\n        _id\n        title\n        slug\n        verticalCover\n        introduction\n        viewerCanRead\n        viewerIsAuthor\n        viewerDidBookmark\n        updatedAt\n        modifiedAt\n        createdAt\n        status\n        government {\n          _id\n          slug\n          name\n          logo\n          isInnovator\n          city {\n            country\n            countryName\n          }\n        }\n        tags {\n          _id\n          name\n        }\n      }\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n    }\n  }\n"
    ]);
    GetStoriesByVendor_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var GetStoriesByVendor = ((0,lib/* gql */.Ps)(GetStoriesByVendor_templateObject()));

;// CONCATENATED MODULE: ./components/icons/VendorProfile/StoriesIcon.tsx





function StoriesIcon(_param) {
    var color = _param.color, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 27 27",
        width: 27,
        height: 27
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M4.5 25.357l-.771-.048a2.24 2.24 0 01-2.086-2.082l-.025-.404a138.681 138.681 0 010-18.587l.025-.403A2.248 2.248 0 013.729 1.77l.403-.024a138.681 138.681 0 0118.587 0l.404.024a2.248 2.248 0 012.062 2.086l.024.404c.415 6.188.415 12.398 0 18.586l-.024.404a2.244 2.244 0 01-2.087 2.066 139.57 139.57 0 01-18.598.04zm3.264-11.815h11.299M7.764 9.507h11.299m-11.299 8.07h11.299",
            fill: "none",
            fillRule: "evenodd",
            stroke: color,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.614
        })
    }));
};

;// CONCATENATED MODULE: ./components/vendor/NoVendorStoriesBox.tsx







function NoVendorStoriesBox() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProfileBox, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 26
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoriesIcon, {
                    width: 33,
                    height: 33,
                    color: palette/* mediumGray */.rF
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                    ml: 14,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        css: {
                            fontSize: 18,
                            fontWeight: 500,
                            color: palette/* mediumGray */.rF
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "No Story Connections",
                            id: "NDqheh"
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/vendor/VendorStories.tsx















function VendorStories(param) {
    var vendor = param.vendor, _showUpgradeBanner = param.showUpgradeBanner, showUpgradeBanner = _showUpgradeBanner === void 0 ? true : _showUpgradeBanner;
    if (vendor.plan.tier == types/* IPlanTier.Basic */.fq.Basic && vendor.viewerIsMember) {
        return showUpgradeBanner ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpgradeAccountBanner/* default */.Z, {}) : null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Query/* Query */.A, {
        query: GetStoriesByVendor,
        variables: {
            vendorId: vendor._id,
            sort: null,
            cursor: null,
            limit: 6
        },
        notifyOnNetworkStatusChange: true,
        children: function(param) {
            var data = param.data, loading = param.loading, fetchMore = param.fetchMore;
            if (loading) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* LoadingIndicator */.TF, {});
            }
            if (!data || !data.storiesByVendor || !data.storiesByVendor.items || data.storiesByVendor.items.length === 0) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoVendorStoriesBox, {});
            }
            var stories = data.storiesByVendor.items;
            var hasMore = data.storiesByVendor.pageInfo && data.storiesByVendor.pageInfo.hasNextPage ? data.storiesByVendor.pageInfo.hasNextPage : false;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorStoriesList, {
                stories: stories,
                hasMore: hasMore,
                onShowMore: function() {
                    if (!hasMore || !data.storiesByVendor.pageInfo || !data.storiesByVendor.pageInfo.endCursor) {
                        return null;
                    }
                    fetchMore({
                        variables: {
                            vendorId: vendor._id,
                            sort: null,
                            cursor: data.storiesByVendor.pageInfo.endCursor,
                            limit: 4
                        },
                        updateQuery: function(previousResult, param) {
                            var fetchMoreResult = param.fetchMoreResult;
                            if (!fetchMoreResult || !fetchMoreResult.storiesByVendor || !fetchMoreResult.storiesByVendor.items || !previousResult.storiesByVendor || !previousResult.storiesByVendor.items) {
                                return previousResult;
                            }
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, previousResult), {
                                storiesByVendor: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, previousResult.storiesByVendor, fetchMoreResult.storiesByVendor), {
                                    items: previousResult.storiesByVendor.items.concat(fetchMoreResult.storiesByVendor.items)
                                })
                            });
                        }
                    });
                }
            });
        }
    });
};
function VendorStoriesList(param) {
    var stories = param.stories, onShowMore = param.onShowMore, hasMore = param.hasMore;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            backgroundColor: palette/* white */.ix,
            borderRadius: 5,
            border: "solid 1px ".concat(palette/* lightestGray */.v2)
        },
        "data-intercom-target": "Vendor Stories",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryListItemDividers/* default */.Z, {
                children: stories.map(function(story) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryListItemHoverContainer/* default */.Z, {
                        style: {
                            padding: 15
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryListItem/* default */.Z, {
                            story: story
                        })
                    }, story._id);
                })
            }),
            hasMore && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShowMoreButon, {
                onClick: function() {
                    return onShowMore();
                }
            })
        ]
    });
}
function ShowMoreButon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        role: "button",
        "aria-label": "View More",
        css: {
            padding: 15,
            textTransform: "uppercase",
            color: palette/* sealBlue */.N9,
            fontSize: 12,
            textAlign: "center",
            fontWeight: 500,
            cursor: "pointer",
            borderTop: "solid 1px ".concat(palette/* lightestGray */.v2),
            "&:hover": {
                color: palette/* darkGray */.O5
            }
        }
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
            defaultMessage: "Show more",
            id: "aWpBzj"
        })
    }));
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(38975);
// EXTERNAL MODULE: ./node_modules/.pnpm/final-form@4.20.7/node_modules/final-form/dist/final-form.es.js
var final_form_es = __webpack_require__(60681);
;// CONCATENATED MODULE: ./lib/mutations/EditGroup.ts

function EditGroup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation EditGroup($id: ObjectId!, $group: GroupInput!) {\n    updateGroup(id: $id, group: $group) {\n      _id\n      slug\n      name\n      about\n      website\n      location\n      membersCount\n      productsCount\n      feedCount\n      viewerIsMember\n      headedByAdmins\n      viewerCanHeadContent\n      awards {\n        _id\n        name\n      }\n      governments {\n        _id\n        name\n        logo\n        slug\n      }\n      vendors {\n        _id\n        name\n        logo\n        slug\n      }\n      pendingRequests {\n        ... on GovernmentGroupRequest {\n          _id\n          government {\n            _id\n            logo\n            name\n            slug\n            city {\n              _id\n              name\n              country\n              countryName\n            }\n          }\n          createdAt\n        }\n        ... on VendorGroupRequest {\n          _id\n          vendor {\n            _id\n            logo\n            name\n            slug\n          }\n          createdAt\n        }\n      }\n      socialMedia {\n        instagram\n        youtube\n        facebook\n        linkedin\n        twitter\n      }\n      products {\n        _id\n        name\n        logo\n        slug\n        company {\n          _id\n          name\n          slug\n        }\n      }\n      outsideProducts {\n        _id\n        name\n        url\n        logo\n      }\n      newsworthy {\n        title\n        siteName\n        favicon\n        url\n        description\n        addedAt\n      }\n      projectsCount\n      projects(limit: 100, audience: PRIVATE) {\n        items {\n          _id\n          ...ProjectCardFields\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n      projectsFromGovernments(limit: 6) {\n        items {\n          _id\n          ...ProjectCardFields\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n      resources {\n        ... on LinkResource {\n          url\n          title\n          addedAt\n          type\n        }\n        ... on DownloadResource {\n          url\n          title\n          filename\n          addedAt\n          type\n        }\n        ... on TextResource {\n          title\n          body\n          addedAt\n          type\n        }\n      }\n      logo\n      visibility\n      viewerCanRemoveMembers\n      members {\n        items {\n          ... on PendingUser {\n            _id\n            slug\n            firstName\n            fullName\n            avatar\n            jobTitle\n            createdAt\n          }\n          ... on GovernmentUser {\n            _id\n            slug\n            firstName\n            jobTitle\n            fullName\n            avatar\n            title\n            createdAt\n          }\n          ... on VendorUser {\n            _id\n            slug\n            firstName\n            jobTitle\n            fullName\n            avatar\n            title\n            createdAt\n          }\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    EditGroup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var EditGroup = ((0,lib/* gql */.Ps)(EditGroup_templateObject(), project/* ProjectCardFieldsFragment */.SS));

// EXTERNAL MODULE: ./lib/queries/GroupQuery.ts
var GroupQuery = __webpack_require__(45742);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-final-form@6.5.9_s44h3cxpdxv6cks4bnqewerqda/node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(56225);
// EXTERNAL MODULE: ./components/form/LogoField.tsx
var LogoField = __webpack_require__(84447);
// EXTERNAL MODULE: ./components/form/ResourcesField.tsx + 8 modules
var ResourcesField = __webpack_require__(65504);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+algolia@1.5.0_ggl46zudxxlqvmbfh2i2q4ymge/node_modules/@govlaunch/algolia/index.js + 3 modules
var algolia = __webpack_require__(96429);
;// CONCATENATED MODULE: ./components/group/form/fields/ProductsField.tsx






function ProductsField() {
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
        name: "products",
        allowNull: true,
        children: function(param) {
            var input = param.input;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    padding: 15
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(algolia/* SearchAlgoliaIndex */.d, {
                    index: "products",
                    children: function(param) {
                        var products = param.results, inputValue = param.searchValue, onInputValueChange = param.onChange;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_select/* StoryProductSelect */.Ts, {
                            placeholder: intl.formatMessage({
                                defaultMessage: "Type product names",
                                id: "hJ0uBD"
                            }),
                            autoFocus: false,
                            products: Array.isArray(input.value) ? input.value : [],
                            inputValue: inputValue,
                            onInputValueChange: onInputValueChange,
                            selectableProducts: products,
                            onChange: input.onChange,
                            onFocus: input.onFocus,
                            onBlur: input.onBlur,
                            css: {
                                minWidth: "auto !important",
                                zIndex: "999 !important"
                            }
                        });
                    }
                })
            });
        }
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(55423);
// EXTERNAL MODULE: ./lib/utils/validate.ts
var validate = __webpack_require__(32774);
// EXTERNAL MODULE: ./components/form/TextField.tsx
var TextField = __webpack_require__(63259);
// EXTERNAL MODULE: ./components/tag/TagsSelect.tsx
var TagsSelect = __webpack_require__(90731);
// EXTERNAL MODULE: ./components/form/SocialMediaFields.tsx + 2 modules
var SocialMediaFields = __webpack_require__(38011);
// EXTERNAL MODULE: ./components/form/sections/Section.tsx
var Section = __webpack_require__(5974);
// EXTERNAL MODULE: ./components/form/sections/SectionHeader.tsx
var SectionHeader = __webpack_require__(73634);
// EXTERNAL MODULE: ./components/form/sections/SectionBody.tsx
var SectionBody = __webpack_require__(32190);
// EXTERNAL MODULE: ./components/form/TextareaField.tsx
var TextareaField = __webpack_require__(75150);
// EXTERNAL MODULE: ./components/form/NewsworthyField.tsx + 1 modules
var NewsworthyField = __webpack_require__(78949);
// EXTERNAL MODULE: ./lib/hooks/useIntlValidationMessages.ts
var useIntlValidationMessages = __webpack_require__(67308);
;// CONCATENATED MODULE: ./components/group/GroupForm.tsx
























function GroupForm(param) {
    var onSubmit = param.onSubmit, initialValues = param.initialValues;
    var intl = (0,useIntl/* default */.Z)();
    var intlValidationMessages = (0,useIntlValidationMessages/* default */.Z)();
    var validationSchema = es/* object */.Ry().shape({
        name: es/* string */.Z_().required(intlValidationMessages.cantBeBlank),
        location: es/* string */.Z_().required(intlValidationMessages.cantBeBlank),
        about: es/* string */.Z_().min(20, intlValidationMessages.minCharacters(20)).max(800, intlValidationMessages.maxCharacters(800)).required(intlValidationMessages.cantBeBlank),
        website: es/* string */.Z_().url(intlValidationMessages.invalidUrl).required(intlValidationMessages.cantBeBlank),
        socialMedia: es/* object */.Ry().shape({
            twitter: es/* string */.Z_().url(intlValidationMessages.invalidUrl).nullable(),
            youtube: es/* string */.Z_().url(intlValidationMessages.invalidUrl).nullable(),
            facebook: es/* string */.Z_().url(intlValidationMessages.invalidUrl).nullable(),
            linkedin: es/* string */.Z_().url(intlValidationMessages.invalidUrl).nullable(),
            instagram: es/* string */.Z_().url(intlValidationMessages.invalidUrl).nullable()
        })
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Form */.l0, {
        onSubmit: onSubmit,
        initialValues: initialValues,
        validate: (0,validate/* default */.Z)(validationSchema),
        children: function(param) {
            var handleSubmit = param.handleSubmit, submitting = param.submitting, submitError = param.submitError;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("form", {
                onSubmit: handleSubmit,
                autoComplete: "off",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* RowWrap */.xv, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Col */.JX, {
                            width: [
                                1,
                                8 / 12
                            ],
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionHeader/* default */.Z, {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "The Basics",
                                                id: "5L4CQD"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionBody/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextField/* default */.Z, {
                                                    fieldName: "name",
                                                    placeholder: intl.formatMessage({
                                                        defaultMessage: "What's the group name?",
                                                        id: "x5XMh4"
                                                    }),
                                                    label: intl.formatMessage({
                                                        defaultMessage: "Name",
                                                        id: "HAlOn1"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextField/* default */.Z, {
                                                    fieldName: "website",
                                                    placeholder: intl.formatMessage({
                                                        defaultMessage: "Group website URL (http://)",
                                                        id: "Ghv4R/"
                                                    }),
                                                    label: intl.formatMessage({
                                                        defaultMessage: "Website",
                                                        id: "JkLHGw"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextField/* default */.Z, {
                                                    fieldName: "location",
                                                    placeholder: intl.formatMessage({
                                                        defaultMessage: "What's the group location?",
                                                        id: "obj3GZ"
                                                    }),
                                                    label: intl.formatMessage({
                                                        defaultMessage: "Location",
                                                        id: "rvirM2"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                    mt: 24,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionHeader/* default */.Z, {
                                                css: {
                                                    display: "flex",
                                                    alignItems: "center"
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "About the Group",
                                                    id: "5zui5m"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionBody/* default */.Z, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextareaField/* default */.Z, {
                                                    fieldName: "about",
                                                    placeholder: intl.formatMessage({
                                                        defaultMessage: "Tell a bit more about the group",
                                                        id: "oLtRDR"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                    mt: 24,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionHeader/* default */.Z, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Newsworthy",
                                                    id: "JhItYg"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionBody/* default */.Z, {
                                                css: {
                                                    padding: 0
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsworthyField/* default */.ZP, {
                                                    fieldName: "newsworthy"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                    mt: 24,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.Z, {
                                        css: {
                                            overflow: "visible"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionHeader/* default */.Z, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Products",
                                                    id: "7NFfmz"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionBody/* default */.Z, {
                                                css: {
                                                    padding: 0
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductsField, {})
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Col */.JX, {
                            width: [
                                1,
                                4 / 12
                            ],
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionHeader/* default */.Z, {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Logo",
                                                id: "k81S1y"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionBody/* default */.Z, {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* FormSpy */.lP, {
                                                subscription: {
                                                    values: true
                                                },
                                                children: function(param) {
                                                    var values = param.values;
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoField/* default */.Z, {
                                                        fieldName: "logo",
                                                        entityName: values.name
                                                    });
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                    mt: 24,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionHeader/* default */.Z, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Social Media",
                                                    id: "5bGX59"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionBody/* default */.Z, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialMediaFields/* default */.Z, {})
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                    mt: 24,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionHeader/* default */.Z, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "\uD83C\uDFC5 Awards",
                                                    id: "RT1ZpG"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionBody/* default */.Z, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                                    name: "awards",
                                                    children: function(param) {
                                                        var input = param.input;
                                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagsSelect/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, input), {
                                                            type: types/* ITagType.Award */.mG.Award
                                                        }));
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                    mt: 24,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionHeader/* default */.Z, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Resources",
                                                    id: "c/KktL"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionBody/* default */.Z, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResourcesField/* default */.Z, {
                                                    fieldName: "resources"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(spacings/* Margin */.Zt, {
                                    mt: 24,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                            type: "submit",
                                            color: palette/* primary */.T$,
                                            size: "large",
                                            disabled: submitting,
                                            style: {
                                                width: "100%"
                                            },
                                            children: submitting ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Submitting",
                                                id: "zA7EJD"
                                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Submit",
                                                id: "wSZR47"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                            css: {
                                                marginTop: 4,
                                                color: palette/* red */.Q6
                                            },
                                            children: submitError
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            });
        }
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/get.js
var get = __webpack_require__(48182);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/pick.js
var pick = __webpack_require__(4074);
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);
;// CONCATENATED MODULE: ./components/vendor/profile/utils/index.ts






function convertValuesToVariables(values) {
    var products = values.products.filter(function(product) {
        return product._id;
    }).map(get_default()("_id"));
    var outsideProducts = values.products.filter(function(product) {
        return product.id;
    });
    return {
        logo: values.logo,
        name: values.name,
        about: values.about,
        vendor: null,
        website: values.website || "",
        newsworthy: (values.newsworthy || []).map(function(newsworthy) {
            return {
                url: newsworthy.url,
                description: newsworthy.description,
                title: newsworthy.title,
                favicon: newsworthy.favicon,
                siteName: newsworthy.siteName
            };
        }),
        products: products,
        outsideProducts: (outsideProducts || []).map(function(outsideProduct) {
            if (outsideProduct.id.startsWith("@")) {
                return {
                    name: outsideProduct.name,
                    url: outsideProduct.url
                };
            }
            return {
                _id: outsideProduct.id,
                name: outsideProduct.name,
                url: outsideProduct.url
            };
        }),
        resources: values.resources.map(pick_default()([
            "type",
            "url",
            "title",
            "body"
        ])),
        socialMedia: pick_default()([
            "facebook",
            "instagram",
            "linkedin",
            "twitter",
            "youtube"
        ], values.socialMedia) || null,
        visibility: values.visibility,
        location: values.location,
        members: values.members || [],
        tags: (values.tags || []).map(function(param) {
            var _id = param._id, objectID = param.objectID;
            return _id || objectID;
        }) || [],
        awards: (values.awards || []).map(function(param) {
            var _id = param._id, objectID = param.objectID;
            return _id || objectID;
        }),
        kind: types/* IGroupKind.Vendor */.Tx.Vendor
    };
}
function convertGroupToInitialValues(group) {
    var products = (group.products || []).map(pick_default()([
        "_id",
        "name",
        "logo"
    ]));
    var outsideProducts = (group.outsideProducts || []).map(function(outsideProduct) {
        return {
            id: outsideProduct._id,
            name: outsideProduct.name,
            url: outsideProduct.url
        };
    });
    return {
        logo: group.logo,
        name: group.name,
        location: group.location,
        about: group.about,
        website: group.website,
        newsworthy: (group.newsworthy || []).map(function(newsworthy) {
            return {
                url: newsworthy.url,
                description: newsworthy.description,
                title: newsworthy.title,
                favicon: newsworthy.favicon,
                siteName: newsworthy.siteName
            };
        }),
        products: (0,_to_consumable_array/* default */.Z)(products).concat((0,_to_consumable_array/* default */.Z)(outsideProducts)).map(addObjectId),
        resources: group.resources,
        socialMedia: group.socialMedia,
        visibility: group.visibility,
        awards: group.awards,
        tags: group.tags || []
    };
}
var addObjectId = function(entity) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, entity), {
        objectID: entity._id
    });
};

;// CONCATENATED MODULE: ./components/vendor/profile/EditVendorGroup.tsx
















function EditVendorGroup(param) {
    var groupSlug = param.groupSlug, vendor = param.vendor;
    var intl = (0,useIntl/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var maxGroups = intl.formatMessage({
        defaultMessage: "You've reached the limit of groups for your plan",
        id: "knb2lM"
    });
    var couldntSave = intl.formatMessage({
        defaultMessage: "Couldn't save. Please try again later!",
        id: "R5RM9+"
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
        mutation: EditGroup,
        children: function(editGroup) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Query/* Query */.A, {
                query: GroupQuery/* default */.Z,
                variables: {
                    slug: groupSlug
                },
                children: function(param) {
                    var group = param.data, loading = param.loading;
                    if (loading) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Loader */.aN, {
                            centered: true
                        });
                    }
                    if (!group || !group.groupBySlug) {
                        return null;
                    }
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GroupForm, {
                            initialValues: convertGroupToInitialValues(group.groupBySlug),
                            onSubmit: function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                _ctx.prev = 0;
                                                _ctx.next = 3;
                                                return editGroup({
                                                    variables: {
                                                        id: group.groupBySlug._id,
                                                        group: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, convertValuesToVariables(values)), {
                                                            vendor: vendor._id
                                                        })
                                                    }
                                                });
                                            case 3:
                                                router.push("/vendors/[vendorSlug]/[[...content]]", "/vendors/".concat(vendor.slug, "/groups"));
                                                return _ctx.abrupt("return", null);
                                            case 7:
                                                _ctx.prev = 7;
                                                _ctx.t0 = _ctx["catch"](0);
                                                if (!/Vendor plan doesn't support more groups/i.test(_ctx.t0.message)) {
                                                    _ctx.next = 11;
                                                    break;
                                                }
                                                return _ctx.abrupt("return", (0,_define_property/* default */.Z)({}, final_form_es/* FORM_ERROR */.Ck, maxGroups));
                                            case 11:
                                                return _ctx.abrupt("return", (0,_define_property/* default */.Z)({}, final_form_es/* FORM_ERROR */.Ck, couldntSave));
                                            case 12:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee, null, [
                                        [
                                            0,
                                            7
                                        ]
                                    ]);
                                }));
                                return function(values) {
                                    return _ref.apply(this, arguments);
                                };
                            }()
                        })
                    });
                }
            });
        }
    });
};

;// CONCATENATED MODULE: ./lib/mutations/CreateGroup.ts

function CreateGroup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CreateGroup($group: GroupInput!) {\n    createGroup(group: $group) {\n      _id\n      slug\n    }\n  }\n"
    ]);
    CreateGroup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var CreateGroup = ((0,lib/* gql */.Ps)(CreateGroup_templateObject()));

;// CONCATENATED MODULE: ./components/vendor/profile/NewVendorGroup.tsx















var GROUP_FORM_INITIAL_STATE = {
    tags: [],
    products: [],
    resources: [],
    newsworthy: [],
    visibility: "PRIVATE",
    awards: []
};
function NewVendorGroup(param) {
    var vendor = param.vendor;
    var intl = (0,useIntl/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var maxGroups = intl.formatMessage({
        defaultMessage: "You've reached the limit of groups for your plan",
        id: "knb2lM"
    });
    var couldntSave = intl.formatMessage({
        defaultMessage: "Couldn't save. Please try again later!",
        id: "R5RM9+"
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
            mutation: CreateGroup,
            children: function(createGroup) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GroupForm, {
                    onSubmit: function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        _ctx.prev = 0;
                                        _ctx.next = 3;
                                        return createGroup({
                                            variables: {
                                                group: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, convertValuesToVariables(values)), {
                                                    vendor: vendor._id
                                                })
                                            },
                                            refetchQueries: (0,RefetchQueriesFixLink/* refetchQueries */.h)([
                                                "Vendor",
                                                "CompanyAccountBillingInfo",
                                                "Selfie"
                                            ]),
                                            awaitRefetchQueries: true
                                        }).then(function(mutationResult) {
                                            if (mutationResult && mutationResult.data && mutationResult.data.createGroup) {
                                                router.push("/groups/[groupSlug]", "/groups/".concat(mutationResult.data.createGroup.slug));
                                            }
                                        });
                                    case 3:
                                        return _ctx.abrupt("return", null);
                                    case 6:
                                        _ctx.prev = 6;
                                        _ctx.t0 = _ctx["catch"](0);
                                        if (true) {
                                            _ctx.next = 10;
                                            break;
                                        }
                                        throw _ctx.t0;
                                    case 10:
                                        if (!/Vendor plan doesn't support more groups/i.test(_ctx.t0.message)) {
                                            _ctx.next = 12;
                                            break;
                                        }
                                        return _ctx.abrupt("return", (0,_define_property/* default */.Z)({}, final_form_es/* FORM_ERROR */.Ck, maxGroups));
                                    case 12:
                                        return _ctx.abrupt("return", (0,_define_property/* default */.Z)({}, final_form_es/* FORM_ERROR */.Ck, couldntSave));
                                    case 13:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee, null, [
                                [
                                    0,
                                    6
                                ]
                            ]);
                        }));
                        return function(values) {
                            return _ref.apply(this, arguments);
                        };
                    }(),
                    initialValues: GROUP_FORM_INITIAL_STATE
                });
            }
        })
    });
};

// EXTERNAL MODULE: ./components/icons/BadgeCheckIcon.tsx
var BadgeCheckIcon = __webpack_require__(23742);
// EXTERNAL MODULE: ./lib/queries/SelfieQuery.ts
var SelfieQuery = __webpack_require__(88877);
// EXTERNAL MODULE: ./components/actions/GroupRequestAction.tsx + 2 modules
var GroupRequestAction = __webpack_require__(22695);
;// CONCATENATED MODULE: ./lib/queries/VendorActionsQuery.ts

function VendorActionsQuery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query VendorActions($vendorSlug: String!) {\n    company(slug: $vendorSlug) {\n      _id\n      actionsCount\n      actions {\n        _id\n        group {\n          _id\n          slug\n          name\n          logo\n        }\n        inviter {\n          ... on PendingUser {\n            _id\n            slug\n            fullName\n            avatar\n          }\n          ... on VendorUser {\n            _id\n            slug\n            fullName\n            avatar\n          }\n          ... on GovernmentUser {\n            _id\n            slug\n            fullName\n            avatar\n          }\n        }\n        createdAt\n      }\n    }\n  }\n"
    ]);
    VendorActionsQuery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var VendorActionsQuery = ((0,lib/* gql */.Ps)(VendorActionsQuery_templateObject()));

;// CONCATENATED MODULE: ./components/vendor/profile/VendorActions.tsx













function VendorActions(param) {
    var vendor = param.vendor;
    // Since fetchPolicy="network-only" doesn't work on the server, we'll only query when rendering in the browser
    if (false) {}
    if (vendor.plan.tier === types/* IPlanTier.Basic */.fq.Basic) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpgradeAccountBanner/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        "data-intercom-target": "Vendor Actions",
        css: {
            display: "block"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Query/* Query */.A, {
            query: VendorActionsQuery,
            fetchPolicy: "network-only",
            variables: {
                vendorSlug: vendor.slug
            },
            children: function(param) {
                var data = param.data, loading = param.loading;
                if (loading || !data || !data.company) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Loader */.aN, {
                        centered: true
                    });
                }
                var actions = data.company.actions;
                if (actions.length === 0) {
                    return(// We refetch the selfie in case admin has taken action on behalf of the user
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Query/* Query */.A, {
                        query: SelfieQuery/* default */.Z,
                        fetchPolicy: "network-only",
                        children: function() {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: 5,
                                    border: "solid 1px ".concat(palette/* lightestGray */.v2),
                                    backgroundColor: palette/* white */.ix,
                                    color: palette/* mediumGray */.rF,
                                    padding: 26
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BadgeCheckIcon/* default */.Z, {}),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                        ml: 14,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                            css: {
                                                fontSize: 18,
                                                fontWeight: 500
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "No actions to take",
                                                id: "pWGG1V"
                                            })
                                        })
                                    })
                                ]
                            });
                        }
                    }));
                }
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: {
                        display: "grid",
                        gridAutoFlow: "row",
                        gridRowGap: 1,
                        border: "solid 1px ".concat(palette/* lightestGray */.v2),
                        backgroundColor: palette/* lightestGray */.v2,
                        borderRadius: 5,
                        overflow: "hidden"
                    },
                    children: actions.map(function(action) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GroupRequestAction/* default */.Z, {
                            action: action,
                            entityType: "vendor"
                        }, action._id);
                    })
                });
            }
        })
    });
}
/* harmony default export */ var profile_VendorActions = (VendorActions);

;// CONCATENATED MODULE: ./lib/mutations/LeaveGroupAsVendor.ts

function LeaveGroupAsVendor_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation LeaveGroupAsVendor($groupId: ObjectId!) {\n    leaveGroupAsVendor(groupId: $groupId)\n  }\n"
    ]);
    LeaveGroupAsVendor_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var LeaveGroupAsVendor = ((0,lib/* gql */.Ps)(LeaveGroupAsVendor_templateObject()));

;// CONCATENATED MODULE: ./lib/mutations/RemoveGroup.ts

function RemoveGroup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation RemoveGroup($groupId: ObjectId!) {\n    removeGroupById(id: $groupId)\n  }\n"
    ]);
    RemoveGroup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var RemoveGroup = ((0,lib/* gql */.Ps)(RemoveGroup_templateObject()));

;// CONCATENATED MODULE: ./components/icons/AnchorIcon.tsx




function AnchorIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 17,
        height: 16,
        viewBox: "0 0 17 16"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: "#797979",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M15.443 0H9.428a.747.747 0 00-.752.743c0 .41.337.743.752.743h4.2l-7.74 7.646a.736.736 0 000 1.05.754.754 0 001.064 0l7.74-7.646v4.15c0 .41.336.743.751.743a.747.747 0 00.752-.743V.743A.747.747 0 0015.443 0z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M12.236 7.467a.716.716 0 00-.72.71v6.4H1.44V4.623h6.478c.397 0 .72-.318.72-.71a.715.715 0 00-.72-.712H.72a.716.716 0 00-.72.711V15.29c0 .393.322.711.72.711h11.516c.398 0 .72-.318.72-.711V8.178a.716.716 0 00-.72-.711z"
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/icons/LeaveIcon.tsx




function LeaveIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 18,
        height: 18,
        viewBox: "0 0 18 18"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: "#797979",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M17.386 9H9.614C9.274 9 9 8.776 9 8.5s.275-.5.614-.5h7.772c.34 0 .614.224.614.5s-.275.5-.614.5z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M14.571 12a.562.562 0 01-.404-.171.592.592 0 010-.825L16.621 8.5l-2.454-2.504a.592.592 0 010-.825.563.563 0 01.809 0l2.857 2.916a.592.592 0 010 .825l-2.857 2.916a.562.562 0 01-.405.172zM6.4 18a1.75 1.75 0 01-.496-.07L1.09 16.426C.434 16.212 0 15.64 0 15V1.5C0 .673.718 0 1.6 0c.171 0 .334.023.496.07L6.91 1.574C7.566 1.788 8 2.36 8 3v13.5c0 .827-.717 1.5-1.6 1.5zM1.6 1.125c-.22 0-.4.169-.4.375V15c0 .16.114.308.278.361L6.27 16.86c.034.01.079.016.13.016.22 0 .4-.169.4-.375V3a.393.393 0 00-.278-.361L1.73 1.14a.461.461 0 00-.13-.016z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M11.44 6a.561.561 0 01-.559-.562V2.063a.936.936 0 00-.932-.938H1.56A.561.561 0 011 .562C1 .252 1.25 0 1.56 0h8.39C11.08 0 12 .925 12 2.063v3.375a.56.56 0 01-.56.562zM9.8 15H6.6c-.331 0-.6-.252-.6-.562 0-.311.269-.563.6-.563h3.2c.551 0 1-.42 1-.938V9.562c0-.31.269-.562.6-.562.331 0 .6.252.6.562v3.375C12 14.075 11.014 15 9.8 15z"
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/icons/TrashIcon.tsx




function TrashIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 15,
        height: 18,
        viewBox: "0 0 15 18"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: "#797979",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M10.5 6c-.276 0-.5.193-.5.43v8.14c0 .237.224.43.5.43s.5-.193.5-.43V6.43c0-.237-.224-.43-.5-.43zm-6 0c-.276 0-.5.193-.5.43v8.14c0 .237.224.43.5.43s.5-.193.5-.43V6.43C5 6.194 4.776 6 4.5 6z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M1.228 5.359v10.386c0 .614.231 1.19.635 1.604.401.415.96.65 1.545.651h8.184a2.156 2.156 0 001.545-.651c.404-.414.635-.99.635-1.604V5.359c.802-.208 1.321-.963 1.214-1.765-.107-.802-.808-1.402-1.638-1.402h-2.215v-.527a1.635 1.635 0 00-.499-1.181A1.723 1.723 0 009.42 0H5.58a1.723 1.723 0 00-1.214.484 1.635 1.635 0 00-.5 1.181v.527H1.653c-.83 0-1.53.6-1.638 1.402-.107.802.412 1.557 1.214 1.765zm10.364 11.798H3.408c-.74 0-1.315-.62-1.315-1.412V5.395h10.814v10.35c0 .793-.576 1.412-1.315 1.412zM4.732 1.665a.801.801 0 01.245-.586.845.845 0 01.603-.236h3.84a.845.845 0 01.603.236.8.8 0 01.245.586v.527H4.732v-.527zm-3.08 1.37h11.696c.43 0 .778.34.778.759 0 .42-.348.759-.778.759H1.652a.769.769 0 01-.778-.759c0-.42.348-.759.778-.759z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M7.5 6c-.276 0-.5.193-.5.43v8.14c0 .237.224.43.5.43s.5-.193.5-.43V6.43C8 6.194 7.776 6 7.5 6z"
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ./components/Tooltip.tsx
var Tooltip = __webpack_require__(79313);
;// CONCATENATED MODULE: ./components/vendor/profile/VendorGroups.tsx





















function VendorGroups(param) {
    var vendor = param.vendor;
    var myGroups = vendor.groups.filter(function(param) {
        var viewerIsOwner = param.viewerIsOwner;
        return viewerIsOwner;
    });
    var otherGroups = vendor.groups.filter(function(param) {
        var viewerIsOwner = param.viewerIsOwner;
        return !viewerIsOwner;
    });
    if (vendor.plan.limits.groups + vendor.plan.limits.groupInvitations === 0) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpgradeAccountBanner/* default */.Z, {});
    }
    if (myGroups.length === 0 && otherGroups.length === 0) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoGroups, {
                vendor: vendor
            })
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                    href: "/vendors/[vendorSlug]/[[...content]]",
                    as: "/vendors/".concat(vendor.slug, "/new-group"),
                    passHref: true,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* AnchorButton */.AN, {
                        theme: "secondary",
                        size: "large",
                        color: palette/* lightestGray */.v2,
                        textColor: palette/* darkGray */.O5,
                        css: {
                            background: "#fff",
                            fontSize: 16,
                            display: "inline-flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PenIcon, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                css: {
                                    marginLeft: 4
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "New Group",
                                    id: "mx9Iyw"
                                })
                            })
                        ]
                    })
                })
            }),
            myGroups.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                mt: 24,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        background: "#fff",
                        border: "1px solid ".concat(palette/* lightestGray */.v2),
                        borderRadius: 4
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                padding: 16,
                                fontSize: 24,
                                fontWeight: 500,
                                borderBottom: "1px solid ".concat(palette/* lightestGray */.v2)
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "My Groups",
                                id: "kkghcT"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GroupListItemDividers, {
                                children: myGroups.map(function(group) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GroupListItem, {
                                        group: group,
                                        vendorSlug: vendor.slug
                                    }, group._id);
                                })
                            })
                        })
                    ]
                })
            }),
            otherGroups.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                mt: 24,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        background: "#fff",
                        border: "1px solid ".concat(palette/* lightestGray */.v2),
                        borderRadius: 4
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                padding: 16,
                                fontSize: 24,
                                fontWeight: 500,
                                borderBottom: "1px solid ".concat(palette/* lightestGray */.v2)
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Other Groups",
                                id: "FnO28L"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GroupListItemDividers, {
                                children: otherGroups.map(function(group) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GroupListItem, {
                                        group: group
                                    }, group._id);
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
function GroupListItemDividers(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        css: {
            "& > :not(:first-of-type)": {
                borderTop: "solid 1px ".concat(palette/* lightestGray */.v2)
            }
        }
    }));
}
function GroupListItem(param) {
    var group = param.group, vendorSlug = param.vendorSlug;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            position: "relative",
            display: "flex",
            padding: 16
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                passHref: true,
                href: "/groups/[groupSlug]",
                as: "/groups/".concat(group.slug),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                    css: {
                        display: "flex"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                        size: 80,
                        image: group.logo,
                        name: group.name
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    marginLeft: 12,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    overflow: "hidden",
                    paddingRight: 40
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        passHref: true,
                        href: "/groups/[groupSlug]",
                        as: "/groups/".concat(group.slug),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                            css: {
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                css: {
                                    fontWeight: 500,
                                    margin: 0,
                                    fontSize: 20,
                                    letterSpacing: 0.25,
                                    color: palette/* darkGray */.O5
                                },
                                children: group.name
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                        target: "_blank",
                        rel: "noreferrer noopener",
                        href: group.website,
                        css: {
                            marginTop: 6,
                            fontSize: 16,
                            color: palette/* mediumGray */.rF,
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnchorIcon, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                css: {
                                    marginLeft: 4
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Website",
                                    id: "JkLHGw"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    position: "absolute",
                    top: 8,
                    right: 8,
                    display: "flex",
                    alignItems: "center"
                },
                children: [
                    group.viewerCanDelete ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                        mutation: RemoveGroup,
                        refetchQueries: (0,RefetchQueriesFixLink/* refetchQueries */.h)([
                            "CompanyAccountBillingInfo",
                            "Selfie"
                        ]),
                        variables: {
                            groupId: group._id
                        },
                        children: function(deleteGroup) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
                                backgroundColor: palette/* text */.fL,
                                render: function() {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                        css: {
                                            display: "block",
                                            fontSize: 12,
                                            padding: 8,
                                            color: palette/* white */.ix,
                                            fontWeight: 500
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Delete Group?",
                                            id: "OjeqDO"
                                        })
                                    });
                                },
                                children: function(param) {
                                    var innerRef = param.innerRef, bind = param.bind;
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        ref: innerRef
                                    }, bind), {
                                        onClick: function() {
                                            if (window.confirm(intl.formatMessage({
                                                defaultMessage: "Are you sure you want to remove this group?",
                                                id: "OJ9QmS"
                                            }))) {
                                                deleteGroup();
                                            }
                                        },
                                        type: "button",
                                        css: {
                                            cursor: "pointer",
                                            padding: 0,
                                            display: "inline-flex",
                                            border: 0,
                                            outline: 0,
                                            background: "none",
                                            marginRight: 8
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrashIcon, {})
                                    }));
                                }
                            });
                        }
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
                        backgroundColor: palette/* text */.fL,
                        render: function() {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                css: {
                                    display: "block",
                                    fontSize: 12,
                                    padding: 8,
                                    color: palette/* white */.ix,
                                    fontWeight: 500
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Leave Group",
                                        id: "aN2Gli"
                                    }),
                                    "?"
                                ]
                            });
                        },
                        children: function(param) {
                            var innerRef = param.innerRef, bind = param.bind;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                                mutation: LeaveGroupAsVendor,
                                variables: {
                                    groupId: group._id
                                },
                                children: function(leaveGroup) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        ref: innerRef
                                    }, bind), {
                                        onClick: function() {
                                            if (window.confirm(intl.formatMessage({
                                                defaultMessage: "Are you sure you want to leave this group?",
                                                id: "5BxgKi"
                                            }))) {
                                                leaveGroup({
                                                    refetchQueries: (0,RefetchQueriesFixLink/* refetchQueries */.h)([
                                                        "Vendor",
                                                        "CompanyAccountBillingInfo"
                                                    ]),
                                                    awaitRefetchQueries: true
                                                });
                                            }
                                        },
                                        type: "button",
                                        css: {
                                            cursor: "pointer",
                                            padding: 0,
                                            display: "inline-flex",
                                            border: 0,
                                            outline: 0,
                                            background: "none"
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LeaveIcon, {})
                                    }));
                                }
                            });
                        }
                    }),
                    group.viewerCanEdit && vendorSlug && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: "/vendors/[vendorSlug]/groups/[groupSlug]",
                        as: "/vendors/".concat(vendorSlug, "/groups/").concat(group.slug),
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                            css: {
                                display: "inline-flex"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PenIcon, {})
                        })
                    })
                ]
            })
        ]
    });
}
function NoGroups(_param) {
    var vendor = _param.vendor, props = (0,_object_without_properties/* default */.Z)(_param, [
        "vendor"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        css: {
            borderRadius: 4,
            background: "#fff",
            border: "1px solid ".concat(palette/* lightestGray */.v2),
            padding: 24
        }
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                maxWidth: 400,
                margin: "0 auto"
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                    width: 60,
                    height: 60,
                    viewBox: "0 0 62 62",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
                        fill: "none",
                        fillRule: "evenodd",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                                cx: 29.949,
                                cy: 29.949,
                                r: 29.949,
                                transform: "translate(1 1)",
                                fill: "#DAEAF6",
                                stroke: "#005AEE",
                                strokeWidth: 0.713
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "#0091FC",
                                fillRule: "nonzero",
                                d: "M46.038 21.995H26.965v-3.81h19.073z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "#0770BF",
                                fillRule: "nonzero",
                                d: "M30.924 21.995h-3.706v-3.602h3.706z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "#EAEAEA",
                                fillRule: "nonzero",
                                d: "M30.924 32.842h-3.706V21.995h3.706z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                fill: "#B0DDFC",
                                fillRule: "nonzero",
                                d: "M46.038 21.995h-4.41v-3.81h4.41z"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                stroke: "#2C426B",
                                strokeWidth: 0.98,
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                d: "M36.915 35.651v4.43H25.069l-5.094 5.797-.026-5.797h-2.107V25.425h6.149"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                stroke: "#2C426B",
                                strokeWidth: 0.98,
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                d: "M26.965 32.842H38.81l5.094 5.797.026-5.797h2.107V18.185H26.965zM30.4 22.803h11.879M42.279 25.335H30.4M30.4 28.351h11.879"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                    css: {
                        margin: "12px 0 0 0",
                        color: palette/* text */.fL,
                        fontWeight: 500,
                        fontSize: 16
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Create a Group",
                        id: "sN7tQJ"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                    css: {
                        margin: "12px 0 0 0",
                        color: palette/* darkGray */.O5,
                        fontSize: 14
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Engage with government leaders with your own custom branded groups.",
                        id: "pQxfWy"
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                    href: "/vendors/[vendorSlug]/[[...content]]",
                    as: "/vendors/".concat(vendor.slug, "/new-group"),
                    passHref: true,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* AnchorButton */.AN, {
                        size: "small",
                        color: palette/* innovatorBlue */.LD,
                        theme: "secondary",
                        css: {
                            margin: "12px 0 0 0",
                            minWidth: 150
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "New Group",
                            id: "mx9Iyw"
                        })
                    })
                })
            ]
        })
    }));
}

// EXTERNAL MODULE: ./lib/mutations/RemoveInvitee.ts
var RemoveInvitee = __webpack_require__(56250);
// EXTERNAL MODULE: ./lib/queries/fragments/VendorFields.ts
var VendorFields = __webpack_require__(31453);
;// CONCATENATED MODULE: ./lib/mutations/TransferOwnership.ts

function TransferOwnership_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation TransferOwnership($vendorId: ObjectId!, $newOwnerId: ObjectId!) {\n    transferOwnership(vendorId: $vendorId, newOwnerId: $newOwnerId) {\n      _id\n      ...VendorFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    TransferOwnership_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var TransferOwnership = ((0,lib/* gql */.Ps)(TransferOwnership_templateObject(), VendorFields/* default */.Z));

;// CONCATENATED MODULE: ./components/icons/TransferIcon.tsx




function TransferIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 477.859 477.859"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M472.863 175.662L353.396 56.195c-6.666-6.664-17.472-6.662-24.136.004a17.066 17.066 0 00-4.997 12.063v51.2H204.796c-9.426 0-17.067 7.641-17.067 17.067s7.641 17.067 17.067 17.067H341.33c9.426 0 17.067-7.641 17.067-17.067V109.46l78.268 78.268-78.268 78.268v-27.068c0-9.426-7.641-17.067-17.067-17.067H153.596v-51.2c-.002-9.426-7.645-17.065-17.07-17.063a17.068 17.068 0 00-12.063 4.997L4.997 278.062c-6.663 6.665-6.663 17.468 0 24.132l119.467 119.467c3.2 3.201 7.54 5 12.066 5.001a16.852 16.852 0 006.536-1.297 17.066 17.066 0 0010.53-15.77v-51.2h119.467c9.426 0 17.067-7.641 17.067-17.067s-7.641-17.067-17.067-17.067H136.53c-9.426 0-17.067 7.641-17.067 17.067v27.068l-78.268-78.268 78.268-78.268v27.068c0 9.426 7.641 17.067 17.067 17.067h187.733v51.2c.002 9.426 7.645 17.065 17.07 17.063a17.068 17.068 0 0012.063-4.997l119.467-119.467c6.662-6.665 6.662-17.468 0-24.132z"
        })
    }));
};

;// CONCATENATED MODULE: ./components/vendor/profile/VendorTeam.tsx


















function VendorTeam(param) {
    var vendor = param.vendor;
    var loggedInUser = (0,Auth/* useSelfie */.yD)();
    var intl = (0,useIntl/* default */.Z)();
    var router = (0,next_router.useRouter)();
    if (!loggedInUser) {
        return null;
    }
    var userHasOwnershipRights = loggedInUser.role === "COMPANY_OWNER" || vendor.usersCanAccessAccountPage;
    var userCanTransferOwnership = loggedInUser.role === "COMPANY_OWNER";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            borderRadius: 4,
            border: "1px solid ".concat(palette/* lightestGray */.v2),
            background: "#fff"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    padding: 16,
                    borderBottom: "1px solid ".concat(palette/* lightestGray */.v2),
                    display: "flex",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            fontSize: 24,
                            fontWeight: 600,
                            color: palette/* text */.fL
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Team",
                            id: "wsUmh9"
                        })
                    }),
                    userHasOwnershipRights && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Toggle */.ZD, {
                        children: function(param) {
                            var isOpen = param.on, toggle = param.toggle;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                        role: "button",
                                        "aria-label": intl.formatMessage({
                                            defaultMessage: "Invite your team",
                                            id: "6g+RkT"
                                        }),
                                        css: {
                                            marginLeft: "auto",
                                            fontWeight: 600,
                                            fontSize: 14,
                                            color: palette/* primary */.T$,
                                            cursor: "pointer"
                                        },
                                        onClick: toggle,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Invite Others",
                                            id: "OHauMK"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InviteModal/* default */.Z, {
                                        title: intl.formatMessage({
                                            defaultMessage: "Invite Team Members",
                                            id: "LeF5J5"
                                        }),
                                        subtitle: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                            children: intl.formatMessage({
                                                defaultMessage: "They’ll be granted access to your Vendor profile",
                                                id: "Y+CAMf"
                                            })
                                        }),
                                        redirectTo: "/vendors/".concat(vendor.slug),
                                        targetType: "VENDOR",
                                        targetId: vendor._id,
                                        isOpen: isOpen,
                                        onRequestClose: toggle
                                    })
                                ]
                            });
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    padding: 16,
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr",
                    gridGap: 16
                },
                children: (vendor.members || []).map(function(member) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            padding: 12,
                            borderRadius: 4,
                            border: "1px solid ".concat(palette/* lightestGray */.v2),
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            position: "relative"
                        },
                        children: [
                            member.role === "COMPANY_OWNER" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: {
                                    position: "absolute",
                                    top: 4,
                                    left: 4,
                                    display: "flex",
                                    flexDirection: "row"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    css: (0,mediaQueries/* default */.Z)({
                                        fontWeight: 600,
                                        background: palette/* lightestBlue */.I,
                                        color: palette/* innovatorBlue */.LD,
                                        borderRadius: 12,
                                        padding: 4,
                                        fontSize: 10,
                                        letterSpacing: 0.5,
                                        display: "flex",
                                        alignItems: "center",
                                        textTransform: "uppercase"
                                    }),
                                    children: intl.formatMessage({
                                        defaultMessage: "Owner",
                                        id: "zINlao"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: {
                                    position: "absolute",
                                    top: 4,
                                    right: 4,
                                    display: "flex",
                                    flexDirection: "row"
                                },
                                children: userCanTransferOwnership && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                                    mutation: TransferOwnership,
                                    refetchQueries: (0,RefetchQueriesFixLink/* refetchQueries */.h)([
                                        "Selfie",
                                        "Vendor"
                                    ]),
                                    children: function(transferOwnership) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
                                            backgroundColor: palette/* innovatorBlue */.LD,
                                            borderColor: palette/* innovatorBlue */.LD,
                                            boxStyle: {
                                                padding: 8
                                            },
                                            render: function() {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                    css: {
                                                        color: palette/* white */.ix,
                                                        fontWeight: 500,
                                                        fontSize: 14
                                                    },
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "Transfer Ownership",
                                                        id: "d2dgcX"
                                                    })
                                                });
                                            },
                                            children: function(param) {
                                                var innerRef = param.innerRef, bind = param.bind;
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                    ref: innerRef
                                                }, bind), {
                                                    onClick: function() {
                                                        if (window.confirm(intl.formatMessage({
                                                            defaultMessage: "Are you sure you want to transfer this vendor ownership to {fullName}?",
                                                            id: "4KjHfq"
                                                        }, {
                                                            fullName: member.fullName
                                                        }))) {
                                                            transferOwnership({
                                                                variables: {
                                                                    vendorId: vendor._id,
                                                                    newOwnerId: member._id
                                                                }
                                                            });
                                                        }
                                                    },
                                                    role: "button",
                                                    css: {
                                                        cursor: "pointer",
                                                        borderRadius: 12,
                                                        padding: 4,
                                                        fontSize: 10,
                                                        letterSpacing: 0.5
                                                    },
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TransferIcon, {
                                                        width: 20,
                                                        height: 20,
                                                        fill: palette/* innovatorBlue */.LD
                                                    })
                                                }));
                                            }
                                        });
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: {
                                    position: "relative"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                                    mutation: RemoveInvitee/* default */.Z,
                                    refetchQueries: (0,RefetchQueriesFixLink/* refetchQueries */.h)([
                                        "Selfie",
                                        "Vendor",
                                        "CompanyAccountBillingInfo"
                                    ]),
                                    children: function(removeInvitee) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
                                            backgroundColor: palette/* red */.Q6,
                                            borderColor: palette/* red */.Q6,
                                            render: function() {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    css: {
                                                        padding: 6,
                                                        fontWeight: 600,
                                                        color: palette/* white */.ix,
                                                        fontSize: 14
                                                    },
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "Remove Member",
                                                        id: "qhbBD7"
                                                    })
                                                });
                                            },
                                            children: function(param) {
                                                var bind = param.bind, innerRef = param.innerRef;
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                        css: {
                                                            position: "relative"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                                                                image: member.avatar,
                                                                name: member.fullName,
                                                                size: 60,
                                                                css: {
                                                                    position: "static"
                                                                }
                                                            }),
                                                            canRemoveMember(userHasOwnershipRights, loggedInUser, member) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                ref: innerRef,
                                                                role: "button"
                                                            }, bind), {
                                                                css: {
                                                                    cursor: "pointer",
                                                                    position: "absolute",
                                                                    top: -5,
                                                                    display: "inline-flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    borderRadius: "100%",
                                                                    right: -5,
                                                                    width: 22,
                                                                    height: 22,
                                                                    background: palette/* red */.Q6
                                                                },
                                                                onClick: function() {
                                                                    if (window.confirm(loggedInUser && loggedInUser._id === member._id ? intl.formatMessage({
                                                                        defaultMessage: "Do you want to leave this vendor?",
                                                                        id: "cOr0z9"
                                                                    }) : intl.formatMessage({
                                                                        defaultMessage: "Do you want to remove this team member?",
                                                                        id: "zvf/vl"
                                                                    }))) {
                                                                        removeInvitee({
                                                                            variables: {
                                                                                targetId: vendor._id,
                                                                                inviteeId: member._id,
                                                                                targetType: "VENDOR"
                                                                            }
                                                                        }).then(function() {
                                                                            if (loggedInUser && loggedInUser._id === member._id) {
                                                                                router.push("/vendors/[vendorSlug]", "/vendors/".concat(vendor.slug));
                                                                            }
                                                                        });
                                                                    }
                                                                },
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                                                                    width: 10,
                                                                    height: 10,
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                                        fill: "#FFF",
                                                                        d: "M6.188 5l3.566-3.565A.84.84 0 1 0 8.565.246L5 3.812 1.435.246A.84.84 0 1 0 .246 1.435L3.812 5 .246 8.565a.84.84 0 0 0 1.189 1.189L5 6.188l3.565 3.566a.84.84 0 1 0 1.189-1.189L6.188 5z"
                                                                    })
                                                                })
                                                            }))
                                                        ]
                                                    })
                                                });
                                            }
                                        });
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    marginTop: 8,
                                    textAlign: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                        css: {
                                            margin: 0,
                                            fontSize: 16,
                                            fontWeight: 500,
                                            color: palette/* darkGray */.O5
                                        },
                                        children: member.fullName
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                        css: {
                                            margin: "4px 0 0 0",
                                            fontSize: 14,
                                            color: palette/* mediumGray */.rF
                                        },
                                        children: member.jobTitle
                                    })
                                ]
                            })
                        ]
                    }, member._id);
                })
            })
        ]
    });
};
function canRemoveMember(hasOwnershipRights, loggedInUser, member) {
    if (hasOwnershipRights && loggedInUser._id !== member._id && member.role !== "COMPANY_OWNER") {
        return true;
    }
    if (loggedInUser._id === member._id && loggedInUser.role !== "COMPANY_OWNER") {
        return true;
    }
    return false;
}

// EXTERNAL MODULE: ./components/feed/Feed.tsx
var Feed = __webpack_require__(45896);
// EXTERNAL MODULE: ./components/feed/WriteContentBox.tsx + 6 modules
var WriteContentBox = __webpack_require__(54436);
;// CONCATENATED MODULE: ./components/vendor/profile/owner/tabs/VendorOwnerFeedTab.tsx






function VendorOwnerFeedTab(param) {
    var user = param.user, vendor = param.vendor;
    if (vendor.plan.tier === types/* IPlanTier.Basic */.fq.Basic && vendor.viewerIsMember) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpgradeAccountBanner/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            display: "grid",
            gridRowGap: 16
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WriteContentBox/* default */.Z, {
                user: user
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Feed/* default */.Z, {
                targetId: vendor._id,
                targetType: types/* IConnectTargetType.Vendor */.QY.Vendor
            })
        ]
    });
};

;// CONCATENATED MODULE: ./lib/mutations/ArchiveProduct.ts

function ArchiveProduct_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ArchiveProduct($productId: ObjectId!) {\n    archiveProduct(productId: $productId)\n  }\n"
    ]);
    ArchiveProduct_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var ArchiveProduct = ((0,lib/* gql */.Ps)(ArchiveProduct_templateObject()));

;// CONCATENATED MODULE: ./lib/mutations/ToggleEnrichedProduct.ts

function ToggleEnrichedProduct_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ToggleEnrichedProduct($productId: ObjectId!) {\n    toggleEnrichedProduct(id: $productId) {\n      _id\n      slug\n      enrichedProfile\n    }\n  }\n"
    ]);
    ToggleEnrichedProduct_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var ToggleEnrichedProduct = ((0,lib/* gql */.Ps)(ToggleEnrichedProduct_templateObject()));

;// CONCATENATED MODULE: ./components/icons/BoltIcon.tsx





function BoltIcon(_param) {
    var width = _param.width, height = _param.height, props = (0,_object_without_properties/* default */.Z)(_param, [
        "width",
        "height"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 512 512",
        height: height ? height : 24,
        width: width ? width : 24
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M397.241 176.552H276.303L388.414 0H247.172L114.759 264.828h104.166L114.759 512l282.482-335.448z",
            fill: "#ecba16"
        })
    }));
}
/* harmony default export */ var icons_BoltIcon = (BoltIcon);

// EXTERNAL MODULE: ./components/icons/MakersIcon.tsx
var MakersIcon = __webpack_require__(52105);
;// CONCATENATED MODULE: ./components/product/icons.tsx






var Pencil = function(_param) /*#__PURE__*/ {
    var fill = _param.fill, props = (0,_object_without_properties/* default */.Z)(_param, [
        "fill"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 19,
        height: 23,
        viewBox: "0 0 19 23"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M4.642 21.14L.8 18.211 12.358 3.72 16.2 6.65 4.642 21.14zm-2.997-3.03l2.893 2.204L15.355 6.751l-2.892-2.206L1.645 18.11zM16.594 6.166L12.8 3.215l.906-1.16L17.5 5.007l-.906 1.159zm-2.96-3.054l2.857 2.222.175-.224-2.857-2.222-.175.224zm4.316 1.39L14.1 1.54l.193-.244C14.65.843 15.318 0 16.058 0c.216 0 .417.07.597.209l1.98 1.523c.2.15.323.359.356.605.065.489-.212 1.117-.848 1.921l-.192.244zm-3-3.064l2.892 2.225c.524-.716.573-1.086.551-1.248a.292.292 0 0 0-.123-.21l-.004-.003-1.98-1.524a.358.358 0 0 0-.227-.083c-.36 0-.815.488-1.11.843zM.8 23a.807.807 0 0 1-.615-.283.768.768 0 0 1-.173-.638l.582-3.581L4.5 21.479l-3.41 1.467A.816.816 0 0 1 .8 23zm.227-3.427L.603 22.18a.187.187 0 0 0 .042.16.206.206 0 0 0 .155.073.206.206 0 0 0 .069-.012l2.47-1.063-2.312-1.765z",
            fill: fill || palette/* primary */.T$
        })
    }));
};

// EXTERNAL MODULE: ./components/text/Dotdotdot.tsx
var Dotdotdot = __webpack_require__(3552);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+popover@0.10.2_qlbrybfyutdb3nzvgq5n4v5xcq/node_modules/@govlaunch/popover/index.js + 59 modules
var popover = __webpack_require__(70271);
;// CONCATENATED MODULE: ./components/vendor/profile/CounterIcon.tsx








function CounterIcon(_param) {
    var count = _param.count, tooltip = _param.tooltip, width = _param.width, height = _param.height, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "count",
        "tooltip",
        "width",
        "height",
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Hover */.TM, {
        children: function(param) {
            var hovered = param.hovered, bind = param.bind;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(popover/* default */.Z, {
                isOpen: hovered,
                placement: "top",
                render: function() {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            padding: 8,
                            color: palette/* white */.ix,
                            fontSize: 12,
                            fontWeight: "bold"
                        },
                        children: tooltip
                    });
                },
                borderColor: "transparent",
                backgroundColor: palette/* innovatorBlue */.LD,
                boxStyle: {
                    boxShadow: "0 2px 12px 0 rgba(0, 0, 0, 0.2)",
                    zIndex: 9999
                },
                children: function(param) {
                    var innerRef = param.innerRef;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props, bind), {
                        ref: innerRef,
                        css: {
                            height: height,
                            width: width,
                            borderRadius: "100%",
                            display: "flex",
                            position: "relative",
                            float: "left",
                            alignItems: "center",
                            cursor: "pointer"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: {
                                    zIndex: 1
                                },
                                children: children
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: {
                                    height: 18,
                                    width: 18,
                                    display: "flex",
                                    position: "absolute",
                                    right: -4,
                                    bottom: -2,
                                    backgroundColor: palette/* innovatorBlue */.LD,
                                    color: palette/* white */.ix,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: "100%",
                                    zIndex: 2,
                                    fontSize: 10
                                },
                                children: count && count > 99 ? "99+" : count
                            })
                        ]
                    }));
                }
            });
        }
    });
};

// EXTERNAL MODULE: ./components/vendor/profile/UpgradeToMakersProBanner.tsx
var UpgradeToMakersProBanner = __webpack_require__(589);
;// CONCATENATED MODULE: ./components/vendor/profile/UpgradeAccountBannerModal.tsx







function UpgradeAccountBannerModal(param) {
    var isOpen = param.isOpen, toggleOpen = param.toggleOpen, isVendorBasic = param.isVendorBasic;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Modal */.u_, {
        isOpen: isOpen,
        onRequestClose: toggleOpen,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* ModalClose */.A3, {
                onClick: toggleOpen
            }),
            isVendorBasic ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpgradeAccountBanner/* default */.Z, {
                icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MakersIcon/* default */.Z, {
                    width: 80,
                    height: 80
                }),
                title: intl.formatMessage({
                    defaultMessage: "Upgrade to {plan}",
                    id: "/gko4g"
                }, {
                    plan: "Makers"
                }),
                plan: "Makers",
                css: {
                    border: 0,
                    borderRadius: 0
                }
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpgradeToMakersProBanner/* default */.Z, {})
        ]
    });
};

;// CONCATENATED MODULE: ./components/vendor/tabs/VendorProducts.tsx
























function VendorProducts(param) {
    var vendor = param.vendor;
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isModalOpen = ref[0], toggleModalOpen = ref[1];
    var enrichedProducts = (vendor.products || []).filter(function(param) {
        var enrichedProfile = param.enrichedProfile;
        return enrichedProfile;
    });
    var hasReachedMaximumEnrichedProducts = enrichedProducts.length >= vendor.plan.limits.enrichedProducts;
    var isVendorBasic = vendor.plan.tier === types/* IPlanTier.Basic */.fq.Basic;
    var isVendorMakers = vendor.plan.tier === types/* IPlanTier.Makers */.fq.Makers;
    var isVendorMakersPro = vendor.plan.tier === types/* IPlanTier.Makerspro */.fq.Makerspro;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            display: "grid",
            gridAutoFlow: "row",
            gridRowGap: 1,
            overflow: "hidden",
            backgroundColor: palette/* lightestGray */.v2,
            border: "solid 1px ".concat(palette/* lightestGray */.v2),
            borderRadius: 5
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpgradeAccountBannerModal, {
                isOpen: isModalOpen,
                toggleOpen: toggleModalOpen,
                isVendorBasic: isVendorBasic
            }),
            (vendor.products || []).map(function(product) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        position: "relative",
                        display: "flex",
                        flexDirection: "row",
                        padding: 12,
                        backgroundColor: palette/* white */.ix,
                        ":hover": {
                            backgroundColor: palette/* washGray */.aF
                        }
                    },
                    children: [
                        vendor.viewerIsMember && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                position: "absolute",
                                top: product.isDisruptor ? 12 : 8,
                                right: 8,
                                display: "flex",
                                alignItems: "center"
                            },
                            children: [
                                !product.isDisruptor && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
                                    backgroundColor: palette/* innovatorBlue */.LD,
                                    boxStyle: hasReachedMaximumEnrichedProducts && !product.enrichedProfile && !isVendorBasic ? {
                                        maxWidth: 250,
                                        padding: 8,
                                        textAlign: "center"
                                    } : {
                                        display: "none"
                                    },
                                    render: function() {
                                        return hasReachedMaximumEnrichedProducts && !product.enrichedProfile ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                            css: {
                                                color: palette/* white */.ix,
                                                fontSize: 14,
                                                textAlign: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "You have reached the maximum number of {plan} products",
                                                    id: "dEGlYB",
                                                    values: {
                                                        plan: isVendorMakers ? "Makers" : "Makers Pro"
                                                    }
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                                                " ",
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                    css: {
                                                        fontWeight: 600
                                                    },
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "Click to Upgrade",
                                                        id: "15Ij0X"
                                                    })
                                                })
                                            ]
                                        }) : null;
                                    },
                                    children: function(param) {
                                        var innerRef = param.innerRef, bind = param.bind;
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                                            mutation: ToggleEnrichedProduct,
                                            refetchQueries: (0,RefetchQueriesFixLink/* refetchQueries */.h)([
                                                "CompanyAccountBillingInfo"
                                            ]),
                                            children: function(toggleEnrichedProduct) {
                                                if (isVendorMakersPro && hasReachedMaximumEnrichedProducts && !product.enrichedProfile) {
                                                    return null;
                                                }
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                    onClick: function() {
                                                        if (!product.enrichedProfile && hasReachedMaximumEnrichedProducts) {
                                                            toggleModalOpen();
                                                            return;
                                                        }
                                                        toggleEnrichedProduct({
                                                            variables: {
                                                                productId: product._id
                                                            }
                                                        });
                                                    }
                                                }, bind), {
                                                    ref: innerRef,
                                                    type: "button",
                                                    css: {
                                                        cursor: "pointer",
                                                        border: "1px solid ".concat(palette/* lightestGray */.v2),
                                                        background: "#fff",
                                                        fontSize: 14,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        borderRadius: 4,
                                                        padding: 8
                                                    },
                                                    children: product.enrichedProfile ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                        css: {
                                                            marginRight: 4,
                                                            fontWeight: 500
                                                        },
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                            defaultMessage: "Set to Basic",
                                                            id: "Y4TPbu"
                                                        })
                                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                        css: {
                                                            marginRight: 4,
                                                            fontWeight: 500
                                                        },
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                            defaultMessage: "Set as Makers",
                                                            id: "WcIcFD"
                                                        })
                                                    })
                                                }));
                                            }
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    href: "/products/[productSlug]/edit",
                                    as: "/products/".concat(product.slug, "/edit"),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                        css: {
                                            display: "inline-flex",
                                            alignItems: "center",
                                            boxSizing: "border-box",
                                            marginLeft: 8,
                                            minHeight: 36
                                        },
                                        "aria-label": intl.formatMessage({
                                            defaultMessage: "Edit product",
                                            id: "Tk3zCB"
                                        }),
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Pencil, {
                                            fill: "#797979",
                                            width: 15,
                                            height: 18
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                                    mutation: ArchiveProduct,
                                    awaitRefetchQueries: true,
                                    refetchQueries: (0,RefetchQueriesFixLink/* refetchQueries */.h)([
                                        "CompanyAccountBillingInfo",
                                        "Vendor"
                                    ]),
                                    children: function(archiveProduct) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
                                            backgroundColor: palette/* text */.fL,
                                            render: function() {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                    css: {
                                                        display: "block",
                                                        fontSize: 12,
                                                        padding: 8,
                                                        color: palette/* white */.ix,
                                                        fontWeight: 500
                                                    },
                                                    children: intl.formatMessage({
                                                        defaultMessage: "Delete product?",
                                                        id: "97jX9O"
                                                    })
                                                });
                                            },
                                            children: function(param) {
                                                var innerRef = param.innerRef, bind = param.bind;
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                    ref: innerRef
                                                }, bind), {
                                                    onClick: function() {
                                                        if (window.confirm(intl.formatMessage({
                                                            defaultMessage: "Are you sure you want to remove this product?",
                                                            id: "LsNq99"
                                                        }))) {
                                                            archiveProduct({
                                                                variables: {
                                                                    productId: product._id
                                                                }
                                                            });
                                                        }
                                                    },
                                                    type: "button",
                                                    css: {
                                                        marginLeft: 8,
                                                        cursor: "pointer",
                                                        padding: 0,
                                                        display: "inline-flex",
                                                        border: 0,
                                                        outline: 0,
                                                        background: "none",
                                                        marginRight: 8
                                                    },
                                                    "aria-label": intl.formatMessage({
                                                        defaultMessage: "Delete product",
                                                        id: "us+OCh"
                                                    }),
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorProducts_TrashIcon, {})
                                                }));
                                            }
                                        });
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                            href: "/products/".concat(product.slug),
                            passHref: true,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                                css: {
                                    position: "relative"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                                        size: "2xl",
                                        src: product.logo,
                                        name: product.name,
                                        variant: product.isDisruptor ? "disruptor" : null
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: {
                                            position: "absolute",
                                            bottom: 0,
                                            right: 0
                                        },
                                        children: product.enrichedProfile && !product.isDisruptor && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MakersIcon/* default */.Z, {
                                            width: 24,
                                            height: 24
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                display: "flex",
                                alignItems: "center"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(spacings/* Margin */.Zt, {
                                ml: 20,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                        href: "/products/".concat(product.slug),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            css: {
                                                fontSize: 18,
                                                color: palette/* text */.fL,
                                                fontWeight: 600
                                            },
                                            children: product.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                        mt: 8,
                                        mr: 150,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                            href: "/products/".concat(product.slug),
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                css: {
                                                    fontSize: 14,
                                                    color: palette/* text */.fL
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dotdotdot/* default */.Z, {
                                                    clamp: 3,
                                                    children: product.description
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                        mt: 8,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                            href: "/products/".concat(product.slug),
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                css: {
                                                    margin: 0,
                                                    fontSize: 14,
                                                    color: palette/* text */.fL
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    css: {
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center"
                                                    },
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                        css: {
                                                            display: "grid",
                                                            gridTemplateColumns: "repeat(2, 1fr)",
                                                            columnGap: 10
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CounterIcon, {
                                                                count: product.governmentsUsingCount,
                                                                tooltip: product.governmentsUsingCount && product.governmentsUsingCount > 0 ? intl.formatMessage({
                                                                    defaultMessage: "# Governments using",
                                                                    id: "zEHwDG"
                                                                }) : intl.formatMessage({
                                                                    defaultMessage: "No Governments using",
                                                                    id: "YYklnk"
                                                                }),
                                                                width: 28,
                                                                height: 28,
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_GovernmentIcon, {
                                                                    width: 28,
                                                                    height: 28
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CounterIcon, {
                                                                count: product.projectsUsingCount,
                                                                tooltip: product.projectsUsingCount && product.projectsUsingCount > 0 ? intl.formatMessage({
                                                                    defaultMessage: "# Projects using",
                                                                    id: "faMcnu"
                                                                }) : intl.formatMessage({
                                                                    defaultMessage: "No Projects using",
                                                                    id: "6EypCh"
                                                                }),
                                                                width: 28,
                                                                height: 28,
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_BoltIcon, {
                                                                    width: 28,
                                                                    height: 28
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }, product._id);
            })
        ]
    });
};
function VendorProducts_TrashIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 15,
        height: 18,
        viewBox: "0 0 15 18"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: "#797979",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M10.5 6c-.276 0-.5.193-.5.43v8.14c0 .237.224.43.5.43s.5-.193.5-.43V6.43c0-.237-.224-.43-.5-.43zm-6 0c-.276 0-.5.193-.5.43v8.14c0 .237.224.43.5.43s.5-.193.5-.43V6.43C5 6.194 4.776 6 4.5 6z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M1.228 5.359v10.386c0 .614.231 1.19.635 1.604.401.415.96.65 1.545.651h8.184a2.156 2.156 0 001.545-.651c.404-.414.635-.99.635-1.604V5.359c.802-.208 1.321-.963 1.214-1.765-.107-.802-.808-1.402-1.638-1.402h-2.215v-.527a1.635 1.635 0 00-.499-1.181A1.723 1.723 0 009.42 0H5.58a1.723 1.723 0 00-1.214.484 1.635 1.635 0 00-.5 1.181v.527H1.653c-.83 0-1.53.6-1.638 1.402-.107.802.412 1.557 1.214 1.765zm10.364 11.798H3.408c-.74 0-1.315-.62-1.315-1.412V5.395h10.814v10.35c0 .793-.576 1.412-1.315 1.412zM4.732 1.665a.801.801 0 01.245-.586.845.845 0 01.603-.236h3.84a.845.845 0 01.603.236.8.8 0 01.245.586v.527H4.732v-.527zm-3.08 1.37h11.696c.43 0 .778.34.778.759 0 .42-.348.759-.778.759H1.652a.769.769 0 01-.778-.759c0-.42.348-.759.778-.759z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M7.5 6c-.276 0-.5.193-.5.43v8.14c0 .237.224.43.5.43s.5-.193.5-.43V6.43C8 6.194 7.776 6 7.5 6z"
                })
            ]
        })
    }));
}

;// CONCATENATED MODULE: ./components/vendor/profile/owner/tabs/VendorOwnerProductsTab.tsx








function VendorOwnerProductsTab(param) {
    var vendor = param.vendor;
    if (!vendor) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    width: 180,
                    marginBottom: 24
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                    as: "/products/new",
                    href: "/products/new",
                    passHref: true,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* AnchorButton */.AN, {
                            theme: "secondary",
                            size: "large",
                            color: palette/* lightestGray */.v2,
                            textColor: palette/* darkGray */.O5,
                            css: {
                                background: "#fff",
                                display: "inline-flex",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PenIcon, {}),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    css: {
                                        marginLeft: 4,
                                        fontSize: 16
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "New Product",
                                        id: "C19d91"
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorProducts, {
                vendor: vendor
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/profile/EmptyBlocks.tsx
var EmptyBlocks = __webpack_require__(32796);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/filter.js
var filter = __webpack_require__(54192);
var filter_default = /*#__PURE__*/__webpack_require__.n(filter);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/identity.js
var identity = __webpack_require__(85579);
var identity_default = /*#__PURE__*/__webpack_require__.n(identity);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/omit.js
var omit = __webpack_require__(53104);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
;// CONCATENATED MODULE: ./components/vendor/profile/owner/tabs/getVendorSharingUrl.ts
function getVendorSharingUrl(slug) {
    if (true) {
        return "https://".concat(slug, ".vendors.govlaunch.com");
    }
    if (false) {}
    return "http://localhost:3006?vendor=".concat(slug);
};

;// CONCATENATED MODULE: ./lib/mutations/SaveVendorSharing.ts

function SaveVendorSharing_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation SaveVendorSharing($companyId: ObjectId!, $enabledSharing: Boolean!, $sharing: CompanySharingInput!) {\n    saveCompanySharing(companyId: $companyId, enabledSharing: $enabledSharing, sharing: $sharing) {\n      _id\n      enabledSharing\n      sharing {\n        products\n        stories\n        projects\n        products\n        resources\n        groups\n        governments\n        newsworthy\n        highlights\n        team\n      }\n      stripePlan {\n        ...StripePlanFields\n      }\n      planUsage {\n        ...CompanyPlanUsageFields\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    SaveVendorSharing_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ var SaveVendorSharing = ((0,lib/* gql */.Ps)(SaveVendorSharing_templateObject(), CompanyPlanUsageFields/* default */.Z, StripePlanFields/* default */.Z));

;// CONCATENATED MODULE: ./components/vendor/profile/owner/tabs/EditVendorSharingModal.tsx


















function EditVendorSharingModal(_param) {
    var handleSetSharing = function handleSetSharing(toggleEnabledSharing) {
        return function(options) {
            if (filter_default()((identity_default()), options).length === 0) {
                toggleEnabledSharing();
            }
            setSharing(options);
        };
    };
    var vendor = _param.vendor, isOpen = _param.isOpen, onRequestClose = _param.onRequestClose, props = (0,_object_without_properties/* default */.Z)(_param, [
        "vendor",
        "isOpen",
        "onRequestClose"
    ]);
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(vendor.enabledSharing || false), 2), enabledSharing = ref[0], toggleEnabledSharing = ref[1];
    var ref1 = (0,react.useState)(omit_default()([
        "__typename"
    ], vendor.sharing)), sharing = ref1[0], setSharing = ref1[1];
    var ref2 = (0,react.useState)(false), saving = ref2[0], setSaving = ref2[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Modal */.u_, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        isOpen: isOpen,
        onRequestClose: function() {
            if (!saving) {
                onRequestClose();
            }
        },
        ariaHideApp: false,
        overlayStyle: {
            background: "rgba(255, 255, 255, 0.6)"
        },
        style: {
            boxShadow: "0 0 20px 0 #e1e1e1",
            border: null
        },
        children: [
            isOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* BlockBodyOverflow */.Bm, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* ModalClose */.A3, {
                onClick: onRequestClose,
                style: {
                    cursor: "pointer"
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    padding: 20,
                    width: 450
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "grid",
                        rowGap: 15
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: {
                                    display: "flex",
                                    justifyContent: "space-between"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("h3", {
                                    css: {
                                        display: "flex",
                                        alignItems: "center",
                                        color: palette/* darkGray */.O5,
                                        margin: 0,
                                        fontWeight: 500,
                                        fontSize: 21
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Sharing",
                                            id: "XfKNCg"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                            css: {
                                                marginLeft: 5,
                                                fontSize: 14,
                                                color: enabledSharing ? "#178B61" : "#B44F4F"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_switch["default"], {
                                                uncheckedIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    css: {
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        height: "100%",
                                                        fontSize: 15,
                                                        color: palette/* lightRed */.r6,
                                                        paddingRight: 10
                                                    },
                                                    children: "off"
                                                }),
                                                checkedIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    css: {
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        height: "100%",
                                                        fontSize: 15,
                                                        color: "#fff",
                                                        paddingLeft: 10
                                                    },
                                                    children: "on"
                                                }),
                                                handleDiameter: 22,
                                                height: 26,
                                                width: 65,
                                                onChange: function(checked) {
                                                    toggleEnabledSharing();
                                                    if (checked) {
                                                        setSharing({
                                                            stories: true,
                                                            projects: true,
                                                            products: true,
                                                            resources: true,
                                                            groups: true,
                                                            governments: true,
                                                            newsworthy: true,
                                                            highlights: true,
                                                            team: true
                                                        });
                                                    } else {
                                                        setSharing({
                                                            stories: false,
                                                            projects: false,
                                                            products: false,
                                                            resources: false,
                                                            groups: false,
                                                            governments: false,
                                                            newsworthy: false,
                                                            highlights: false,
                                                            team: false
                                                        });
                                                    }
                                                },
                                                checked: enabledSharing,
                                                onColor: palette/* greenSuccess */.CU,
                                                offColor: palette/* red */.Q6
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        enabledSharing ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                            css: {
                                color: palette/* darkGray */.O5,
                                fontSize: 14,
                                margin: 0
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Select the items below to display in your public share page",
                                    id: "6kIwcu"
                                }),
                                ":",
                                " ",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                    css: {
                                        color: "#005AEE"
                                    },
                                    href: getVendorSharingUrl(vendor.slug),
                                    rel: "noopener noreferrer",
                                    target: "_blank",
                                    children: getVendorSharingUrl(vendor.slug)
                                })
                            ]
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                            css: {
                                color: palette/* darkGray */.O5,
                                fontSize: 14,
                                margin: 0
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Turn on sharing to create your custom page and then select what you want to share. It is that simple! Your Vendor's unique URL",
                                    id: "/jih0A"
                                }),
                                ":",
                                " ",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                    css: {
                                        color: "#005AEE"
                                    },
                                    href: getVendorSharingUrl(vendor.slug),
                                    rel: "noopener noreferrer",
                                    target: "_blank",
                                    children: getVendorSharingUrl(vendor.slug)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                                    css: {
                                        color: palette/* darkGray */.O5,
                                        fontSize: 14,
                                        margin: 0,
                                        marginBottom: 5
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("strong", {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Public",
                                                    id: "uhu5aG"
                                                }),
                                                ":"
                                            ]
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Anybody can view (including guests in Govlaunch)",
                                            id: "dF5LfH"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                                    css: {
                                        color: palette/* darkGray */.O5,
                                        fontSize: 14,
                                        margin: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("strong", {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Private",
                                                    id: "viXE32"
                                                }),
                                                ":"
                                            ]
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Only verified users in the Govlaunch community can view",
                                            id: "UH6st0"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                opacity: enabledSharing ? 1 : 0.3,
                                display: "grid",
                                rowGap: 10
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toggle, {
                                    value: "stories",
                                    description: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Stories",
                                                id: "Ldxym4"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                                css: {
                                                    fontSize: 11
                                                },
                                                children: [
                                                    "(",
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "only stories marked as public will be visible",
                                                        id: "UPxtYU"
                                                    }),
                                                    ")"
                                                ]
                                            })
                                        ]
                                    }),
                                    sharing: sharing,
                                    setSharing: handleSetSharing(toggleEnabledSharing),
                                    enabledSharing: enabledSharing
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toggle, {
                                    value: "projects",
                                    description: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Projects",
                                                id: "UxTJRa"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                                css: {
                                                    fontSize: 11
                                                },
                                                children: [
                                                    "(",
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "only projects marked as public will be visible",
                                                        id: "8uWZ5k"
                                                    }),
                                                    ")"
                                                ]
                                            })
                                        ]
                                    }),
                                    sharing: sharing,
                                    setSharing: handleSetSharing(toggleEnabledSharing),
                                    enabledSharing: enabledSharing
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toggle, {
                                    value: "products",
                                    description: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Products",
                                                id: "7NFfmz"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                                css: {
                                                    fontSize: 11
                                                },
                                                children: [
                                                    "(",
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "only products marked as public will be visible",
                                                        id: "lMw4W7"
                                                    }),
                                                    ")"
                                                ]
                                            })
                                        ]
                                    }),
                                    sharing: sharing,
                                    setSharing: handleSetSharing(toggleEnabledSharing),
                                    enabledSharing: enabledSharing
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toggle, {
                                    value: "resources",
                                    description: intl.formatMessage({
                                        defaultMessage: "Resources",
                                        id: "c/KktL"
                                    }),
                                    sharing: sharing,
                                    setSharing: handleSetSharing(toggleEnabledSharing),
                                    enabledSharing: enabledSharing
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toggle, {
                                    value: "groups",
                                    description: intl.formatMessage({
                                        defaultMessage: "Groups",
                                        id: "hzmswI"
                                    }),
                                    sharing: sharing,
                                    setSharing: handleSetSharing(toggleEnabledSharing),
                                    enabledSharing: enabledSharing
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toggle, {
                                    value: "governments",
                                    description: intl.formatMessage({
                                        defaultMessage: "Governments",
                                        id: "qnQX9U"
                                    }),
                                    sharing: sharing,
                                    setSharing: handleSetSharing(toggleEnabledSharing),
                                    enabledSharing: enabledSharing
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toggle, {
                                    value: "newsworthy",
                                    description: intl.formatMessage({
                                        defaultMessage: "Newsworthy",
                                        id: "JhItYg"
                                    }),
                                    sharing: sharing,
                                    setSharing: handleSetSharing(toggleEnabledSharing),
                                    enabledSharing: enabledSharing
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toggle, {
                                    value: "highlights",
                                    description: intl.formatMessage({
                                        defaultMessage: "Highlights",
                                        id: "KGmQjH"
                                    }),
                                    sharing: sharing,
                                    setSharing: handleSetSharing(toggleEnabledSharing),
                                    enabledSharing: enabledSharing
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toggle, {
                                    value: "team",
                                    description: intl.formatMessage({
                                        defaultMessage: "Team Members",
                                        id: "HCYBYT"
                                    }),
                                    sharing: sharing,
                                    setSharing: handleSetSharing(toggleEnabledSharing),
                                    enabledSharing: enabledSharing
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                            mutation: SaveVendorSharing,
                            children: function(saveVendorSharing) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                    disabled: saving,
                                    size: "small",
                                    color: palette/* innovatorBlue */.LD,
                                    css: {
                                        userSelect: "none",
                                        marginTop: 10
                                    },
                                    onClick: function() {
                                        setSaving(true);
                                        saveVendorSharing({
                                            variables: {
                                                companyId: vendor._id,
                                                sharing: {
                                                    stories: sharing.stories ? sharing.stories : false,
                                                    projects: sharing.projects ? sharing.projects : false,
                                                    products: sharing.products ? sharing.products : false,
                                                    resources: sharing.resources ? sharing.resources : false,
                                                    groups: sharing.groups ? sharing.groups : false,
                                                    governments: sharing.governments ? sharing.governments : false,
                                                    newsworthy: sharing.newsworthy ? sharing.newsworthy : false,
                                                    highlights: sharing.highlights ? sharing.highlights : false,
                                                    team: sharing.team ? sharing.team : false
                                                },
                                                enabledSharing: enabledSharing
                                            }
                                        }).then(function() {
                                            setSaving(false);
                                            onRequestClose();
                                        });
                                    },
                                    children: saving ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Saving",
                                        id: "QLkzoS"
                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Save",
                                        id: "jvo0vs"
                                    })
                                });
                            }
                        })
                    ]
                })
            })
        ]
    }));
};
function Toggle(param) {
    var value = param.value, description = param.description, sharing = param.sharing, setSharing = param.setSharing, enabledSharing = param.enabledSharing;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", {
            css: {
                display: "flex",
                alignItems: "center"
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_switch["default"], {
                    uncheckedIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            fontSize: 12,
                            color: palette/* lightRed */.r6,
                            paddingRight: 15
                        },
                        children: "off"
                    }),
                    checkedIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            fontSize: 12,
                            color: "#fff",
                            paddingLeft: 15
                        },
                        children: "on"
                    }),
                    offColor: palette/* red */.Q6,
                    handleDiameter: 22,
                    height: 24,
                    width: 80,
                    onColor: palette/* greenSuccess */.CU,
                    onChange: function() {
                        return setSharing(omit_default()("__typename", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sharing), (0,_define_property/* default */.Z)({}, value, !sharing[value]))));
                    },
                    checked: enabledSharing && Boolean(sharing[value])
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    css: {
                        marginLeft: 10,
                        color: palette/* darkGray */.O5,
                        fontSize: 16
                    },
                    children: description
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./components/icons/GearIcon.tsx
var GearIcon = __webpack_require__(74055);
// EXTERNAL MODULE: ./lib/hooks/useClipboard.ts
var useClipboard = __webpack_require__(91472);
;// CONCATENATED MODULE: ./components/vendor/profile/owner/tabs/VendorSharingPage.tsx











function VendorSharingPage(param) {
    var vendor = param.vendor, onGearIconClicked = param.onGearIconClicked;
    var inputRef = /*#__PURE__*/ react.createRef();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useClipboard/* default */.Z)(inputRef), 2), copied = ref[0], setClipboard = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            backgroundColor: palette/* white */.ix,
            borderRadius: 5,
            border: "solid 1px ".concat(palette/* lightestGray */.v2)
        },
        "data-intercom-target": "User Sharing",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    padding: 15,
                    textTransform: "uppercase",
                    fontSize: 12,
                    borderBottom: "1px solid ".concat(palette/* lightestGray */.v2),
                    color: palette/* sealBlue */.N9,
                    letterSpacing: 0.5,
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "row"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Sharing",
                            id: "XfKNCg"
                        })
                    }),
                     false && /*#__PURE__*/ 0,
                    vendor.enabledSharing && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        role: "button",
                        css: {
                            display: "inline-flex",
                            marginLeft: "auto",
                            cursor: "pointer"
                        },
                        onClick: onGearIconClicked,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GearIcon/* default */.Z, {
                                width: 20,
                                height: 20
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    padding: 15
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            fontWeight: 500,
                            fontSize: 14,
                            color: palette/* darkGray */.O5,
                            marginBottom: 15
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Your custom public page is now live!",
                            id: "1lfWb3"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            fontSize: 14,
                            color: palette/* darkGray */.O5
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                position: "relative"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        position: "absolute",
                                        left: 15,
                                        top: 14,
                                        display: "inline-flex"
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
                                        width: 15,
                                        height: 15,
                                        viewBox: "0 0 52.974 52.974",
                                        fill: palette/* sealBlue */.N9,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                d: "M49.467 3.51c-4.677-4.679-12.291-4.681-16.97 0l-9.192 9.192a.999.999 0 1 0 1.414 1.414l9.192-9.192a9.927 9.927 0 0 1 7.07-2.915c2.681 0 5.191 1.036 7.071 2.916s2.916 4.391 2.916 7.071c0 2.68-1.036 5.19-2.916 7.07L36.033 31.088c-3.898 3.898-10.244 3.898-14.143 0a.999.999 0 1 0-1.414 1.414c2.34 2.339 5.412 3.509 8.485 3.509s6.146-1.17 8.485-3.509L49.467 20.48a11.914 11.914 0 0 0 3.502-8.485c0-3.214-1.244-6.227-3.502-8.485z"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                d: "M26.84 40.279l-7.778 7.778a9.928 9.928 0 0 1-7.071 2.916 9.93 9.93 0 0 1-7.071-2.916c-3.898-3.898-3.898-10.243 0-14.142l11.314-11.314c3.899-3.898 10.244-3.896 14.142 0a.999.999 0 1 0 1.414-1.414c-4.677-4.679-12.291-4.681-16.97 0L3.505 32.502a11.914 11.914 0 0 0-3.501 8.485c0 3.214 1.244 6.227 3.502 8.484s5.271 3.502 8.484 3.502c3.215 0 6.228-1.244 8.485-3.502l7.778-7.778a.999.999 0 1 0-1.413-1.414z"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Input */.II, {
                                    innerRef: inputRef,
                                    readOnly: true,
                                    onChange: function() {},
                                    value: getVendorSharingUrl(vendor.slug),
                                    onFocus: function(e) {
                                        return e.target.select();
                                    },
                                    css: {
                                        paddingLeft: 40,
                                        borderColor: palette/* lightSealBlue */.oz,
                                        borderStyle: "dashed"
                                    }
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    padding: 16,
                    borderTop: "1px solid ".concat(palette/* lightestGray */.v2)
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* AnchorButton */.AN, {
                        href: getVendorSharingUrl(vendor.slug),
                        target: "_blank",
                        rel: "noopener noreferrer",
                        size: "xsmall",
                        css: {
                            display: "inline-flex",
                            marginRight: 8
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                css: {
                                    marginRight: 10,
                                    display: "inline-flex"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
                                    width: 15,
                                    height: 15,
                                    viewBox: "0 0 511.626 511.627",
                                    fill: "#fff",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                            d: "M392.857 292.354h-18.274c-2.669 0-4.859.855-6.563 2.573-1.718 1.708-2.573 3.897-2.573 6.563v91.361c0 12.563-4.47 23.315-13.415 32.262-8.945 8.945-19.701 13.414-32.264 13.414H82.224c-12.562 0-23.317-4.469-32.264-13.414-8.945-8.946-13.417-19.698-13.417-32.262V155.31c0-12.562 4.471-23.313 13.417-32.259 8.947-8.947 19.702-13.418 32.264-13.418h200.994c2.669 0 4.859-.859 6.57-2.57 1.711-1.713 2.566-3.9 2.566-6.567V82.221c0-2.662-.855-4.853-2.566-6.563-1.711-1.713-3.901-2.568-6.57-2.568H82.224c-22.648 0-42.016 8.042-58.102 24.125C8.042 113.297 0 132.665 0 155.313v237.542c0 22.647 8.042 42.018 24.123 58.095 16.086 16.084 35.454 24.13 58.102 24.13h237.543c22.647 0 42.017-8.046 58.101-24.13 16.085-16.077 24.127-35.447 24.127-58.095v-91.358c0-2.669-.856-4.859-2.574-6.57-1.713-1.718-3.903-2.573-6.565-2.573z"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                            d: "M506.199 41.971c-3.617-3.617-7.905-5.424-12.85-5.424H347.171c-4.948 0-9.233 1.807-12.847 5.424-3.617 3.615-5.428 7.898-5.428 12.847s1.811 9.233 5.428 12.85l50.247 50.248-186.147 186.151c-1.906 1.903-2.856 4.093-2.856 6.563 0 2.479.953 4.668 2.856 6.571l32.548 32.544c1.903 1.903 4.093 2.852 6.567 2.852s4.665-.948 6.567-2.852l186.148-186.148 50.251 50.248c3.614 3.617 7.898 5.426 12.847 5.426s9.233-1.809 12.851-5.426c3.617-3.616 5.424-7.898 5.424-12.847V54.818c-.001-4.952-1.814-9.232-5.428-12.847z"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Open",
                                    id: "JfG49w"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Button */.zx, {
                                theme: "secondary",
                                size: "xsmall",
                                onClick: setClipboard,
                                color: palette/* innovatorBlue */.LD,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                        css: {
                                            marginRight: 10,
                                            display: "inline-flex"
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
                                            width: 15,
                                            height: 15,
                                            viewBox: "0 0 488.3 488.3",
                                            fill: palette/* primary */.T$,
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                    d: "M314.25 85.4h-227c-21.3 0-38.6 17.3-38.6 38.6v325.7c0 21.3 17.3 38.6 38.6 38.6h227c21.3 0 38.6-17.3 38.6-38.6V124c-.1-21.3-17.4-38.6-38.6-38.6zm11.5 364.2c0 6.4-5.2 11.6-11.6 11.6h-227c-6.4 0-11.6-5.2-11.6-11.6V124c0-6.4 5.2-11.6 11.6-11.6h227c6.4 0 11.6 5.2 11.6 11.6v325.6z"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                    d: "M401.05 0h-227c-21.3 0-38.6 17.3-38.6 38.6 0 7.5 6 13.5 13.5 13.5s13.5-6 13.5-13.5c0-6.4 5.2-11.6 11.6-11.6h227c6.4 0 11.6 5.2 11.6 11.6v325.7c0 6.4-5.2 11.6-11.6 11.6-7.5 0-13.5 6-13.5 13.5s6 13.5 13.5 13.5c21.3 0 38.6-17.3 38.6-38.6V38.6c0-21.3-17.3-38.6-38.6-38.6z"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Copy",
                                            id: "4l6vz1"
                                        })
                                    })
                                ]
                            }),
                            copied && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                css: {
                                    marginLeft: 6,
                                    color: palette/* greenSuccess */.CU
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Copied",
                                    id: "p556q3"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/vendor/profile/owner/tabs/VendorOwnerSharingTab.tsx







function VendorOwnerSharingTab(param) {
    var vendor = param.vendor;
    var ref = (0,react.useState)(false), isModalShown = ref[0], setIsModalShown = ref[1];
    var router = (0,next_router.useRouter)();
    var openModal = function() {
        setIsModalShown(true);
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditVendorSharingModal, {
            vendor: vendor,
            isOpen: isModalShown,
            onRequestClose: function() {
                setIsModalShown(!isModalShown);
                return router.push("/vendors/[vendorSlug]/[[...content]]", "/vendors/".concat(vendor.slug, "/sharing"));
            }
        });
    };
    if (!vendor.plan.limits.sharingPage) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpgradeToMakersProBanner/* default */.Z, {});
    }
    if (!vendor.enabledSharing) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyBlocks/* NoSharingPage */.pH, {
                    onStartSharing: function() {
                        return setIsModalShown(true);
                    },
                    isForMakers: true
                }),
                isModalShown && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditVendorSharingModal, {
                    vendor: vendor,
                    isOpen: isModalShown,
                    onRequestClose: function() {
                        setIsModalShown(!isModalShown);
                        return router.push("/vendors/[vendorSlug]/[[...content]]", "/vendors/".concat(vendor.slug, "/sharing"));
                    }
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorSharingPage, {
                vendor: vendor,
                onGearIconClicked: function() {
                    return openModal();
                }
            }),
            isModalShown && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditVendorSharingModal, {
                vendor: vendor,
                isOpen: isModalShown,
                onRequestClose: function() {
                    setIsModalShown(!isModalShown);
                    return router.push("/vendors/[vendorSlug]/[[...content]]", "/vendors/".concat(vendor.slug, "/sharing"));
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/icons/DisruptorD.tsx
var DisruptorD = __webpack_require__(30283);
;// CONCATENATED MODULE: ./components/vendor/profile/SponsorshipBadges.tsx







function SponsorshipBadges(param) {
    var sponsorships = param.sponsorships, vendorLogoSize = param.vendorLogoSize;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: sponsorships.slice(0, 4).map(function(sponsorship, index) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
                backgroundColor: palette/* lightestGray */.v2,
                render: function() {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            padding: 8,
                            color: palette/* text */.fL,
                            fontSize: 14
                        },
                        children: sponsorship.name
                    });
                },
                children: function(param) {
                    var innerRef = param.innerRef, bind = param.bind;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BadgePlaceholder, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        innerRef: innerRef,
                        size: vendorLogoSize,
                        index: index,
                        link: sponsorship.link
                    }, bind), {
                        children: sponsorship.logo ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge, {
                            size: vendorLogoSize,
                            logo: sponsorship.logo
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            children: "".concat(sponsorship.name.charAt(0))
                        })
                    }));
                }
            }, "sponsorship_".concat(index));
        })
    });
};
function BadgePlaceholder(_param) {
    var innerRef = _param.innerRef, index = _param.index, size = _param.size, children = _param.children, link = _param.link, props = (0,_object_without_properties/* default */.Z)(_param, [
        "innerRef",
        "index",
        "size",
        "children",
        "link"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: link ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            href: link || "",
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                ref: innerRef,
                css: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    display: "flex",
                    position: "absolute"
                }, getBadgePlaceholderSize(size), getPosition(size, index)), {
                    backgroundColor: palette/* white */.ix,
                    ":hover": {
                        backgroundColor: palette/* lightestGray */.v2
                    },
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "100%",
                    zIndex: 2 + index
                })
            }, props), {
                children: children
            }))
        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: innerRef,
            css: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                display: "flex",
                position: "absolute"
            }, getBadgePlaceholderSize(size), getPosition(size, index)), {
                backgroundColor: palette/* white */.ix,
                ":hover": {
                    backgroundColor: palette/* lightestGray */.v2,
                    cursor: "pointer"
                },
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "100%",
                zIndex: 2 + index
            })
        }, props), {
            children: children
        }))
    });
}
function getBadgePlaceholderSize(size) {
    return {
        height: size / 2 + 4,
        width: size / 2 + 4
    };
}
function getBadgeSize(size) {
    return {
        height: size / 2,
        width: size / 2
    };
}
//TODO: figure out a function in the case the index is greater than 4, ergo more than 4 badges
function getPosition(size, index) {
    if (index === 0) {
        return {
            right: -size / 6,
            bottom: -size / 6
        };
    }
    if (index === 1) {
        return {
            left: -size / 6,
            top: -size / 6
        };
    }
    if (index === 2) {
        return {
            left: -size / 6,
            bottom: -size / 6
        };
    }
    if (index === 3) {
        return {
            right: -size / 6,
            top: -size / 6
        };
    }
    return {
        right: -size / 6,
        bottom: -size / 6
    };
}
function Badge(param) {
    var size = param.size, logo = param.logo;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getBadgeSize(size)), {
        src: logo,
        css: {
            userSelect: "none",
            borderRadius: "100%",
            objectFit: "contain"
        },
        alt: "Sponsorship badge"
    }));
}

;// CONCATENATED MODULE: ./components/vendor/profile/owner/VendorOwnerInfo.tsx






function VendorOwnerInfo(param) {
    var vendor = param.vendor;
    var showSponsorshipsBadges = vendor.sponsorships && vendor.sponsorships.length > 0;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
            width: "100%",
            padding: 16,
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                        size: 48,
                        disruptor: vendor.isDisruptor,
                        image: vendor.logo,
                        name: vendor.name,
                        css: {
                            borderWidth: !showSponsorshipsBadges && vendor.isDisruptor ? 2 : 1
                        }
                    }),
                    showSponsorshipsBadges && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SponsorshipBadges, {
                        sponsorships: vendor.sponsorships,
                        vendorLogoSize: 48
                    }),
                    !showSponsorshipsBadges && vendor.isDisruptor && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DisruptorD/* default */.Z, {
                        width: 18,
                        height: 18,
                        style: {
                            position: "absolute",
                            bottom: -3,
                            right: -3
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    overflow: "hidden",
                    textAlign: "center"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                    title: vendor.name,
                    css: {
                        margin: "8px 0 0",
                        color: palette/* darkGray */.O5,
                        fontSize: 20
                    },
                    children: vendor.name
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/shared/hooks/useIntlPolicies.ts
var useIntlPolicies = __webpack_require__(91968);
// EXTERNAL MODULE: ./components/icons/MakersProIcon.tsx
var MakersProIcon = __webpack_require__(56906);
;// CONCATENATED MODULE: ./components/icons/VendorProfile/ActionsIcon.tsx





function ActionsIcon(_param) {
    var color = _param.color, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 24 27",
        width: 24,
        height: 27
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: "none",
            fillRule: "evenodd",
            stroke: color,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.796,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M2.404 22.487h19.333c.404-.007.773-.212.968-.539a.974.974 0 00-.021-1.043L20.6 17.653V9.42c0-4.672-3.79-8.47-8.53-8.47-4.742 0-8.531 3.798-8.531 8.47v8.234l-2.07 3.252a.974.974 0 00-.025 1.038c.193.326.557.533.959.544z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M15.595 22.487c.049.195.073.396.072.597 0 1.647-1.607 2.993-3.59 2.993-1.983 0-3.59-1.346-3.59-2.993a2.416 2.416 0 01.072-.597"
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/icons/VendorProfile/ActivityIcon.tsx





function ActivityIcon(_param) {
    var color = _param.color, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 26 27",
        width: 26,
        height: 27
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: "none",
            fillRule: "evenodd",
            stroke: color,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.587,
            transform: "translate(1.282 1.385)",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M10.753 7.181h9.523m-9.523 9.524h9.523"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                    cx: 5.991,
                    cy: 7.181,
                    r: 2.381
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                    cx: 5.991,
                    cy: 16.705,
                    r: 2.381
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M3.178 23.562l-.758-.047a2.202 2.202 0 01-2.052-2.048l-.024-.397a136.375 136.375 0 010-18.277l.024-.397A2.21 2.21 0 012.42.368l.396-.024a136.375 136.375 0 0118.278 0l.397.024a2.21 2.21 0 012.027 2.052l.024.396c.409 6.086.409 12.192 0 18.278l-.024.397a2.206 2.206 0 01-2.051 2.031 137.3 137.3 0 01-18.29.04z"
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/icons/VendorProfile/GovernmentsIcon.tsx





function GovernmentsIcon(_param) {
    var color = _param.color, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 26 26",
        width: 26,
        height: 26
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: "none",
            fillRule: "evenodd",
            stroke: color,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    strokeWidth: 1.573,
                    d: "M22.564 24.744H3.692c-1.301 0-2.359-.704-2.359-1.573V9.2a1.36 1.36 0 01.66-1.092l9.586-6.617a3.708 3.708 0 013.098 0l9.586 6.617c.388.232.635.641.66 1.093V23.17c0 .869-1.058 1.573-2.359 1.573z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M6.718 12.436v11.282zm4.102 0v11.282zm4.103 0v11.282zm4.103 0v11.282z",
                    strokeWidth: 2.64
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/icons/VendorProfile/GroupsIcon.tsx





function GroupsIcon(_param) {
    var color = _param.color, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 27 28",
        width: 27,
        height: 28
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: "none",
            fillRule: "evenodd",
            stroke: color,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.641,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M21.558 3.522v-.254c-.066-.73-.82-1.309-1.768-1.358h-.333c-5.245-.267-10.5-.267-15.745 0h-.333c-.947.049-1.702.627-1.768 1.358l-.02.254a69.744 69.744 0 000 12.07l.02.25c.066.73.82 1.309 1.773 1.358l.648.029c.82.04 1.64.075 2.461.102l4.899 4.874v-4.788c2.798 0 5.592-.07 8.381-.213.948-.05 1.699-.628 1.764-1.354v-.258c.356-4.015.363-8.054.02-12.07z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M23.872 6.012c.947.05 1.702.628 1.768 1.358v.255a69.744 69.744 0 010 12.07v.25c-.066.73-.82 1.308-1.772 1.358l-.649.028c-.82.041-1.64.075-2.461.103l-4.919 4.874V21.52h-.234c-1.132 0-.62 0-1.752-.041M6.777 9.557h9.575M6.777 6.135h9.575m-9.575 6.839h4.787"
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/icons/VendorProfile/ProductsIcon.tsx





function ProductsIcon(_param) {
    var color = _param.color, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 27 27",
        width: 27,
        height: 27
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M4.794 25.218l-.758-.035c-1.104-.056-1.986-.73-2.057-1.588l-.024-.294a80.199 80.199 0 010-14.015l.024-.298c.075-.846.953-1.517 2.053-1.588h.397a177.818 177.818 0 0118.286 0h.397c1.1.056 1.986.727 2.053 1.588l.024.298a80.199 80.199 0 010 14.015l-.024.301c-.075.842-.949 1.513-2.049 1.589a179.26 179.26 0 01-18.322.027zM6.418 2.41v-.112c.047-.317.587-.567 1.262-.587h.238c3.748-.115 7.512-.115 11.26 0h.238c.675.02 1.215.27 1.263.587l.032.111M3.639 5.586l.023-.223c.064-.631.814-1.135 1.755-1.19h.33c5.205-.235 10.43-.235 15.634 0h.33c.94.043 1.691.547 1.755 1.19l.024.223",
            fill: "none",
            fillRule: "evenodd",
            stroke: color,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.588
        })
    }));
};

;// CONCATENATED MODULE: ./components/icons/VendorProfile/SettingsIcon.tsx





function SettingsIcon(_param) {
    var color = _param.color, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 28 28",
        width: 28,
        height: 28
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
            fill: "none",
            fillRule: "evenodd",
            stroke: color,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.723,
            transform: "translate(1 1.077)",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M14.004 22.4l2.805 3.162 4.88-2.74-1.227-4.002 1.275-2.205 4.11-.892v-5.6l-4.11-.892-1.245-2.15 1.258-4.005-4.868-2.77-2.813 3.14h-2.227L9.038.284l-4.881 2.74 1.228 4.002L4.11 9.23 0 10.123v5.6l4.11.892 1.244 2.15-1.257 4.005 4.867 2.77 2.813-3.14z"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                    cx: 12.923,
                    cy: 12.923,
                    r: 4.308
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./components/icons/VendorProfile/SharingHubIcon.tsx





function SharingHubIcon(_param) {
    var color = _param.color, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 27 27",
        width: 27,
        height: 27
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fill: "none",
            stroke: color,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.681,
            d: "M25.046 3.787l-8.837 20.45c-.646 1.49-2.708 1.615-3.402.227L9.474 17.78a1.784 1.784 0 00-.807-.807l-6.69-3.333c-1.405-.694-1.264-2.756.225-3.402l20.46-8.837a1.792 1.792 0 012.384 2.385z"
        })
    }));
};

// EXTERNAL MODULE: ./components/Terms.tsx
var Terms = __webpack_require__(23805);
;// CONCATENATED MODULE: ./components/vendor/profile/owner/VendorOwnerNavbar.tsx



function VendorOwnerNavbar(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: (0,mediaQueries/* default */.Z)({
            padding: "16px 0px",
            display: "flex",
            flexDirection: "column",
            flexWrap: "wrap",
            textAlign: "center",
            alignItems: "left"
        }),
        children: children
    });
};

// EXTERNAL MODULE: ./components/profile/CountBadge.tsx
var CountBadge = __webpack_require__(61404);
;// CONCATENATED MODULE: ./components/vendor/profile/owner/VendorOwnerNavbarGroup.tsx










function VendorOwnerNavbarGroup(_param) {
    var href = _param.href, as = _param.as, title = _param.title, Icon = _param.icon, active = _param.active, dataIntercomTarget = _param.dataIntercomTarget, disabled = _param.disabled, children = _param.children, count = _param.count, circleProps = _param.circleProps, props = (0,_object_without_properties/* default */.Z)(_param, [
        "href",
        "as",
        "title",
        "icon",
        "active",
        "dataIntercomTarget",
        "disabled",
        "children",
        "count",
        "circleProps"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-intercom-target": dataIntercomTarget,
        css: {
            background: active ? palette/* lightestBlue */.I : "#fff"
        }
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: href,
                as: as,
                passHref: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                    css: (0,mediaQueries/* default */.Z)({
                        display: "flex",
                        padding: "8px 0 8px 24px",
                        alignItems: "center",
                        opacity: disabled ? 0.5 : 1,
                        color: active ? palette/* innovatorBlue */.LD : "#5A6677",
                        fontWeight: active ? 600 : "normal",
                        fontSize: 16
                    }),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                            mr: 16,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
                                width: 24,
                                height: 24,
                                color: active ? palette/* innovatorBlue */.LD : palette/* darkGray */.O5
                            })
                        }),
                        title,
                        " ",
                        !!count && count > 0 && active && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CountBadge/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            css: {
                                backgroundColor: "#5A6677",
                                color: palette/* white */.ix
                            }
                        }, circleProps), {
                            children: count > 99 ? "99+" : count
                        }))
                    ]
                })
            }),
            active && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: (0,mediaQueries/* default */.Z)({
                    marginLeft: 36,
                    textAlign: "left",
                    borderLeft: "solid 2px ".concat(active ? palette/* innovatorBlue */.LD : palette/* lightestGray */.v2)
                }),
                children: children
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/vendor/profile/owner/VendorOwnerNavbarTab.tsx











function VendorOwnerNavbarTab(_param) {
    var href = _param.href, as = _param.as, title = _param.title, active = _param.active, count = _param.count, Icon = _param.icon, tmp = _param.planIcon, PlanIcon = tmp === void 0 ? MakersIcon/* default */.Z : tmp, dataIntercomTarget = _param.dataIntercomTarget, disabled = _param.disabled, _alwaysShowCounter = _param.alwaysShowCounter, alwaysShowCounter = _alwaysShowCounter === void 0 ? false : _alwaysShowCounter, props = (0,_object_without_properties/* default */.Z)(_param, [
        "href",
        "as",
        "title",
        "active",
        "count",
        "icon",
        "planIcon",
        "dataIntercomTarget",
        "disabled",
        "alwaysShowCounter"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        "data-intercom-target": dataIntercomTarget,
        css: {
            display: "flex",
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: href,
                as: as,
                passHref: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    css: (0,mediaQueries/* default */.Z)({
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        width: "100%",
                        padding: "8px 0 8px 24px",
                        color: active ? palette/* innovatorBlue */.LD : "#5A6677",
                        fontWeight: active ? 600 : "normal",
                        fontSize: 16,
                        opacity: disabled ? 0.5 : 1
                    })
                }, props), {
                    children: [
                        Icon && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                            mr: 16,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
                                width: 24,
                                height: 24,
                                color: active ? palette/* innovatorBlue */.LD : "#5A6677"
                            })
                        }),
                        title,
                        " ",
                        !!count && count > 0 && !disabled && (active || alwaysShowCounter) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CountBadge/* default */.Z, {
                            css: {
                                backgroundColor: "#5A6677",
                                color: palette/* white */.ix
                            },
                            children: count > 99 ? "99+" : count
                        })
                    ]
                }))
            }),
            disabled && false && /*#__PURE__*/ 0
        ]
    });
};

;// CONCATENATED MODULE: ./components/vendor/profile/owner/VendorOwnerNavigation.tsx






// import AccountIcon from "../../../icons/VendorProfile/AccountIcon";
// import TeamIcon from "../../../icons/VendorProfile/TeamIcon";
// import EditProfileIcon from "../../../icons/VendorProfile/EditProfileIcon";


// import PreviewIcon from "../../../icons/PreviewIcon";













function VendorOwnerNavigation(param) {
    var vendor = param.vendor, tab = param.tab;
    var intl = (0,useIntl/* default */.Z)();
    var user = (0,Auth/* useSelfie */.yD)();
    var policiesUrls = (0,useIntlPolicies/* default */.Z)();
    if (!user || user.__typename !== "VendorUser") {
        return null;
    }
    var userCanSeeAccountTab = user.role === "COMPANY_OWNER" || vendor.usersCanAccessAccountPage && vendor.viewerIsMember;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(VendorOwnerNavbar, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorOwnerNavbarTab, {
                as: "/vendors/".concat(vendor.slug, "/connect"),
                href: "/vendors/[vendorSlug]/[[...content]]",
                icon: ActivityIcon,
                title: intl.formatMessage({
                    defaultMessage: "Activity",
                    id: "ZmlNQ3"
                }),
                alwaysShowCounter: true,
                count: vendor.feedCount,
                disabled: vendor.plan.tier === types/* IPlanTier.Basic */.fq.Basic,
                active: tab === "connect",
                dataIntercomTarget: getIntercomTarget(user, {
                    asMember: "Activity Navbar Tab",
                    asOwner: "Activity Navbar Tab",
                    asDisruptor: "Activity Navbar Tab for Disruptors"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorOwnerNavbarTab, {
                as: "/vendors/".concat(vendor.slug, "/products"),
                href: "/vendors/[vendorSlug]/[[...content]]",
                icon: ProductsIcon,
                title: intl.formatMessage({
                    id: "7NFfmz",
                    defaultMessage: "Products"
                }),
                count: vendor.productsCount,
                active: tab === "products",
                dataIntercomTarget: getIntercomTarget(user, {
                    asMember: "Products Navbar Tab",
                    asOwner: "Products Navbar Tab",
                    asDisruptor: "Products Navbar Tab for Disruptors"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorOwnerNavbarTab, {
                as: "/vendors/".concat(vendor.slug, "/projects"),
                href: "/vendors/[vendorSlug]/[[...content]]",
                icon: ProjectsIcon,
                title: intl.formatMessage({
                    defaultMessage: "Projects",
                    id: "UxTJRa"
                }),
                disabled: vendor.plan.limits.projectsPerMonth === 0,
                count: vendor.projectsCount,
                active: tab === "projects",
                dataIntercomTarget: getIntercomTarget(user, {
                    asMember: "Projects Navbar Tab",
                    asOwner: "Projects Navbar Tab",
                    asDisruptor: "Projects Navbar Tab for Disruptors"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(VendorOwnerNavbarGroup, {
                href: "/vendors/[vendorSlug]/[[...content]]",
                as: "/vendors/".concat(vendor.slug, "/invite-governments"),
                icon: GovernmentsIcon,
                title: intl.formatMessage({
                    defaultMessage: "Governments",
                    id: "qnQX9U"
                }),
                disabled: !vendor.plan.limits.inviteGovernments,
                dataIntercomTarget: getIntercomTarget(user, {
                    asMember: "Governments Navbar Tab",
                    asOwner: "Governments Navbar Tab",
                    asDisruptor: "Governments Navbar Tab for Disruptors"
                }),
                count: vendor.governmentConnectionsCount,
                active: tab === "invite-governments" || tab === "governments",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorOwnerNavbarTab, {
                        as: "/vendors/".concat(vendor.slug, "/invite-governments"),
                        href: "/vendors/[vendorSlug]/[[...content]]",
                        icon: null,
                        title: intl.formatMessage({
                            defaultMessage: "Invite Governments",
                            id: "ZiH9ot"
                        }),
                        disabled: !vendor.plan.limits.inviteGovernments,
                        active: tab === "invite-governments"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorOwnerNavbarTab, {
                        as: "/vendors/".concat(vendor.slug, "/governments"),
                        href: "/vendors/[vendorSlug]/[[...content]]",
                        icon: null,
                        title: intl.formatMessage({
                            defaultMessage: "Verified Governments",
                            id: "1cTtuP"
                        }),
                        disabled: !vendor.plan.limits.inviteGovernments,
                        active: tab === "governments"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorOwnerNavbarTab, {
                as: "/vendors/".concat(vendor.slug, "/stories"),
                href: "/vendors/[vendorSlug]/[[...content]]",
                icon: StoriesIcon,
                title: intl.formatMessage({
                    defaultMessage: "Stories",
                    id: "Ldxym4"
                }),
                disabled: vendor.plan.tier === types/* IPlanTier.Basic */.fq.Basic,
                count: vendor.storiesCount,
                active: tab === "stories",
                dataIntercomTarget: getIntercomTarget(user, {
                    asMember: "Stories Navbar Tab",
                    asOwner: "Stories Navbar Tab",
                    asDisruptor: "Stories Navbar Tab for Disruptors"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorOwnerNavbarTab, {
                as: "/vendors/".concat(vendor.slug, "/groups"),
                href: "/vendors/[vendorSlug]/[[...content]]",
                icon: GroupsIcon,
                title: intl.formatMessage({
                    id: "hzmswI",
                    defaultMessage: "Groups"
                }),
                count: vendor.groups.length,
                disabled: vendor.plan.limits.groups + vendor.plan.limits.groupInvitations === 0,
                active: tab === "groups",
                dataIntercomTarget: getIntercomTarget(user, {
                    asMember: "Groups Navbar Tab",
                    asOwner: "Groups Navbar Tab",
                    asDisruptor: "Groups Navbar Tab for Disruptors"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorOwnerNavbarTab, {
                as: "/vendors/".concat(vendor.slug, "/actions"),
                href: "/vendors/[vendorSlug]/[[...content]]",
                alwaysShowCounter: true,
                icon: ActionsIcon,
                title: intl.formatMessage({
                    defaultMessage: "Actions",
                    id: "wL7VAE"
                }),
                disabled: vendor.plan.tier === types/* IPlanTier.Basic */.fq.Basic,
                count: vendor.actionsCount,
                active: tab === "actions",
                dataIntercomTarget: getIntercomTarget(user, {
                    asMember: "Actions Navbar Tab",
                    asOwner: "Actions Navbar Tab",
                    asDisruptor: "Actions Navbar Tab for Disruptors"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorOwnerNavbarTab, {
                as: "/vendors/".concat(vendor.slug, "/sharing"),
                href: "/vendors/[vendorSlug]/[[...content]]",
                icon: SharingHubIcon,
                planIcon: MakersProIcon/* default */.Z,
                disabled: !vendor.plan.limits.sharingPage,
                title: intl.formatMessage({
                    defaultMessage: "Sharing Hub",
                    id: "88oiPf"
                }),
                active: tab === "sharing",
                dataIntercomTarget: getIntercomTarget(user, {
                    asMember: "Sharing Hub Navbar Tab",
                    asOwner: "Sharing Hub Navbar Tab",
                    asDisruptor: "Sharing Hub Navbar Tab for Disruptors"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(VendorOwnerNavbarGroup, {
                href: "/vendors/[vendorSlug]/[[...content]]",
                as: "/vendors/".concat(vendor.slug, "/").concat(userCanSeeAccountTab ? "account" : "edit-vendor"),
                css: {
                    marginBottom: [
                        "account",
                        "change-plans",
                        "edit-vendor",
                        "preview-profile",
                        "team"
                    ].includes(tab) ? -16 : 0
                },
                icon: SettingsIcon,
                title: intl.formatMessage({
                    defaultMessage: "Settings",
                    id: "D3idYv"
                }),
                active: [
                    "account",
                    "change-plans",
                    "edit-vendor",
                    "preview-profile",
                    "team"
                ].includes(tab),
                dataIntercomTarget: getIntercomTarget(user, {
                    asMember: "Settings Navbar Tab",
                    asOwner: "Settings Navbar Tab",
                    asDisruptor: "Settings Navbar Tab for Disruptors"
                }),
                children: [
                    userCanSeeAccountTab && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorOwnerNavbarTab, {
                        as: "/vendors/".concat(vendor.slug, "/account"),
                        href: "/vendors/[vendorSlug]/[[...content]]",
                        // icon={AccountIcon}
                        icon: null,
                        title: intl.formatMessage({
                            defaultMessage: "Account",
                            id: "TwyMau"
                        }),
                        active: tab === "account" || tab === "change-plans",
                        css: {
                            padding: "8px 16px"
                        },
                        dataIntercomTarget: getIntercomTarget(user, {
                            asMember: "Account Navbar Tab",
                            asOwner: "Account Navbar Tab",
                            asDisruptor: "Account Navbar Tab for Disruptors"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorOwnerNavbarTab, {
                        as: "/vendors/".concat(vendor.slug, "/edit-vendor"),
                        href: "/vendors/[vendorSlug]/[[...content]]",
                        // icon={EditProfileIcon}
                        icon: null,
                        title: intl.formatMessage({
                            defaultMessage: "Edit Profile",
                            id: "usAvMr"
                        }),
                        active: tab === "edit-vendor",
                        css: {
                            padding: "8px 16px"
                        },
                        dataIntercomTarget: getIntercomTarget(user, {
                            asMember: "Edit Vendor Navbar Tab",
                            asOwner: "Edit Vendor Navbar Tab",
                            asDisruptor: "Edit Vendor Navbar Tab for Disruptors"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorOwnerNavbarTab, {
                        as: vendor.plan.limits.enrichedProfile ? "/vendors/".concat(vendor.slug, "/limits?preview=1&makers=1") : "/vendors/".concat(vendor.slug, "/limits?preview=1"),
                        href: "/vendors/[vendorSlug]/[[...content]]",
                        // icon={PreviewIcon}
                        icon: null,
                        title: intl.formatMessage({
                            defaultMessage: "Preview Profile",
                            id: "Uve4oA"
                        }),
                        active: tab === "preview-profile",
                        css: {
                            padding: "8px 16px"
                        },
                        dataIntercomTarget: getIntercomTarget(user, {
                            asMember: "Preview Profile Navbar Tab",
                            asOwner: "Preview Profile Navbar Tab",
                            asDisruptor: "Preview Profile Navbar Tab for Disruptors"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorOwnerNavbarTab, {
                        as: "/vendors/".concat(vendor.slug, "/team"),
                        href: "/vendors/[vendorSlug]/[[...content]]",
                        // icon={TeamIcon}
                        icon: null,
                        title: intl.formatMessage({
                            defaultMessage: "Team",
                            id: "wsUmh9"
                        }),
                        active: tab === "team",
                        css: {
                            padding: "8px 16px"
                        },
                        dataIntercomTarget: getIntercomTarget(user, {
                            asMember: "Team Navbar Tab",
                            asOwner: "Team Navbar Tab",
                            asDisruptor: "Team Navbar Tab for Disruptors"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            display: "flex",
                            alignItems: "center"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Terms/* default */.Z, {
                            title: intl.formatMessage({
                                defaultMessage: "Terms and Conditions",
                                id: "6qF/vN"
                            }),
                            policyUrl: policiesUrls.termsAndConditions,
                            children: function(toggleOpen) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                    href: "#",
                                    onClick: function(event) {
                                        event.preventDefault();
                                        toggleOpen();
                                    },
                                    css: {
                                        padding: "8px 0 8px 16px",
                                        display: "flex",
                                        opacity: 1,
                                        flexDirection: "row",
                                        alignItems: "center",
                                        color: "#5A6677",
                                        fontWeight: "normal",
                                        fontSize: 16
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Terms of Service",
                                        id: "32rBNK"
                                    })
                                });
                            }
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/vendor/profile/owner/VendorOwnerSidemenu.tsx









function VendorOwnerSidemenu(param) {
    var vendor = param.vendor, tab = param.tab;
    var isMobile = (0,useIsMobile/* default */.Z)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isOpen = ref[0], toggle = ref[1];
    if (!vendor) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            display: "grid",
            justifyItems: "left",
            alignItems: "center",
            backgroundColor: palette/* white */.ix,
            borderRadius: 5,
            border: "solid 1px ".concat(palette/* lightestGray */.v2),
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorOwnerInfo, {
                vendor: vendor
            }),
            !isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    width: "100%",
                    borderTop: "solid 1px ".concat(palette/* lightestGray */.v2)
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorOwnerNavigation, {
                        vendor: vendor,
                        tab: tab
                    })
                })
            }),
            isOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* MobileScreen */.vp, {
                isOpen: isOpen,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* MobileScreenHeader */.uD, {
                        onRequestClose: toggle,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                            css: {
                                margin: 0,
                                color: palette/* text */.fL,
                                fontSize: 24
                            },
                            children: vendor.name
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* MobileScreenBody */.Ly, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            onClick: function() {
                                return setTimeout(toggle, 100);
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorOwnerNavigation, {
                                vendor: vendor,
                                tab: tab
                            })
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-intercom@1.0.15/node_modules/react-intercom/lib/index.js
var react_intercom_lib = __webpack_require__(74134);
;// CONCATENATED MODULE: ./components/makers/UpgradeSuccess.tsx




// eslint-disable-next-line
// @ts-ignore





function UpgradeSuccess() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: (0,utils_mediaQueries/* default */.Z)({
            position: "relative",
            display: "grid",
            gridRowGap: 20,
            alignItems: "center",
            padding: 50,
            textAlign: "center",
            background: palette/* white */.ix,
            border: "solid 1px #e4e4e4",
            borderRadius: 4,
            "> p": {
                color: "#212121",
                fontSize: [
                    16,
                    16,
                    18,
                    23
                ],
                lineHeight: 1.33
            }
        }),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "calc(100% - 200px)",
                    backgroundImage: 'url("/static/makers/confetti.png")',
                    backgroundPosition: "center"
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MakersIcon/* default */.Z, {
                    width: 59,
                    height: 59
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                css: (0,utils_mediaQueries/* default */.Z)({
                    margin: 0,
                    fontSize: [
                        23,
                        23,
                        26,
                        36
                    ],
                    color: "#212121"
                }),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Upgrade Successful",
                    id: "c3JbkI"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Congratulations and welcome to the <strong>Makers</strong> community!",
                    id: "pwO0XI",
                    values: {
                        strong: function(chunk) {
                            return (0,strongify/* default */.Z)(chunk);
                        }
                    }
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Click below to get started with your upgraded account \uD83D\uDC47",
                    id: "bsegy1"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: (0,utils_mediaQueries/* default */.Z)({
                    height: [
                        240,
                        240,
                        240,
                        322
                    ],
                    marginRight: -50,
                    marginLeft: -50,
                    backgroundImage: 'url("/static/makers/upgrade-success.png")',
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "top center"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    display: "flex",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                    color: "#25c088",
                    textColor: palette/* white */.ix,
                    onClick: function() {
                        if (react_intercom_lib/* IntercomAPI */.Bl && typeof react_intercom_lib/* IntercomAPI */.Bl === "function") {
                            // TODO: make sure this is the correct tour ID
                            (0,react_intercom_lib/* IntercomAPI */.Bl)("startTour", "2219251");
                        }
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("strong", {
                        css: {
                            fontSize: 19
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Take Tour",
                            id: "Dl3VDT"
                        })
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/groupBy.js
var groupBy = __webpack_require__(58230);
var groupBy_default = /*#__PURE__*/__webpack_require__.n(groupBy);
// EXTERNAL MODULE: ./components/icons/LinkIcon.tsx
var LinkIcon = __webpack_require__(22143);
;// CONCATENATED MODULE: ./lib/mutations/InviteGovernmentsToAddProduct.ts

function InviteGovernmentsToAddProduct_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation InviteGovernmentsToAddProduct($productId: ObjectId!, $governments: [ObjectId!]!) {\n    inviteGovernmentsToAddProduct(productId: $productId, governments: $governments) {\n      _id\n      product {\n        _id\n        name\n        slug\n        logo\n      }\n      government {\n        _id\n        slug\n        logo\n        name\n        budget\n        currency\n        isInnovator\n        city {\n          _id\n          name\n          population\n          country\n          countryName\n        }\n      }\n      createdAt\n    }\n  }\n"
    ]);
    InviteGovernmentsToAddProduct_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var InviteGovernmentsToAddProduct = ((0,lib/* gql */.Ps)(InviteGovernmentsToAddProduct_templateObject()));

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/uniqBy.js
var uniqBy = __webpack_require__(40768);
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);
// EXTERNAL MODULE: ./node_modules/.pnpm/moment@2.29.4/node_modules/moment/moment.js
var moment = __webpack_require__(98777);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./lib/mutations/CancelProductStackRequest.ts

function CancelProductStackRequest_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation CancelProductStackRequest($requestId: ObjectId!) {\n    cancelProductStackRequest(requestId: $requestId)\n  }\n"
    ]);
    CancelProductStackRequest_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var CancelProductStackRequest = ((0,lib/* gql */.Ps)(CancelProductStackRequest_templateObject()));

// EXTERNAL MODULE: ./lib/utils/getGovlaunchBaseUrl.ts
var getGovlaunchBaseUrl = __webpack_require__(44673);
// EXTERNAL MODULE: ./src/shared/components/IntlRelativeTime.tsx
var IntlRelativeTime = __webpack_require__(89989);
// EXTERNAL MODULE: ./components/icons/ClipboardIcon.tsx
var ClipboardIcon = __webpack_require__(23946);
;// CONCATENATED MODULE: ./components/vendor/profile/PendingGovernmentInvites.tsx




















function PendingGovernmentInvites(param) {
    var vendor = param.vendor, productStackRequests = param.productStackRequests, product = param.product, onRequestClose = param.onRequestClose;
    if (!productStackRequests) {
        return null;
    }
    var user = (0,Auth/* useSelfie */.yD)();
    var inputRef = /*#__PURE__*/ (0,react.createRef)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useClipboard/* default */.Z)(inputRef), 2), copied = ref[0], setClipboard = ref[1];
    if (!user) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("h3", {
                css: {
                    fontWeight: 600,
                    fontSize: 18,
                    color: palette/* darkGray */.O5,
                    margin: 0
                },
                children: [
                    "Pending Invites for ",
                    product.name,
                    " (",
                    productStackRequests.length,
                    ")"
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                mutation: CancelProductStackRequest,
                children: function(cancelProductStackRequest, param) {
                    var loading = param.loading;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                        mt: 24,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                display: "grid",
                                gridTemplateColumns: "repeat(auto-fit, 70px)",
                                gridGap: 32
                            },
                            children: productStackRequests.map(function(productStackRequest) {
                                var isSameHour = moment_default()(productStackRequest.createdAt).isSame(moment_default()().toDate(), "hour");
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
                                    backgroundColor: palette/* innovatorBlue */.LD,
                                    boxStyle: {
                                        padding: "4px 8px",
                                        border: "none",
                                        borderRadius: 4,
                                        boxShadow: "0 10px 40px 0 rgba(34, 35, 40, 0.2)"
                                    },
                                    arrowSize: 8,
                                    render: function() {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                            css: {
                                                color: palette/* white */.ix,
                                                fontWeight: 500,
                                                fontSize: 13,
                                                lineHeight: 1.33,
                                                letterSpacing: 1
                                            },
                                            children: productStackRequest.government.name
                                        });
                                    },
                                    children: function(param) {
                                        var innerRef = param.innerRef, bind = param.bind;
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                            href: "/governments/[governmentSlug]/[[...content]]",
                                            as: "/governments/".concat(productStackRequest.government.slug),
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bind), {
                                                ref: innerRef,
                                                css: {
                                                    position: "relative",
                                                    display: "block",
                                                    color: "unset",
                                                    textDecoration: "none"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                        role: "button",
                                                        css: {
                                                            cursor: "pointer",
                                                            position: "absolute",
                                                            top: -5,
                                                            zIndex: 10,
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            borderRadius: "100%",
                                                            right: -5,
                                                            width: 22,
                                                            height: 22,
                                                            background: palette/* red */.Q6
                                                        },
                                                        onClick: function(event) {
                                                            event.preventDefault();
                                                            if (!loading) {
                                                                cancelProductStackRequest({
                                                                    variables: {
                                                                        requestId: productStackRequest._id
                                                                    },
                                                                    update: function(proxy) {
                                                                        proxy.writeQuery({
                                                                            query: VendorQuery/* default */.Z,
                                                                            variables: {
                                                                                slug: vendor.slug,
                                                                                language: null
                                                                            },
                                                                            data: {
                                                                                __typename: "Query",
                                                                                company: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, vendor), {
                                                                                    pendingProductStackRequests: vendor.pendingProductStackRequests.filter(function(request) {
                                                                                        return request._id !== productStackRequest._id;
                                                                                    })
                                                                                })
                                                                            }
                                                                        });
                                                                    }
                                                                }).then(function() {
                                                                    if (productStackRequests.length === 1 && onRequestClose) {
                                                                        onRequestClose();
                                                                    }
                                                                });
                                                            }
                                                        },
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                                                            width: 10,
                                                            height: 10,
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                                fill: "#FFF",
                                                                d: "M6.188 5l3.566-3.565A.84.84 0 1 0 8.565.246L5 3.812 1.435.246A.84.84 0 1 0 .246 1.435L3.812 5 .246 8.565a.84.84 0 0 0 1.189 1.189L5 6.188l3.565 3.566a.84.84 0 1 0 1.189-1.189L6.188 5z"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                                                        size: 70,
                                                        image: productStackRequest.government.logo,
                                                        name: productStackRequest.government.name,
                                                        css: {
                                                            display: "block"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                        css: {
                                                            display: "block",
                                                            marginTop: 2,
                                                            fontSize: 12,
                                                            color: palette/* darkGray */.O5,
                                                            textAlign: "center"
                                                        },
                                                        children: isSameHour ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                            defaultMessage: "just now",
                                                            id: "I90sbW"
                                                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IntlRelativeTime/* default */.Z, {
                                                            value: productStackRequest.createdAt
                                                        })
                                                    })
                                                ]
                                            }))
                                        });
                                    }
                                }, productStackRequest._id);
                            })
                        })
                    });
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                mt: 24,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: {
                        fontWeight: 500,
                        fontSize: 16,
                        color: palette/* darkGray */.O5
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Send this invite link to your Government contacts to add {productName} to their stacks.",
                        id: "9AeBqJ",
                        values: {
                            productName: product.name
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                mt: 24,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                    css: {
                        boxSizing: "border-box",
                        padding: 12,
                        fontWeight: 500,
                        fontSize: 14,
                        color: palette/* mediumGray */.rF,
                        textAlign: "center",
                        display: "block",
                        fontFamily: "Courier",
                        lineHeight: 1.44,
                        backgroundColor: "transparent",
                        border: "dashed 1px #48A0DA",
                        borderRadius: 4,
                        outline: "none",
                        WebkitAppearance: "none",
                        width: "100%"
                    },
                    value: "".concat((0,getGovlaunchBaseUrl/* default */.Z)(), "/signin?referral=").concat(window.btoa(JSON.stringify({
                        userId: user._id,
                        productId: product._id,
                        type: "product-stack-request"
                    }))),
                    onChange: function() {},
                    onFocus: function(e) {
                        return e.target.select();
                    },
                    readOnly: true,
                    ref: inputRef
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(spacings/* Margin */.Zt, {
                mt: 16,
                css: {
                    display: "flex",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
                        css: {
                            border: 0,
                            outline: 0,
                            background: "none",
                            color: palette/* primary */.T$,
                            fontWeight: 500,
                            fontSize: 14,
                            display: "flex",
                            alignItems: "center",
                            padding: 0,
                            cursor: "pointer",
                            margin: 0
                        },
                        type: "button",
                        onClick: function() {
                            setClipboard();
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Copy invite link",
                                id: "rtACcE"
                            }),
                            " ",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                css: {
                                    marginLeft: 4
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ClipboardIcon/* default */.Z, {})
                            })
                        ]
                    }),
                    copied && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        css: {
                            marginLeft: 6,
                            color: palette/* greenSuccess */.CU
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Copied",
                            id: "p556q3"
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/vendor/profile/InviteGovernmentsModal.tsx







/* eslint-disable-next-line */ 









function InviteGovernmentsModal(param) {
    var vendor = param.vendor, isOpen = param.isOpen, onRequestClose = param.onRequestClose;
    if (!isOpen) {
        return null;
    }
    var ref = (0,react.useState)(null), selectedProduct = ref[0], setSelectedProduct = ref[1];
    var ref1 = (0,react.useState)([]), selectedGovernments = ref1[0], setSelectedGovernments = ref1[1];
    var ref2 = (0,react.useState)(false), nextStep = ref2[0], setNextStep = ref2[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
        mutation: InviteGovernmentsToAddProduct,
        update: function(proxy, param) {
            var data = param.data;
            if (!data) {
                return;
            }
            proxy.writeQuery({
                query: VendorQuery/* default */.Z,
                variables: {
                    slug: vendor.slug,
                    language: null
                },
                data: {
                    __typename: "Query",
                    company: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, vendor), {
                        pendingProductStackRequests: uniqBy_default()("_id", (0,_to_consumable_array/* default */.Z)(vendor.pendingProductStackRequests).concat((0,_to_consumable_array/* default */.Z)(data.inviteGovernmentsToAddProduct)))
                    })
                }
            });
        },
        children: function(inviteGovernments, param) {
            var data = param.data, loading = param.loading;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Modal */.u_, {
                ariaHideApp: false,
                isOpen: isOpen,
                onRequestClose: onRequestClose,
                destroyOnClose: true,
                overlayStyle: {
                    zIndex: 1000
                },
                style: {
                    overflow: "visible"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* ModalClose */.A3, {
                        onClick: onRequestClose
                    }),
                    !(data && data.inviteGovernmentsToAddProduct && selectedProduct) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: (0,mediaQueries/* default */.Z)({
                            width: [
                                350,
                                350,
                                650,
                                650
                            ],
                            padding: 32
                        }),
                        children: [
                            !nextStep && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectGovernmentsStep, {
                                selectedGovernments: selectedGovernments,
                                onSelectGovernments: setSelectedGovernments,
                                onCancel: onRequestClose,
                                onNext: function() {
                                    return setNextStep(true);
                                }
                            }),
                            nextStep && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectProductStep, {
                                confirming: loading,
                                onConfirm: function() {
                                    if (selectedProduct && selectedGovernments.length > 0) {
                                        inviteGovernments({
                                            variables: {
                                                governments: selectedGovernments.map(function(param) {
                                                    var _id = param._id;
                                                    return _id;
                                                }),
                                                productId: selectedProduct._id
                                            }
                                        });
                                    }
                                },
                                selectedProduct: selectedProduct,
                                onSelectProduct: setSelectedProduct,
                                vendorProducts: vendor.products || [],
                                onCancel: onRequestClose
                            })
                        ]
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: (0,mediaQueries/* default */.Z)({
                            width: [
                                350,
                                350,
                                580,
                                580
                            ],
                            padding: 32
                        }),
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PendingGovernmentInvites, {
                            vendor: vendor,
                            productStackRequests: vendor.pendingProductStackRequests.filter(function(request) {
                                return request.product._id === selectedProduct._id;
                            }),
                            product: selectedProduct,
                            onRequestClose: onRequestClose
                        })
                    })
                ]
            });
        }
    });
};
function SelectGovernmentsStep(param) {
    var selectedGovernments = param.selectedGovernments, onSelectGovernments = param.onSelectGovernments, onCancel = param.onCancel, onNext = param.onNext;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                        css: {
                            fontSize: 18,
                            fontWeight: "bold",
                            color: palette/* darkGray */.O5,
                            margin: "0 0 4px",
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                css: {
                                    marginRight: 4
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Add Your Partners",
                                    id: "rxt9M4"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
                                viewBox: "0 0 64 64",
                                width: 22,
                                height: 22,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M1.652 19.564h17V62h-17zM44.862 19.564H62V62H44.862z",
                                        fill: "#5aaae0"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M18.652 2h26.21v60h-26.21z",
                                        fill: "#7dc7ff"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M33.912 48.566a3.923 3.923 0 0 0 1.894-3.343 4 4 0 0 0-8 0 3.923 3.923 0 0 0 1.893 3.343 5.922 5.922 0 0 0-3.893 5.539V62h12v-7.895a5.922 5.922 0 0 0-3.894-5.539z",
                                        fill: "#f73445"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                                        fill: "#359ed8",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                            d: "M22.684 23.512H24.7v1.973h-2.016zM22.684 27.46H24.7v1.973h-2.016zM22.684 31.407H24.7v1.973h-2.016zM22.684 35.354H24.7v1.974h-2.016zM26.717 23.512h2.016v1.973h-2.016zM26.717 27.46h2.016v1.973h-2.016zM26.717 31.407h2.016v1.973h-2.016zM26.717 35.354h2.016v1.974h-2.016zM30.749 23.512h2.016v1.973H30.75zM30.749 27.46h2.016v1.973H30.75zM30.749 31.407h2.016v1.973H30.75zM30.749 35.354h2.016v1.974H30.75zM34.781 23.512h2.017v1.973H34.78zM26.717 19.564h2.016v1.974h-2.016zM30.749 19.564h2.016v1.974H30.75zM34.781 19.564h2.017v1.974H34.78zM34.781 27.46h2.017v1.973H34.78zM34.781 31.407h2.017v1.973H34.78zM34.781 35.354h2.017v1.974H34.78zM38.814 23.512h2.016v1.973h-2.016zM38.814 27.46h2.016v1.973h-2.016zM38.814 31.407h2.016v1.973h-2.016zM38.814 35.354h2.016v1.974h-2.016z"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M13.47 52.485a2.93 2.93 0 0 0 1.166-2.328 3 3 0 0 0-6 0A2.93 2.93 0 0 0 9.8 52.485a4.93 4.93 0 0 0-3.165 4.58V62h10v-4.934a4.93 4.93 0 0 0-3.166-4.581z",
                                        fill: "#f7f769"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M22.543 49.524a2.93 2.93 0 0 0 1.165-2.327 3 3 0 0 0-6 0 2.93 2.93 0 0 0 1.166 2.327 4.93 4.93 0 0 0-3.166 4.581V62h10v-7.895a4.93 4.93 0 0 0-3.165-4.581z",
                                        fill: "#ffc943"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M53.794 52.485a2.93 2.93 0 0 0 1.166-2.328 3 3 0 0 0-6 0 2.93 2.93 0 0 0 1.165 2.328 4.93 4.93 0 0 0-3.166 4.58V62h10v-4.934a4.93 4.93 0 0 0-3.165-4.581z",
                                        fill: "#f7f769"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M44.72 49.524a2.93 2.93 0 0 0 1.167-2.327 3 3 0 0 0-6 0 2.93 2.93 0 0 0 1.165 2.327 4.93 4.93 0 0 0-3.165 4.581V62h10v-7.895a4.93 4.93 0 0 0-3.166-4.581z",
                                        fill: "#ffc943"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M49.903 26.472h2.016v15.79h-2.016zM55.951 26.472h2.017v15.79H55.95zM5.546 26.472h2.017v15.79H5.546zM11.595 26.472h2.016v15.79h-2.016z",
                                        fill: "#005889"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M23.692 4.76h16.13v9.87h-16.13z",
                                        fill: "#359ed8"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                        css: {
                            fontSize: 14,
                            margin: 0,
                            color: palette/* mediumGray */.rF
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Invite your government partner to verify that they use one of your solutions",
                            id: "jdSmPk"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                mt: 28,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(algolia/* SearchAlgoliaIndex */.d, {
                    index: "governments",
                    children: function(param) {
                        var governments = param.results, inputValue = param.searchValue, onInputValueChange = param.onChange;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_select/* MultiGovernmentSelect */.pK, {
                            selectableGovernments: governments,
                            css: {
                                minWidth: 300
                            },
                            governments: selectedGovernments,
                            inputValue: inputValue,
                            onInputValueChange: onInputValueChange,
                            onChange: onSelectGovernments,
                            placeholder: intl.formatMessage({
                                defaultMessage: "Find your government",
                                id: "WAV/MK"
                            })
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                mt: 28,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "flex",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                            color: palette/* innovatorBlue */.LD,
                            textColor: palette/* white */.ix,
                            disabled: selectedGovernments.length === 0,
                            onClick: onNext,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Next",
                                id: "9+Ddtu"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                            ml: 8,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                href: "#",
                                onClick: onCancel,
                                css: {
                                    color: palette/* mediumGray */.rF,
                                    fontSize: 14
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Cancel",
                                    id: "47FYwb"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}
function SelectProductStep(param) {
    var selectedProduct = param.selectedProduct, onSelectProduct = param.onSelectProduct, vendorProducts = param.vendorProducts, onCancel = param.onCancel, onConfirm = param.onConfirm, confirming = param.confirming;
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useState)(""), inputValue = ref[0], setInputValue = ref[1];
    var products = vendorProducts.filter(function(product) {
        if (!inputValue) {
            return true;
        }
        return product.name.toLowerCase().includes(inputValue.toLowerCase());
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                        css: {
                            fontSize: 18,
                            fontWeight: "bold",
                            color: palette/* darkGray */.O5,
                            margin: "0 0 4px",
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                css: {
                                    marginRight: 4
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Select Product",
                                    id: "5JlF3Y"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
                                viewBox: "0 0 64 64",
                                width: 22,
                                height: 22,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M1.652 19.564h17V62h-17zM44.862 19.564H62V62H44.862z",
                                        fill: "#5aaae0"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M18.652 2h26.21v60h-26.21z",
                                        fill: "#7dc7ff"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M33.912 48.566a3.923 3.923 0 0 0 1.894-3.343 4 4 0 0 0-8 0 3.923 3.923 0 0 0 1.893 3.343 5.922 5.922 0 0 0-3.893 5.539V62h12v-7.895a5.922 5.922 0 0 0-3.894-5.539z",
                                        fill: "#f73445"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                                        fill: "#359ed8",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                            d: "M22.684 23.512H24.7v1.973h-2.016zM22.684 27.46H24.7v1.973h-2.016zM22.684 31.407H24.7v1.973h-2.016zM22.684 35.354H24.7v1.974h-2.016zM26.717 23.512h2.016v1.973h-2.016zM26.717 27.46h2.016v1.973h-2.016zM26.717 31.407h2.016v1.973h-2.016zM26.717 35.354h2.016v1.974h-2.016zM30.749 23.512h2.016v1.973H30.75zM30.749 27.46h2.016v1.973H30.75zM30.749 31.407h2.016v1.973H30.75zM30.749 35.354h2.016v1.974H30.75zM34.781 23.512h2.017v1.973H34.78zM26.717 19.564h2.016v1.974h-2.016zM30.749 19.564h2.016v1.974H30.75zM34.781 19.564h2.017v1.974H34.78zM34.781 27.46h2.017v1.973H34.78zM34.781 31.407h2.017v1.973H34.78zM34.781 35.354h2.017v1.974H34.78zM38.814 23.512h2.016v1.973h-2.016zM38.814 27.46h2.016v1.973h-2.016zM38.814 31.407h2.016v1.973h-2.016zM38.814 35.354h2.016v1.974h-2.016z"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M13.47 52.485a2.93 2.93 0 0 0 1.166-2.328 3 3 0 0 0-6 0A2.93 2.93 0 0 0 9.8 52.485a4.93 4.93 0 0 0-3.165 4.58V62h10v-4.934a4.93 4.93 0 0 0-3.166-4.581z",
                                        fill: "#f7f769"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M22.543 49.524a2.93 2.93 0 0 0 1.165-2.327 3 3 0 0 0-6 0 2.93 2.93 0 0 0 1.166 2.327 4.93 4.93 0 0 0-3.166 4.581V62h10v-7.895a4.93 4.93 0 0 0-3.165-4.581z",
                                        fill: "#ffc943"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M53.794 52.485a2.93 2.93 0 0 0 1.166-2.328 3 3 0 0 0-6 0 2.93 2.93 0 0 0 1.165 2.328 4.93 4.93 0 0 0-3.166 4.58V62h10v-4.934a4.93 4.93 0 0 0-3.165-4.581z",
                                        fill: "#f7f769"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M44.72 49.524a2.93 2.93 0 0 0 1.167-2.327 3 3 0 0 0-6 0 2.93 2.93 0 0 0 1.165 2.327 4.93 4.93 0 0 0-3.165 4.581V62h10v-7.895a4.93 4.93 0 0 0-3.166-4.581z",
                                        fill: "#ffc943"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M49.903 26.472h2.016v15.79h-2.016zM55.951 26.472h2.017v15.79H55.95zM5.546 26.472h2.017v15.79H5.546zM11.595 26.472h2.016v15.79h-2.016z",
                                        fill: "#005889"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M23.692 4.76h16.13v9.87h-16.13z",
                                        fill: "#359ed8"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                        css: {
                            fontSize: 14,
                            margin: 0,
                            color: palette/* mediumGray */.rF
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Which product would you like to include in this invite?",
                            id: "oFUVi6"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                mt: 28,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_select/* ProductSelect */.iF, {
                    value: selectedProduct,
                    css: {
                        minWidth: 300
                    },
                    products: products,
                    inputValue: inputValue,
                    onInputValueChange: setInputValue,
                    onChange: onSelectProduct,
                    placeholder: intl.formatMessage({
                        defaultMessage: "Select your product",
                        id: "g5mjtM"
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                mt: 28,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "flex",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                            color: palette/* innovatorBlue */.LD,
                            textColor: palette/* white */.ix,
                            disabled: !selectedProduct || confirming,
                            onClick: onConfirm,
                            children: confirming ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Sending Invites",
                                id: "jE87Cf"
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Send Invites",
                                id: "NVxaQu"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                            ml: 8,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                href: "#",
                                onClick: onCancel,
                                css: {
                                    color: palette/* mediumGray */.rF,
                                    fontSize: 14
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Cancel",
                                    id: "47FYwb"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/vendor/profile/VendorInviteGovernments.tsx



















function VendorInviteGovernments(param) {
    var vendor = param.vendor;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isOpen = ref[0], toggle = ref[1];
    var requestsByProduct = groupBy_default()("product._id", vendor.pendingProductStackRequests);
    if (!vendor.plan.limits.inviteGovernments && vendor.viewerIsMember) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpgradeAccountBanner/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InviteGovernmentsModal, {
                vendor: vendor,
                isOpen: isOpen,
                onRequestClose: toggle
            }),
            vendor.pendingProductStackRequests.length === 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InviteGovernmentsPlaceholder, {
                slug: vendor.slug,
                onClickToggle: toggle
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                        mb: 16,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Button */.zx, {
                            theme: "secondary",
                            size: "large",
                            type: "button",
                            onClick: toggle,
                            color: palette/* lightestGray */.v2,
                            textColor: palette/* darkGray */.O5,
                            css: {
                                background: "#fff",
                                fontSize: 16,
                                display: "inline-flex",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentsIcon, {
                                    width: 16,
                                    height: 16,
                                    color: palette/* darkGray */.O5
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    css: {
                                        marginLeft: 8,
                                        height: 15
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Add Government",
                                        id: "5/r8pz"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            marginBottom: 16,
                            "> div:not(first-of-type)": {
                                marginTop: 16
                            }
                        },
                        children: Object.keys(requestsByProduct).map(function(productId) {
                            var requests = requestsByProduct[productId];
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    background: "#fff",
                                    borderRadius: 4,
                                    border: "1px solid ".concat(palette/* lightestGray */.v2)
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        css: {
                                            fontWeight: 500,
                                            color: palette/* darkGray */.O5,
                                            fontSize: 16,
                                            padding: 16,
                                            borderBottom: "1px solid ".concat(palette/* lightestGray */.v2),
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                                                image: requests[0].product.logo,
                                                name: requests[0].product.name,
                                                size: 24
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                                css: {
                                                    marginLeft: 8
                                                },
                                                children: [
                                                    requests[0].product.name,
                                                    " ",
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "Invites",
                                                        id: "Wy+Idb"
                                                    }),
                                                    " (",
                                                    requests.length,
                                                    ")"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Toggle */.ZD, {
                                                initial: false,
                                                children: function(param) {
                                                    var isOpen = param.on, toggle = param.toggle;
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                                                role: "button",
                                                                onClick: toggle,
                                                                css: {
                                                                    cursor: "pointer",
                                                                    marginLeft: "auto",
                                                                    fontWeight: 500,
                                                                    fontSize: 16,
                                                                    display: "inline-flex",
                                                                    alignItems: "center",
                                                                    color: palette/* innovatorBlue */.LD
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkIcon/* default */.Z, {
                                                                        fill: palette/* innovatorBlue */.LD,
                                                                        css: {
                                                                            marginRight: 8
                                                                        }
                                                                    }),
                                                                    " ",
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                            defaultMessage: "Invite Link",
                                                                            id: "iLUQIP"
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Modal */.u_, {
                                                                ariaHideApp: false,
                                                                isOpen: isOpen,
                                                                onRequestClose: toggle,
                                                                destroyOnClose: true,
                                                                overlayStyle: {
                                                                    zIndex: 1000
                                                                },
                                                                style: {
                                                                    overflow: "visible"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* ModalClose */.A3, {
                                                                        onClick: toggle
                                                                    }),
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                                        css: (0,mediaQueries/* default */.Z)({
                                                                            width: [
                                                                                350,
                                                                                350,
                                                                                580,
                                                                                580
                                                                            ],
                                                                            padding: 32
                                                                        }),
                                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PendingGovernmentInvites, {
                                                                            product: requests[0].product,
                                                                            productStackRequests: requests,
                                                                            vendor: vendor,
                                                                            onRequestClose: toggle
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    });
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: {
                                            padding: 16
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            css: (0,mediaQueries/* default */.Z)({
                                                display: "grid",
                                                gridTemplateColumns: [
                                                    "1fr",
                                                    "repeat(3, 1fr)"
                                                ],
                                                gridGap: 16
                                            }),
                                            children: requests.map(function(request) {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentRichLink, {
                                                    government: request.government
                                                }, request._id);
                                            })
                                        })
                                    })
                                ]
                            }, productId);
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/vendor/profile/owner/VendorOwnerProfile.tsx




















function VendorOwnerProfile(param) {
    var vendor = param.vendor, user = param.user, tab = param.tab, groupSlug = param.groupSlug;
    if (!vendor) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            marginTop: 30,
            marginBottom: 30,
            width: "100%"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Grid */.rj, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* RowWrap */.xv, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Col */.JX, {
                        width: [
                            1,
                            1,
                            3 / 12,
                            3 / 12
                        ],
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                display: "grid",
                                gridRowGap: 24
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorOwnerSidemenu, {
                                vendor: vendor,
                                tab: tab
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Col */.JX, {
                        width: [
                            1,
                            1,
                            9 / 12,
                            9 / 12
                        ],
                        mt: [
                            24,
                            24,
                            0,
                            0
                        ],
                        children: [
                            tab === "connect" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorOwnerFeedTab, {
                                user: user,
                                vendor: vendor
                            }),
                            tab === "products" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorOwnerProductsTab, {
                                vendor: vendor
                            }),
                            tab === "projects" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FullVendorProjects, {
                                vendor: vendor
                            }),
                            tab === "governments" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorGovernmentConnections, {
                                vendor: vendor
                            }),
                            tab === "invite-governments" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorInviteGovernments, {
                                vendor: vendor
                            }),
                            tab === "stories" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorStories, {
                                vendor: vendor
                            }),
                            tab === "groups" && !groupSlug && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorGroups, {
                                vendor: vendor
                            }),
                            tab === "groups" && groupSlug && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditVendorGroup, {
                                groupSlug: groupSlug,
                                vendor: vendor
                            }),
                            tab === "new-group" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewVendorGroup, {
                                vendor: vendor
                            }),
                            tab === "actions" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_VendorActions, {
                                vendor: vendor
                            }),
                            tab === "sharing" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorOwnerSharingTab, {
                                vendor: vendor
                            }),
                            tab === "account" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyAccountBillingInfo, {
                                    vendor: vendor
                                })
                            }),
                            tab === "edit-vendor" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditVendorForm/* default */.Z, {
                                vendor: vendor
                            }),
                            tab === "change-plans" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChangePlans, {})
                            }),
                            tab === "preview-profile" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                children: "UNDER CONSTRUCTION..."
                            }),
                            tab === "team" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorTeam, {
                                vendor: vendor
                            }),
                            tab === "upgrade-success" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpgradeSuccess, {})
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/getOr.js
var getOr = __webpack_require__(62076);
var getOr_default = /*#__PURE__*/__webpack_require__.n(getOr);
// EXTERNAL MODULE: ./components/cover/Cover.tsx + 3 modules
var Cover = __webpack_require__(42607);
// EXTERNAL MODULE: ./components/makers/userHasSearchAccess.ts
var userHasSearchAccess = __webpack_require__(20948);
// EXTERNAL MODULE: ./components/profile/Team.tsx
var Team = __webpack_require__(13005);
// EXTERNAL MODULE: ./components/newsworthy/RelatedUrlCard.tsx
var RelatedUrlCard = __webpack_require__(90416);
;// CONCATENATED MODULE: ./components/icons/StarIcon.tsx




var StarIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "aria-hidden": "true",
        "data-prefix": "fal",
        "data-icon": "star",
        className: "prefix__svg-inline--fa prefix__fa-star prefix__fa-w-18",
        viewBox: "0 0 576 512",
        width: 35,
        height: 31
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fill: "currentColor",
            d: "M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM405.8 317.9l27.8 162L288 403.5 142.5 480l27.8-162L52.5 203.1l162.7-23.6L288 32l72.8 147.5 162.7 23.6-117.7 114.8z"
        })
    }));
};
/* harmony default export */ var icons_StarIcon = (StarIcon);

// EXTERNAL MODULE: ./components/profile/Resources.tsx
var Resources = __webpack_require__(57473);
;// CONCATENATED MODULE: ./components/vendor/tabs/VendorHighlights.tsx










function VendorHighlights(param) {
    var vendor = param.vendor;
    var resourcesExist = vendor.resources && vendor.resources.length > 0;
    if (vendor.highlights.length === 0 && vendor.newsworthy.length === 0 && !resourcesExist) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProfileBox, {
            css: {
                padding: 26
            },
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: palette/* white */.ix,
                    color: palette/* mediumGray */.rF
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_StarIcon, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                        ml: 14,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            css: {
                                fontSize: 18,
                                fontWeight: 500
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "No highlights",
                                id: "vma3lC"
                            })
                        })
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        children: [
            vendor.highlights && vendor.highlights.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                mb: 24,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        height: "100%",
                        backgroundColor: palette/* white */.ix,
                        border: "1px solid ".concat(palette/* lightestGray */.v2),
                        borderRadius: 5
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                padding: 16,
                                textTransform: "uppercase",
                                fontSize: 12,
                                color: palette/* darkGray */.O5,
                                letterSpacing: 0.5,
                                fontWeight: 500,
                                borderBottom: "solid 1px ".concat(palette/* lightestGray */.v2)
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Highlights",
                                id: "KGmQjH"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                padding: 16
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
                                css: {
                                    listStyle: "none",
                                    margin: 0,
                                    padding: 0,
                                    display: "grid",
                                    gridRowGap: 5
                                },
                                children: (vendor.highlights || []).map(function(highlight, index) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                                        css: {
                                            margin: 0,
                                            padding: 0,
                                            fontSize: 15,
                                            color: palette/* text */.fL,
                                            lineHeight: 1.5,
                                            verticalAlign: "middle",
                                            display: "flex",
                                            alignItems: "baseline"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                css: {
                                                    display: "inline-block",
                                                    paddingRight: 20,
                                                    marginRight: 0,
                                                    width: 13,
                                                    textAlign: "center"
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                    css: {
                                                        backgroundColor: palette/* primary */.T$,
                                                        width: 10,
                                                        height: 10,
                                                        display: "inline-block",
                                                        borderRadius: "100%"
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                css: {
                                                    wordBreak: "break-word"
                                                },
                                                children: highlight
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        })
                    ]
                })
            }),
            vendor.newsworthy.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                        css: {
                            fontSize: 16,
                            color: palette/* darkGray */.O5,
                            fontWeight: "normal"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Newsworthy",
                            id: "JhItYg"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: (0,mediaQueries/* default */.Z)({
                            display: "grid",
                            gridTemplateColumns: [
                                "1fr",
                                "1fr",
                                "1fr 1fr"
                            ],
                            gridColumnGap: 16,
                            gridRowGap: 16
                        }),
                        children: vendor.newsworthy.map(function(newsworthyItem) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RelatedUrlCard/* RelatedUrlCard */.l, {
                                description: newsworthyItem.description || "",
                                title: newsworthyItem.title,
                                url: newsworthyItem.url,
                                siteName: newsworthyItem.siteName,
                                favicon: newsworthyItem.favicon || ""
                            }, newsworthyItem.url);
                        })
                    })
                ]
            }),
            vendor.resources && vendor.resources.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Resources/* default */.Z, {
                resources: vendor.resources,
                titleColor: palette/* darkGray */.O5
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/vendor/profile/GovernmentConnectionsBox.tsx







function GovernmentConnectionsBox(param) {
    var vendor = param.vendor;
    var governments = vendor.governmentConnections && vendor.governmentConnections.items ? vendor.governmentConnections.items.slice(0, 4) : [];
    if (!governments) {
        return null;
    }
    if (!vendor.plan.limits.enrichedProfile) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            backgroundColor: palette/* white */.ix,
            borderRadius: 5,
            border: "solid 1px ".concat(palette/* lightestGray */.v2),
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    padding: 15,
                    borderBottom: "solid 1px ".concat(palette/* lightestGray */.v2),
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    css: {
                        textTransform: "uppercase",
                        fontSize: 12,
                        color: palette/* sealBlue */.N9,
                        letterSpacing: 0.5,
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Government Connections ({governmentConnectionsCount})",
                        id: "C7I5jD",
                        values: {
                            governmentConnectionsCount: vendor.governmentConnectionsCount
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    display: "grid",
                    padding: 15,
                    gridRowGap: 15
                },
                children: governments.map(function(government) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentRichLink, {
                        government: government
                    }, government._id);
                })
            }),
            vendor.governmentConnectionsCount > 4 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: "/vendors/[vendorSlug]/[[...content]]",
                as: "/vendors/".concat(vendor.slug, "/governments"),
                passHref: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShowMore/* ShowMore */.g, {})
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-share@4.4.0_react@17.0.2/node_modules/react-share/es/FacebookIcon.js
var FacebookIcon = __webpack_require__(74239);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-share@4.4.0_react@17.0.2/node_modules/react-share/es/LinkedinIcon.js
var LinkedinIcon = __webpack_require__(80022);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-share@4.4.0_react@17.0.2/node_modules/react-share/es/TwitterIcon.js
var TwitterIcon = __webpack_require__(22770);
// EXTERNAL MODULE: ./components/icons/InstagramIcon.tsx
var InstagramIcon = __webpack_require__(3815);
// EXTERNAL MODULE: ./components/icons/YoutubeIcon.tsx
var YoutubeIcon = __webpack_require__(11444);
// EXTERNAL MODULE: ./components/profile/Website.tsx
var Website = __webpack_require__(68471);
// EXTERNAL MODULE: ./lib/utils/getHostname.ts
var getHostname = __webpack_require__(6044);
;// CONCATENATED MODULE: ./components/vendor/profile/VendorInfo.tsx














function VendorInfo(param) {
    var vendor = param.vendor, preview = param.preview, translationButton = param.translationButton;
    var isPreviewingAsBasic = preview === "current";
    var isPreviewingAsMaker = preview === "makers";
    var canSeeExtendedInfo = (vendor.plan.limits.enrichedProfile || isPreviewingAsMaker) && !isPreviewingAsBasic;
    var isMobile = (0,useIsMobile/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            display: "grid",
            justifyItems: "center",
            backgroundColor: palette/* white */.ix,
            borderRadius: 5,
            border: "solid 1px ".concat(palette/* lightestGray */.v2),
            overflow: "hidden"
        },
        children: [
            vendor.usersCanRequestContentTranslation && translationButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    display: "flex",
                    width: "100%",
                    justifyContent: "flex-end",
                    marginTop: isMobile ? "5px" : 0,
                    marginRight: isMobile ? "5px" : 0,
                    marginBottom: "-15px"
                },
                children: translationButton()
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                mt: 24,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        position: "relative"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                            image: vendor.logo,
                            name: vendor.name,
                            size: 100
                        }),
                        vendor.sponsorships.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SponsorshipBadges, {
                            sponsorships: vendor.sponsorships,
                            vendorLogoSize: 100
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    margin: "0 15px",
                    textAlign: "center"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                        mt: 12,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                            css: {
                                margin: 0,
                                color: palette/* text */.fL,
                                fontSize: 26
                            },
                            children: vendor.name
                        })
                    }),
                    (vendor.yearFounded || vendor.numberOfEmployees) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                        mt: 4,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: palette/* mediumGray */.rF,
                                fontSize: 14
                            },
                            children: [
                                vendor.yearFounded && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Founded in {year}",
                                    id: "ZpCZYw",
                                    values: {
                                        year: vendor.yearFounded
                                    }
                                }),
                                " ",
                                vendor.yearFounded && vendor.numberOfEmployees && canSeeExtendedInfo && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                    mx: 3,
                                    children: "|"
                                }),
                                vendor.numberOfEmployees && canSeeExtendedInfo && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Contains {count} {count, plural, one {employee} other {employees}}",
                                    id: "n7jGCZ",
                                    values: {
                                        count: vendor.numberOfEmployees
                                    }
                                })
                            ]
                        })
                    }),
                    vendor.description && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                        mt: 12,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                            css: {
                                color: palette/* mediumGray */.rF
                            },
                            children: vendor.description
                        })
                    }),
                    vendor.slogan && canSeeExtendedInfo && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                        mt: 18,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                display: "grid",
                                gridColumnGap: 8,
                                gridAutoFlow: "column",
                                justifyContent: "center",
                                color: palette/* sealBlue */.N9,
                                fontStyle: "italic"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                children: [
                                    '"',
                                    vendor.slogan,
                                    '"'
                                ]
                            })
                        })
                    })
                ]
            }),
            canSeeExtendedInfo && vendor.socialMedia && (vendor.socialMedia.facebook || vendor.socialMedia.instagram || vendor.socialMedia.linkedin || vendor.socialMedia.twitter || vendor.socialMedia.youtube) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                mt: 18,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "grid",
                        gridColumnGap: 18,
                        gridAutoFlow: "column",
                        justifyContent: "center"
                    },
                    children: [
                        vendor.socialMedia.facebook && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                            href: vendor.socialMedia.facebook,
                            external: "outside-redirect",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FacebookIcon/* default */.Z, {
                                size: 32,
                                round: true
                            })
                        }),
                        vendor.socialMedia.instagram && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                            href: vendor.socialMedia.instagram,
                            external: "outside-redirect",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InstagramIcon/* default */.Z, {
                                height: 32,
                                width: 32
                            })
                        }),
                        vendor.socialMedia.linkedin && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                            href: vendor.socialMedia.linkedin,
                            external: "outside-redirect",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkedinIcon/* default */.Z, {
                                size: 32,
                                round: true
                            })
                        }),
                        vendor.socialMedia.twitter && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                            href: vendor.socialMedia.twitter,
                            external: "outside-redirect",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TwitterIcon/* default */.Z, {
                                size: 32,
                                round: true
                            })
                        }),
                        vendor.socialMedia.youtube && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                            href: vendor.socialMedia.youtube,
                            external: "outside-redirect",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(YoutubeIcon/* default */.Z, {
                                height: 32,
                                width: 32
                            })
                        })
                    ]
                })
            }),
            vendor.site && !vendor.contactPage && !vendor.businessEmail && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    width: "100%",
                    padding: 15,
                    borderTop: "solid 1px ".concat(palette/* lightestGray */.v2),
                    marginTop: 18
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Website/* default */.Z, {
                        url: vendor.site
                    }),
                    " "
                ]
            }),
            vendor.site && (vendor.contactPage || vendor.businessEmail) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    width: "100%",
                    padding: 15,
                    borderTop: "solid 1px ".concat(palette/* lightestGray */.v2),
                    marginTop: 18,
                    display: "flex",
                    overflow: "hidden"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(spacings/* Margin */.Zt, {
                        mr: 22,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                css: {
                                    fontWeight: 600,
                                    fontSize: 14,
                                    display: "flex"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Website",
                                    id: "JkLHGw"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                href: vendor.site,
                                external: "outside-govlaunch",
                                css: {
                                    color: palette/* darkGray */.O5,
                                    userSelect: "none",
                                    fontSize: 14,
                                    "&:focus, &:visited": {
                                        color: palette/* darkGray */.O5
                                    },
                                    "&:hover": {
                                        color: palette/* darkGray */.O5,
                                        borderBottom: "solid 1px ".concat(palette/* sealBlue */.N9)
                                    }
                                },
                                children: (0,getHostname/* default */.Z)(vendor.site)
                            })
                        ]
                    }),
                    vendor.contactPage && canSeeExtendedInfo && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                css: {
                                    fontWeight: 600,
                                    fontSize: 14,
                                    display: "flex"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Contact page",
                                    id: "G5vdr6"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                href: vendor.contactPage,
                                external: "outside-govlaunch",
                                css: {
                                    color: palette/* darkGray */.O5,
                                    userSelect: "none",
                                    fontSize: 14,
                                    "&:focus, &:visited": {
                                        color: palette/* darkGray */.O5
                                    },
                                    "&:hover": {
                                        color: palette/* darkGray */.O5,
                                        borderBottom: "solid 1px ".concat(palette/* sealBlue */.N9)
                                    }
                                },
                                children: (0,getHostname/* default */.Z)(vendor.contactPage)
                            })
                        ]
                    }),
                    vendor.businessEmail && canSeeExtendedInfo && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            maxWidth: "75%"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                css: {
                                    fontWeight: 600,
                                    fontSize: 14,
                                    display: "flex"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Contact",
                                    id: "zFegDD"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                href: "mailto:".concat(vendor.businessEmail),
                                css: {
                                    color: palette/* darkGray */.O5,
                                    userSelect: "none",
                                    fontSize: 14,
                                    overflowWrap: "break-word",
                                    "&:focus, &:visited": {
                                        color: palette/* darkGray */.O5
                                    },
                                    "&:hover": {
                                        color: palette/* darkGray */.O5,
                                        borderBottom: "solid 1px ".concat(palette/* sealBlue */.N9)
                                    }
                                },
                                children: vendor.businessEmail
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/profile/NewLinkTab.tsx
var NewLinkTab = __webpack_require__(37897);
// EXTERNAL MODULE: ./components/profile/ProfileNavbar.tsx
var ProfileNavbar = __webpack_require__(81558);
;// CONCATENATED MODULE: ./components/vendor/profile/VendorProfileNavbar.tsx





function VendorProfileNavbar(param) {
    var tab = param.tab, vendorSlug = param.vendorSlug, preview = param.preview, canShowAllTabs = param.canShowAllTabs, canShowGovernmentsTab = param.canShowGovernmentsTab, feedCount = param.feedCount, productsCount = param.productsCount, storiesCount = param.storiesCount, projectsCount = param.projectsCount, governmentConnectionsCount = param.governmentConnectionsCount, highlightsCount = param.highlightsCount;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProfileNavbar/* default */.Z, {
        children: [
            canShowAllTabs && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewLinkTab/* default */.Z, {
                href: "/vendors/[vendorSlug]/[[...content]]",
                as: paramsWithPreview({
                    content: "connect",
                    vendorSlug: vendorSlug
                }, preview),
                title: intl.formatMessage({
                    defaultMessage: "Activity",
                    id: "ZmlNQ3"
                }),
                count: feedCount,
                active: tab === "connect"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewLinkTab/* default */.Z, {
                href: "/vendors/[vendorSlug]/[[...content]]",
                as: paramsWithPreview({
                    content: "products",
                    vendorSlug: vendorSlug
                }, preview),
                title: intl.formatMessage({
                    defaultMessage: "Products",
                    id: "7NFfmz"
                }),
                count: productsCount,
                active: tab === "products"
            }),
            canShowAllTabs && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewLinkTab/* default */.Z, {
                href: "/vendors/[vendorSlug]/[[...content]]",
                as: paramsWithPreview({
                    content: "stories",
                    vendorSlug: vendorSlug
                }, preview),
                title: intl.formatMessage({
                    defaultMessage: "Stories",
                    id: "Ldxym4"
                }),
                count: storiesCount,
                active: tab === "stories"
            }),
            canShowAllTabs && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewLinkTab/* default */.Z, {
                href: "/vendors/[vendorSlug]/[[...content]]",
                as: paramsWithPreview({
                    content: "projects",
                    vendorSlug: vendorSlug
                }, preview),
                title: intl.formatMessage({
                    defaultMessage: "Projects",
                    id: "UxTJRa"
                }),
                count: projectsCount,
                active: tab === "projects"
            }),
            canShowGovernmentsTab && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewLinkTab/* default */.Z, {
                href: "/vendors/[vendorSlug]/[[...content]]",
                as: paramsWithPreview({
                    content: "governments",
                    vendorSlug: vendorSlug
                }, preview),
                title: intl.formatMessage({
                    defaultMessage: "Governments",
                    id: "qnQX9U"
                }),
                count: governmentConnectionsCount,
                active: tab === "governments"
            }),
            canShowAllTabs && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewLinkTab/* default */.Z, {
                href: "/vendors/[vendorSlug]/[[...content]]",
                as: paramsWithPreview({
                    content: "highlights",
                    vendorSlug: vendorSlug
                }, preview),
                title: intl.formatMessage({
                    defaultMessage: "Highlights",
                    id: "KGmQjH"
                }),
                count: highlightsCount,
                active: tab === "highlights"
            })
        ]
    });
};
function paramsWithPreview(param, preview) {
    var content = param.content, vendorSlug = param.vendorSlug;
    if (preview) {
        if (preview === "makers") {
            return "/vendors/".concat(vendorSlug, "/").concat(content, "?preview=1&makers=1");
        }
        return "/vendors/".concat(vendorSlug, "/").concat(content, "?preview=1");
    }
    return "/vendors/".concat(vendorSlug, "/").concat(content);
}

// EXTERNAL MODULE: ./components/icons/LeftArrowIcon.tsx
var LeftArrowIcon = __webpack_require__(9128);
;// CONCATENATED MODULE: ./components/vendor/profile/VendorProfilePreviewHeader.tsx








function VendorProfilePreviewHeader(param) {
    var vendorSlug = param.vendorSlug, preview = param.preview, isEnrichedProfile = param.isEnrichedProfile, _userHasOwnerRights = param.userHasOwnerRights, userHasOwnerRights = _userHasOwnerRights === void 0 ? false : _userHasOwnerRights;
    if (!preview) {
        return null;
    }
    var viewingAsBasic = preview === "current";
    var basicSwitchProps = {
        padding: 4,
        ":hover": {
            opacity: 0.8
        }
    };
    var makersSwitchProps = {
        padding: 4,
        ":hover": {
            opacity: 0.8
        }
    };
    var notSelectedProps = {
        color: palette/* darkGray */.O5
    };
    var selectedProps = {
        backgroundImage: "linear-gradient(97deg, #086BE5 10%, #28D094 60%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        fontWeight: "bold"
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Row */.X2, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Col */.JX, {
            width: 1,
            mb: 24,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "flex",
                    width: "100%",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: "/vendors/[vendorSlug]/[[...content]]",
                        as: "/vendors/".concat(vendorSlug, "/").concat(userHasOwnerRights ? "account" : "edit-vendor"),
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                            css: {
                                color: palette/* darkGray */.O5,
                                display: "flex",
                                alignItems: "center",
                                ":hover": {
                                    opacity: 0.7
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LeftArrowIcon/* default */.Z, {
                                    width: 20,
                                    height: 10
                                }),
                                " ",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    css: {
                                        marginLeft: 4
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Leave Preview",
                                        id: "qJ60r9"
                                    })
                                })
                            ]
                        })
                    }),
                    !isEnrichedProfile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            marginLeft: 12,
                            background: "-webkit-linear-gradient(97deg, #086BE5 10%, #28D094 60%);",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            ":hover": {
                                opacity: 0.8
                            }
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                            href: "/makers",
                            passHref: true,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Upgrade to {plan}",
                                    id: "/gko4g",
                                    values: {
                                        plan: "Makers"
                                    }
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            display: "flex",
                            alignItems: "center",
                            marginLeft: "auto"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                href: "/vendors/[vendorSlug]?preview=1",
                                as: "/vendors/".concat(vendorSlug, "?preview=1"),
                                passHref: true,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                    css: viewingAsBasic ? (0,_object_spread/* default */.Z)({}, basicSwitchProps, selectedProps) : (0,_object_spread/* default */.Z)({}, basicSwitchProps, notSelectedProps),
                                    children: viewingAsBasic ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Viewing as {plan}",
                                        id: "xN3lSr",
                                        values: {
                                            plan: "Basic"
                                        }
                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "View as {plan}",
                                        id: "uBVo8f",
                                        values: {
                                            plan: "Basic"
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                href: "/vendors/[vendorSlug]?preview=1&makers=1",
                                as: "/vendors/".concat(vendorSlug, "?preview=1&makers=1"),
                                passHref: true,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                    css: viewingAsBasic ? (0,_object_spread/* default */.Z)({}, makersSwitchProps, notSelectedProps) : (0,_object_spread/* default */.Z)({}, makersSwitchProps, selectedProps),
                                    children: viewingAsBasic ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "View as {plan}",
                                        id: "uBVo8f",
                                        values: {
                                            plan: "Makers"
                                        }
                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Viewing as {plan}",
                                        id: "xN3lSr",
                                        values: {
                                            plan: "Makers"
                                        }
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/vendor/profile/VendorUpgradeRequired.tsx




function VendorUpgradeRequired(param) {
    var user = param.user;
    if (!user.company) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Grid */.rj, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Row */.X2, {
            mb: [
                20,
                20,
                20,
                20
            ],
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Col */.JX, {
                width: [
                    1,
                    1,
                    1,
                    1
                ],
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpgradeToMakersProBanner/* default */.Z, {})
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/vendor/profile/VendorProfile.tsx




























function VendorProfile(param) {
    var vendor = param.vendor, tab = param.tab, preview = param.preview, translationButton = param.translationButton;
    var user = (0,Auth/* useSelfie */.yD)();
    var viewAccess = (0,userHasSearchAccess/* default */.Z)(user) || vendor.viewerIsMember;
    var upgradeRequired = user && user.__typename === "VendorUser" && !viewAccess;
    var isPreviewing = user && user.__typename === "VendorUser" && user.company && user.company._id === vendor._id && preview !== null;
    var isPreviewingAsMaker = preview === "makers";
    var isPreviewingAsBasic = preview === "current";
    var showCover = vendor.cover && vendor.cover.original || !preview && vendor.viewerIsMember;
    var canShowAllTabs = (vendor.plan.limits.enrichedProfile || isPreviewingAsMaker) && !isPreviewingAsBasic;
    var canShowGovernmentsTab = user && user.__typename === "GovernmentUser" && canShowAllTabs;
    var userHasOwnerRights = user && user.__typename === "VendorUser" && vendor.viewerIsMember && (user.role === "COMPANY_OWNER" || vendor.usersCanAccessAccountPage);
    // Component is being shown to a vendor user who has no view rights
    if (upgradeRequired) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorUpgradeRequired, {
            user: user
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Grid */.rj, {
            children: [
                isPreviewing && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorProfilePreviewHeader, {
                    vendorSlug: vendor.slug,
                    userHasOwnerRights: userHasOwnerRights || false,
                    preview: preview,
                    isEnrichedProfile: vendor.plan.limits.enrichedProfile
                }),
                showCover && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Row */.X2, {
                    mb: [
                        20,
                        20,
                        20,
                        20
                    ],
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Col */.JX, {
                        width: [
                            1,
                            1,
                            1,
                            1
                        ],
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                position: "relative"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Cover/* default */.ZP, {
                                alt: "Cover",
                                height: 250,
                                onRemove: function() {},
                                onChange: function() {},
                                onReposition: function() {},
                                originalSource: getOr_default()(null, "cover.original", vendor),
                                repositionedSource: getOr_default()(null, "cover.repositioned", vendor),
                                placeholderSource: Cover/* PLACEHOLDER_COVER */.t2,
                                readOnly: true,
                                containerProps: {
                                    style: {
                                        borderRadius: 5,
                                        overflow: "hidden"
                                    }
                                }
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* RowWrap */.xv, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Col */.JX, {
                            width: [
                                1,
                                1,
                                4 / 12,
                                4 / 12
                            ],
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    display: "grid",
                                    gridRowGap: 24
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorInfo, {
                                        vendor: vendor,
                                        preview: preview,
                                        translationButton: translationButton
                                    }),
                                    vendor.membersCount > 0 && (user === null || user === void 0 ? void 0 : user.__typename) === "GovernmentUser" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Team/* default */.Z, {
                                        members: vendor.members,
                                        viewerIsMember: vendor.viewerIsMember || false,
                                        viewerCanInviteMembers: false,
                                        viewerCanRemoveMembers: false,
                                        targetType: "VENDOR",
                                        targetId: vendor._id
                                    }),
                                    vendor.governmentConnectionsCount > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentConnectionsBox, {
                                        vendor: vendor
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Col */.JX, {
                            width: [
                                1,
                                1,
                                8 / 12,
                                8 / 12
                            ],
                            mt: [
                                24,
                                24,
                                0,
                                0
                            ],
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorProfileNavbar, {
                                    tab: tab,
                                    vendorSlug: vendor.slug,
                                    preview: preview,
                                    canShowAllTabs: canShowAllTabs,
                                    canShowGovernmentsTab: !!canShowGovernmentsTab,
                                    feedCount: vendor.feedCount,
                                    productsCount: vendor.productsCount || 0,
                                    storiesCount: vendor.storiesCount || 0,
                                    projectsCount: vendor.projectsCount || 0,
                                    governmentConnectionsCount: vendor.governmentConnectionsCount,
                                    highlightsCount: vendor.highlightsCount + vendor.newsworthyCount
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    css: {
                                        marginTop: 24
                                    },
                                    children: [
                                        tab === "connect" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            children: [
                                                vendor.feedCount === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                    css: {
                                                        borderRadius: 4,
                                                        border: "1px solid ".concat(palette/* lightestGray */.v2),
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        padding: 16,
                                                        background: "#fff"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ActivityIcon, {
                                                            width: 32,
                                                            height: 32,
                                                            color: palette/* darkGray */.O5
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                                            css: {
                                                                margin: "12px 0 0 0",
                                                                fontSize: 18,
                                                                fontWeight: 500,
                                                                color: palette/* darkGray */.O5
                                                            },
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                defaultMessage: "No Activity",
                                                                id: "vugtF7"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    css: {
                                                        display: "grid",
                                                        gridRowGap: 16
                                                    },
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Feed/* default */.Z, {
                                                        targetId: vendor._id,
                                                        targetType: types/* IConnectTargetType.Vendor */.QY.Vendor,
                                                        showNoPosts: false
                                                    })
                                                })
                                            ]
                                        }),
                                        tab === "products" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            children: [
                                                vendor.productsCount === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                    css: {
                                                        borderRadius: 4,
                                                        border: "1px solid ".concat(palette/* lightestGray */.v2),
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        padding: 16,
                                                        background: "#fff"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductsIcon, {
                                                            width: 32,
                                                            height: 32,
                                                            color: palette/* darkGray */.O5
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                                            css: {
                                                                margin: "12px 0 0 0",
                                                                fontSize: 18,
                                                                fontWeight: 500,
                                                                color: palette/* darkGray */.O5
                                                            },
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                defaultMessage: "No Products",
                                                                id: "Gg4+K7"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                (vendor.products || []).length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorProducts, {
                                                    vendor: vendor
                                                })
                                            ]
                                        }),
                                        tab === "governments" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            children: [
                                                vendor.governmentConnectionsCount === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                    css: {
                                                        borderRadius: 4,
                                                        border: "1px solid ".concat(palette/* lightestGray */.v2),
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        padding: 16,
                                                        background: "#fff"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentsIcon, {
                                                            width: 32,
                                                            height: 32,
                                                            color: palette/* darkGray */.O5
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                                            css: {
                                                                margin: "12px 0 0 0",
                                                                fontSize: 18,
                                                                fontWeight: 500,
                                                                color: palette/* darkGray */.O5
                                                            },
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                defaultMessage: "No Governments",
                                                                id: "TXTwHh"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorGovernmentConnections, {
                                                    showUpgradeBanner: false,
                                                    showPlaceholder: false,
                                                    vendor: vendor
                                                })
                                            ]
                                        }),
                                        tab === "stories" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            children: [
                                                vendor.storiesCount === 0 && false && /*#__PURE__*/ 0,
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorStories, {
                                                    vendor: vendor,
                                                    showUpgradeBanner: false
                                                })
                                            ]
                                        }),
                                        tab === "projects" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            children: [
                                                vendor.projectsCount === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                    css: {
                                                        borderRadius: 4,
                                                        border: "1px solid ".concat(palette/* lightestGray */.v2),
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        padding: 16,
                                                        background: "#fff"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectsIcon, {
                                                            width: 32,
                                                            height: 32,
                                                            color: palette/* darkGray */.O5
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                                            css: {
                                                                margin: "12px 0 0 0",
                                                                fontSize: 18,
                                                                fontWeight: 500,
                                                                color: palette/* darkGray */.O5
                                                            },
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                defaultMessage: "No Projects",
                                                                id: "E4723/"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FullVendorProjects, {
                                                    showUpgradeBanner: false,
                                                    showPlaceholder: false,
                                                    vendor: vendor
                                                })
                                            ]
                                        }),
                                        tab === "actions" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_VendorActions, {
                                                vendor: vendor
                                            })
                                        }),
                                        tab === "highlights" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorHighlights, {
                                            vendor: vendor
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/vendor/VendorPage.tsx














function VendorPage(param) {
    var vendorSlug = param.vendorSlug, tab = param.tab, preview = param.preview, makers = param.makers, groupSlug = param.groupSlug, user = param.user;
    var router = (0,next_router.useRouter)();
    var locale = (0,withIntl/* useIntlLocale */.U)().locale;
    var lang = (0,stringOrFirst/* default */.Z)(router.query.lang);
    var langExists = typeof lang !== "undefined" && lang.length > 0 && lang !== "en-US";
    var targetLanguage = lang || locale;
    var showTranslateButton = langExists || locale !== "en-US";
    var previewAs = preview ? makers ? "makers" : "current" : null;
    var queryTab = constructQueryTab(router.query.content, router.query.preview);
    var ref = (0,useQuery/* useQuery */.a)(VendorQuery/* default */.Z, {
        variables: {
            slug: vendorSlug,
            language: (0,locales/* findLanguageByLocale */.Y)(lang)
        },
        fetchPolicy: "network-only"
    }), data = ref.data, loading = ref.loading, refetch = ref.refetch;
    var translationButton = function() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TranslateTo/* default */.Z, {
            langExists: langExists,
            showTranslateButton: showTranslateButton,
            refetch: function() {
                refetch({
                    slug: vendorSlug,
                    language: (0,locales/* findLanguageByLocale */.Y)(targetLanguage)
                });
            },
            refetchOriginal: function() {
                refetch({
                    slug: vendorSlug,
                    language: null
                });
            }
        });
    };
    if (loading || !data) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: {
                padding: 30,
                width: "100%",
                textAlign: "center"
            },
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* LoadingSpinner */.TK, {})
        });
    }
    if (!data.company) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Redirect/* default */.Z, {
            to: "/"
        });
    }
    var vendor = data.company;
    if (preview && vendor.viewerIsMember) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: {
                paddingTop: 30,
                paddingBottom: 30,
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorPageSeo, {
                    vendor: vendor,
                    tab: queryTab
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorProfile, {
                    vendor: vendor,
                    tab: tab,
                    preview: previewAs,
                    translationButton: translationButton
                })
            ]
        });
    }
    if (vendor.viewerIsMember) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorPageSeo, {
                    vendor: vendor,
                    tab: queryTab
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorOwnerProfile, {
                    vendor: vendor,
                    user: user,
                    tab: tab,
                    groupSlug: groupSlug
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorPageSeo, {
                vendor: vendor,
                tab: queryTab
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    paddingTop: 30,
                    paddingBottom: 30,
                    width: "100%"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorProfile, {
                    vendor: vendor,
                    tab: tab,
                    preview: null,
                    translationButton: translationButton
                })
            })
        ]
    });
};
function constructQueryTab(tab, preview) {
    if (preview && preview === "1") {
        return "preview";
    }
    var queryTab = Array.isArray(tab) ? tab[0] : tab;
    return queryTab || "";
}

// EXTERNAL MODULE: ./lib/utils/safeGetQueryParameter.ts
var safeGetQueryParameter = __webpack_require__(35909);
// EXTERNAL MODULE: ./src/components/navbar/NavbarLayout.tsx + 62 modules
var NavbarLayout = __webpack_require__(71858);
;// CONCATENATED MODULE: ./pages/vendor.tsx






function getTab(content, groupSlug) {
    if (content) {
        return content;
    }
    return groupSlug ? "groups" : "products";
}
var Vendor = function(param) {
    var slug = param.slug, groupSlug = param.groupSlug, content = param.content, preview = param.preview, makers = param.makers;
    var user = (0,Auth/* useSelfie */.yD)();
    var tab = getTab(content || null, groupSlug);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavbarLayout/* default */.Z, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorPage, {
            vendorSlug: slug,
            tab: tab,
            preview: preview,
            makers: makers,
            groupSlug: groupSlug,
            user: user
        })
    });
};
Vendor.getInitialProps = function(param) {
    var query = param.query;
    return {
        slug: (0,safeGetQueryParameter/* default */.Z)(query, "vendorSlug"),
        content: (0,safeGetQueryParameter/* default */.Z)(query, "content"),
        groupSlug: (0,safeGetQueryParameter/* default */.Z)(query, "groupSlug"),
        preview: (0,safeGetQueryParameter/* default */.Z)(query, "preview"),
        makers: (0,safeGetQueryParameter/* default */.Z)(query, "makers"),
        token: (0,safeGetQueryParameter/* default */.Z)(query, "token")
    };
};
/* harmony default export */ var vendor = (Vendor);


/***/ }),

/***/ 70455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProjectCards; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_project__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78062);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19026);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54892);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22051);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59496);
/* harmony import */ var _components_project_EmptyProjectSlot__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33563);
/* harmony import */ var _src_utils_nextLinkHref__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88196);
/* harmony import */ var _src_utils_stringOrFirst__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(39327);
/* harmony import */ var _src_components_project_CreateProjectModal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23115);
/* harmony import */ var _src_components_project_modal_ProjectModal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96077);
/* harmony import */ var _src_components_project_listing_computeNavigationProps__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(36668);
/* harmony import */ var lodash_fp_noop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98483);
/* harmony import */ var lodash_fp_noop__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_noop__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67459);
/* harmony import */ var _lib_withIntl__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(21505);
/* harmony import */ var _src_components_translation_TranslationButton__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(98769);


















function ProjectCards(param) {
    var projects = param.projects, gridProps = param.gridProps, _onClick = param.onClick, onClick = _onClick === void 0 ? (lodash_fp_noop__WEBPACK_IMPORTED_MODULE_9___default()) : _onClick, _withAddProjectSlot = param.withAddProjectSlot, withAddProjectSlot = _withAddProjectSlot === void 0 ? false : _withAddProjectSlot, addProjectSlotText = param.addProjectSlotText, firstLocationId = param.firstLocationId, firstLocationCountry = param.firstLocationCountry, groupId = param.groupId, projectNavigationLimit = param.projectNavigationLimit, onModalClose = param.onModalClose, _routeParams = param.routeParams, routeParams = _routeParams === void 0 ? {} : _routeParams;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var isMobile = (0,_lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), showCreateProjectModal = ref[0], setShowCreateProjectModal = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), relatedProject = ref1[0], setRelatedProject = ref1[1];
    var locale = (0,_lib_withIntl__WEBPACK_IMPORTED_MODULE_11__/* .useIntlLocale */ .U)().locale;
    var projectSlugFromRouter = router.query.projectSlug;
    var langFromRouter = router.query.lang;
    var slugExistsOnProjects = projects.some(function(project) {
        return project.slug === projectSlugFromRouter;
    }) || relatedProject;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_src_components_project_CreateProjectModal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                isOpen: showCreateProjectModal,
                onClose: function() {
                    return setShowCreateProjectModal(false);
                },
                groupId: groupId
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsxs */ .BX)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_1__/* .PageGridContainer */ .pf, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                px: 0
            }, gridProps), {
                children: [
                    withAddProjectSlot && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_components_project_EmptyProjectSlot__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        onClick: function() {
                            return setShowCreateProjectModal(true);
                        },
                        groupId: groupId,
                        text: addProjectSlotText
                    }),
                    projects.map(function(project, index) {
                        var linkHref = isMobile ? "/projects/".concat(project.slug) : (0,_src_utils_nextLinkHref__WEBPACK_IMPORTED_MODULE_6__/* .appendNextLinkHrefParams */ .o)(router, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                            projectSlug: project.slug
                        }, routeParams));
                        var translationLinkHref = isMobile ? "/projects/[projectSlug]" : (0,_src_utils_nextLinkHref__WEBPACK_IMPORTED_MODULE_6__/* .appendNextLinkHrefParams */ .o)(router, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                            projectSlug: project.slug,
                            lang: locale
                        }, routeParams));
                        var translationLinkWrap = function() {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_src_components_translation_TranslationButton__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                paddingY: "4px",
                                onClick: function(event) {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    router.push(translationLinkHref, "/projects/".concat(project.slug, "?lang=").concat(locale));
                                }
                            });
                        };
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: linkHref,
                            as: "/projects/".concat(project.slug),
                            passHref: true,
                            scroll: false,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_govlaunch_project__WEBPACK_IMPORTED_MODULE_0__/* .ProjectCard */ .t, {
                                "data-intercom-target": index === 0 ? "First project" : undefined,
                                project: project,
                                onClick: function(event) {
                                    return onClick(event, project, index);
                                },
                                firstLocationId: firstLocationId,
                                firstLocationCountry: firstLocationCountry,
                                translationLinkWrap: locale !== "en-US" ? translationLinkWrap : undefined
                            })
                        }, project._id);
                    })
                ]
            })),
            projectSlugFromRouter && slugExistsOnProjects && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_src_components_project_modal_ProjectModal__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                onClickProject: function(project) {
                    setRelatedProject(project);
                },
                projectSlug: (0,_src_utils_stringOrFirst__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(projectSlugFromRouter),
                navigation: (0,_src_components_project_listing_computeNavigationProps__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(projects.slice(0, projectNavigationLimit), (0,_src_utils_stringOrFirst__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(projectSlugFromRouter)),
                onClose: onModalClose,
                lang: (0,_src_utils_stringOrFirst__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(langFromRouter)
            })
        ]
    });
};


/***/ }),

/***/ 93921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProjectsListing; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19026);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var _components_form_resources_ShowMoreButtonWithIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38248);
/* harmony import */ var _src_shared_components_NoResultsFound__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57600);
/* harmony import */ var _src_components_project_listing_ProjectCards__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70455);






function ProjectsListing(param) {
    var projects = param.projects, loading = param.loading, onLoadMore = param.onLoadMore, hasNextPage = param.hasNextPage, onModalClose = param.onModalClose, _gridProps = param.gridProps, gridProps = _gridProps === void 0 ? {
        columns: [
            1,
            1,
            2,
            3
        ],
        spacingY: 6
    } : _gridProps, _withAddProjectSlot = param.withAddProjectSlot, withAddProjectSlot = _withAddProjectSlot === void 0 ? false : _withAddProjectSlot, addProjectSlotText = param.addProjectSlotText, groupId = param.groupId, onClickProject = param.onClickProject, _projectNavigationLimit = param.projectNavigationLimit, projectNavigationLimit = _projectNavigationLimit === void 0 ? Infinity : _projectNavigationLimit, firstLocationId = param.firstLocationId, firstLocationCountry = param.firstLocationCountry;
    if (!loading && projects.length === 0) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .PageContainer */ ._z, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_src_shared_components_NoResultsFound__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                mt: 32
            })
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_src_components_project_listing_ProjectCards__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                projects: projects,
                gridProps: gridProps,
                withAddProjectSlot: withAddProjectSlot,
                addProjectSlotText: addProjectSlotText,
                groupId: groupId,
                onClick: onClickProject,
                firstLocationId: firstLocationId,
                firstLocationCountry: firstLocationCountry,
                projectNavigationLimit: projectNavigationLimit,
                onModalClose: onModalClose
            }),
            hasNextPage && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Flex */ .kC, {
                justifyContent: "center",
                mt: 6,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_components_form_resources_ShowMoreButtonWithIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    loading: loading || false,
                    onClick: function() {
                        if (typeof onLoadMore !== "undefined") {
                            onLoadMore();
                        }
                    }
                })
            })
        ]
    });
};


/***/ }),

/***/ 50544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ IntlDateTimeComment; },
/* harmony export */   "Z": function() { return /* binding */ IntlDateTime; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11920);



function IntlDateTime(param) {
    var value = param.value;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_2__/* .FormattedDate */ .Ji, {
        value: value,
        year: "numeric",
        month: "long",
        day: "2-digit"
    });
};
function IntlDateTimeComment(param) {
    var value = param.value;
    // old format date: "Y-m-d H:m"
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(react_intl__WEBPACK_IMPORTED_MODULE_2__/* .FormattedDate */ .Ji, {
        value: value,
        year: "2-digit",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric"
    });
}


/***/ })

}]);